import "core-js/modules/esnext.promise.all-settled.js";
import "core-js/modules/es.object.from-entries.js";
import e, { useState as t, useEffect as n, useRef as a } from "react";
import r from "react-google-recaptcha";
import l from "axios";
import { TextField as o, FormControl as i, FormControlLabel as c, Checkbox as s, FormHelperText as d, InputLabel as m, Select as u, MenuItem as p, TextareaAutosize as f, RadioGroup as v, Radio as g, Grid as h, Typography as y, Stepper as C, Step as x, StepLabel as E, Button as b, CircularProgress as N, Tooltip as w, Card as k, Divider as S, Backdrop as F, CardContent as I, Accordion as T, AccordionSummary as D, AccordionDetails as P, List as L, ListItem as A, IconButton as O } from "@material-ui/core";
import { useField as M, Field as z, Formik as W, Form as B, useFormikContext as R } from "formik";
import * as _ from "yup";
import j from "lodash/at";
import V from "prop-types";
import U from "@material-ui/core/Grid";
import { MuiPickersUtilsProvider as H, DatePicker as q } from "@material-ui/pickers";
import $ from "@date-io/date-fns";
import K from "@mui/material/Rating";
import J from "@material-ui/core/TextField";
import { Loader as Y } from "@googlemaps/js-api-loader";
import G from "@material-ui/icons/Search";
import Z from "@material-ui/icons/Cancel";
import { KeyboardArrowUp as Q, KeyboardArrowRight as X } from "@material-ui/icons";
import { makeStyles as ee } from "@material-ui/core/styles";
import { ApolloClient as te, HttpLink as ne, InMemoryCache as ae, gql as re } from "@apollo/client";
import le from "@mui/material/CardActions";
import oe from "@mui/material/CardContent";
import ie from "@mui/material/Button";
import ce from "@mui/material/Typography";
import se from "@material-ui/icons/Straighten";
import de from "@mui/material/SvgIcon";
import me from "@material-ui/icons/InfoOutlined";
import ue from "@material-ui/core/Select";
import pe from "@material-ui/core/MenuItem";
import fe from "@material-ui/core/InputLabel";
import ve from "@material-ui/core/FormControl";
import ge from "@material-ui/icons/ArrowBack";
import he from "@material-ui/icons/ArrowDropDown";
import ye from "@material-ui/icons/Lock";
import Ce from "@material-ui/icons/CalendarToday";
import xe from "@material-ui/icons/RemoveCircleOutline";
import Ee from "@material-ui/icons/CheckCircle";
import be from "@material-ui/icons/AddCircleOutline";
import Ne from "@material-ui/icons/RadioButtonUnchecked";
import we from "@material-ui/icons/RadioButtonChecked";
import ke from "@material-ui/icons/Delete";
import { useStripe as Se, useElements as Fe, CardNumberElement as Ie, CardExpiryElement as Te, CardCvcElement as De, Elements as Pe } from "@stripe/react-stripe-js";
import { loadStripe as Le } from "@stripe/stripe-js/pure";
import Ae from "react-modal";
import Oe from "@material-ui/icons/Error";
import Me from "react-input-verification-code";

function ze(e, t) {
  var n = Object.keys(e);

  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, a);
  }

  return n;
}

function We(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? ze(Object(n), !0).forEach(function (t) {
      Ve(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ze(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }

  return e;
}

function Be() {
  Be = function Be() {
    return e;
  };

  var e = {},
      t = Object.prototype,
      n = t.hasOwnProperty,
      a = Object.defineProperty || function (e, t, n) {
    e[t] = n.value;
  },
      r = "function" == typeof Symbol ? Symbol : {},
      l = r.iterator || "@@iterator",
      o = r.asyncIterator || "@@asyncIterator",
      i = r.toStringTag || "@@toStringTag";

  function c(e, t, n) {
    return Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), e[t];
  }

  try {
    c({}, "");
  } catch (e) {
    c = function c(e, t, n) {
      return e[t] = n;
    };
  }

  function s(e, t, n, r) {
    var l = t && t.prototype instanceof u ? t : u,
        o = Object.create(l.prototype),
        i = new k(r || []);
    return a(o, "_invoke", {
      value: E(e, n, i)
    }), o;
  }

  function d(e, t, n) {
    try {
      return {
        type: "normal",
        arg: e.call(t, n)
      };
    } catch (e) {
      return {
        type: "throw",
        arg: e
      };
    }
  }

  e.wrap = s;
  var m = {};

  function u() {}

  function p() {}

  function f() {}

  var v = {};
  c(v, l, function () {
    return this;
  });
  var g = Object.getPrototypeOf,
      h = g && g(g(S([])));
  h && h !== t && n.call(h, l) && (v = h);
  var y = f.prototype = u.prototype = Object.create(v);

  function C(e) {
    ["next", "throw", "return"].forEach(function (t) {
      c(e, t, function (e) {
        return this._invoke(t, e);
      });
    });
  }

  function x(e, t) {
    function r(a, l, o, i) {
      var c = d(e[a], e, l);

      if ("throw" !== c.type) {
        var s = c.arg,
            m = s.value;
        return m && "object" == typeof m && n.call(m, "__await") ? t.resolve(m.__await).then(function (e) {
          r("next", e, o, i);
        }, function (e) {
          r("throw", e, o, i);
        }) : t.resolve(m).then(function (e) {
          s.value = e, o(s);
        }, function (e) {
          return r("throw", e, o, i);
        });
      }

      i(c.arg);
    }

    var l;
    a(this, "_invoke", {
      value: function value(e, n) {
        function a() {
          return new t(function (t, a) {
            r(e, n, t, a);
          });
        }

        return l = l ? l.then(a, a) : a();
      }
    });
  }

  function E(e, t, n) {
    var a = "suspendedStart";
    return function (r, l) {
      if ("executing" === a) throw new Error("Generator is already running");

      if ("completed" === a) {
        if ("throw" === r) throw l;
        return F();
      }

      for (n.method = r, n.arg = l;;) {
        var o = n.delegate;

        if (o) {
          var i = b(o, n);

          if (i) {
            if (i === m) continue;
            return i;
          }
        }

        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if ("suspendedStart" === a) throw a = "completed", n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        a = "executing";
        var c = d(e, t, n);

        if ("normal" === c.type) {
          if (a = n.done ? "completed" : "suspendedYield", c.arg === m) continue;
          return {
            value: c.arg,
            done: n.done
          };
        }

        "throw" === c.type && (a = "completed", n.method = "throw", n.arg = c.arg);
      }
    };
  }

  function b(e, t) {
    var n = t.method,
        a = e.iterator[n];
    if (void 0 === a) return t.delegate = null, "throw" === n && e.iterator.return && (t.method = "return", t.arg = void 0, b(e, t), "throw" === t.method) || "return" !== n && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + n + "' method")), m;
    var r = d(a, e.iterator, t.arg);
    if ("throw" === r.type) return t.method = "throw", t.arg = r.arg, t.delegate = null, m;
    var l = r.arg;
    return l ? l.done ? (t[e.resultName] = l.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, m) : l : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, m);
  }

  function N(e) {
    var t = {
      tryLoc: e[0]
    };
    1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
  }

  function w(e) {
    var t = e.completion || {};
    t.type = "normal", delete t.arg, e.completion = t;
  }

  function k(e) {
    this.tryEntries = [{
      tryLoc: "root"
    }], e.forEach(N, this), this.reset(!0);
  }

  function S(e) {
    if (e) {
      var t = e[l];
      if (t) return t.call(e);
      if ("function" == typeof e.next) return e;

      if (!isNaN(e.length)) {
        var a = -1,
            r = function t() {
          for (; ++a < e.length;) {
            if (n.call(e, a)) return t.value = e[a], t.done = !1, t;
          }

          return t.value = void 0, t.done = !0, t;
        };

        return r.next = r;
      }
    }

    return {
      next: F
    };
  }

  function F() {
    return {
      value: void 0,
      done: !0
    };
  }

  return p.prototype = f, a(y, "constructor", {
    value: f,
    configurable: !0
  }), a(f, "constructor", {
    value: p,
    configurable: !0
  }), p.displayName = c(f, i, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
    var t = "function" == typeof e && e.constructor;
    return !!t && (t === p || "GeneratorFunction" === (t.displayName || t.name));
  }, e.mark = function (e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, f) : (e.__proto__ = f, c(e, i, "GeneratorFunction")), e.prototype = Object.create(y), e;
  }, e.awrap = function (e) {
    return {
      __await: e
    };
  }, C(x.prototype), c(x.prototype, o, function () {
    return this;
  }), e.AsyncIterator = x, e.async = function (t, n, a, r, l) {
    void 0 === l && (l = Promise);
    var o = new x(s(t, n, a, r), l);
    return e.isGeneratorFunction(n) ? o : o.next().then(function (e) {
      return e.done ? e.value : o.next();
    });
  }, C(y), c(y, i, "Generator"), c(y, l, function () {
    return this;
  }), c(y, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (e) {
    var t = Object(e),
        n = [];

    for (var a in t) {
      n.push(a);
    }

    return n.reverse(), function e() {
      for (; n.length;) {
        var a = n.pop();
        if (a in t) return e.value = a, e.done = !1, e;
      }

      return e.done = !0, e;
    };
  }, e.values = S, k.prototype = {
    constructor: k,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(w), !e) for (var t in this) {
        "t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
      }
    },
    stop: function stop() {
      this.done = !0;
      var e = this.tryEntries[0].completion;
      if ("throw" === e.type) throw e.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var t = this;

      function a(n, a) {
        return o.type = "throw", o.arg = e, t.next = n, a && (t.method = "next", t.arg = void 0), !!a;
      }

      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var l = this.tryEntries[r],
            o = l.completion;
        if ("root" === l.tryLoc) return a("end");

        if (l.tryLoc <= this.prev) {
          var i = n.call(l, "catchLoc"),
              c = n.call(l, "finallyLoc");

          if (i && c) {
            if (this.prev < l.catchLoc) return a(l.catchLoc, !0);
            if (this.prev < l.finallyLoc) return a(l.finallyLoc);
          } else if (i) {
            if (this.prev < l.catchLoc) return a(l.catchLoc, !0);
          } else {
            if (!c) throw new Error("try statement without catch or finally");
            if (this.prev < l.finallyLoc) return a(l.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(e, t) {
      for (var a = this.tryEntries.length - 1; a >= 0; --a) {
        var r = this.tryEntries[a];

        if (r.tryLoc <= this.prev && n.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
          var l = r;
          break;
        }
      }

      l && ("break" === e || "continue" === e) && l.tryLoc <= t && t <= l.finallyLoc && (l = null);
      var o = l ? l.completion : {};
      return o.type = e, o.arg = t, l ? (this.method = "next", this.next = l.finallyLoc, m) : this.complete(o);
    },
    complete: function complete(e, t) {
      if ("throw" === e.type) throw e.arg;
      return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), m;
    },
    finish: function finish(e) {
      for (var t = this.tryEntries.length - 1; t >= 0; --t) {
        var n = this.tryEntries[t];
        if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), w(n), m;
      }
    },
    catch: function _catch(e) {
      for (var t = this.tryEntries.length - 1; t >= 0; --t) {
        var n = this.tryEntries[t];

        if (n.tryLoc === e) {
          var a = n.completion;

          if ("throw" === a.type) {
            var r = a.arg;
            w(n);
          }

          return r;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, t, n) {
      return this.delegate = {
        iterator: S(e),
        resultName: t,
        nextLoc: n
      }, "next" === this.method && (this.arg = void 0), m;
    }
  }, e;
}

function Re(e) {
  return Re = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Re(e);
}

function _e(e, t, n, a, r, l, o) {
  try {
    var i = e[l](o),
        c = i.value;
  } catch (e) {
    return void n(e);
  }

  i.done ? t(c) : Promise.resolve(c).then(a, r);
}

function je(e) {
  return function () {
    var t = this,
        n = arguments;
    return new Promise(function (a, r) {
      var l = e.apply(t, n);

      function o(e) {
        _e(l, a, r, o, i, "next", e);
      }

      function i(e) {
        _e(l, a, r, o, i, "throw", e);
      }

      o(void 0);
    });
  };
}

function Ve(e, t, n) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" != typeof e || null === e) return e;
      var n = e[Symbol.toPrimitive];

      if (void 0 !== n) {
        var a = n.call(e, t || "default");
        if ("object" != typeof a) return a;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }

      return ("string" === t ? String : Number)(e);
    }(e, "string");

    return "symbol" == typeof t ? t : String(t);
  }(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

function Ue() {
  return Ue = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var a in n) {
        Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      }
    }

    return e;
  }, Ue.apply(this, arguments);
}

function He(e, t) {
  if (null == e) return {};

  var n,
      a,
      r = function (e, t) {
    if (null == e) return {};
    var n,
        a,
        r = {},
        l = Object.keys(e);

    for (a = 0; a < l.length; a++) {
      n = l[a], t.indexOf(n) >= 0 || (r[n] = e[n]);
    }

    return r;
  }(e, t);

  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(e);

    for (a = 0; a < l.length; a++) {
      n = l[a], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
  }

  return r;
}

function qe(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}

function $e(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];

    if (null != n) {
      var a,
          r,
          l,
          o,
          i = [],
          c = !0,
          s = !1;

      try {
        if (l = (n = n.call(e)).next, 0 === t) {
          if (Object(n) !== n) return;
          c = !1;
        } else for (; !(c = (a = l.call(n)).done) && (i.push(a.value), i.length !== t); c = !0) {
          ;
        }
      } catch (e) {
        s = !0, r = e;
      } finally {
        try {
          if (!c && null != n.return && (o = n.return(), Object(o) !== o)) return;
        } finally {
          if (s) throw r;
        }
      }

      return i;
    }
  }(e, t) || Je(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function Ke(e) {
  return function (e) {
    if (Array.isArray(e)) return Ye(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || Je(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function Je(e, t) {
  if (e) {
    if ("string" == typeof e) return Ye(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Ye(e, t) : void 0;
  }
}

function Ye(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var n = 0, a = new Array(t); n < t; n++) {
    a[n] = e[n];
  }

  return a;
}

var Ge = ["errorText", "name", "label"];

function Ze(t) {
  t.errorText;
  var n = t.name,
      a = t.label,
      r = He(t, Ge),
      l = $e(M(t), 2),
      i = l[0],
      c = l[1];

  function s() {
    var e = $e(j(c, "touched", "error"), 2),
        t = e[0],
        n = e[1];
    if (t && n) return n;
  }

  return a ? e.createElement("div", {
    className: "ondeff-input-with-label"
  }, a && e.createElement("label", {
    htmlFor: n,
    dangerouslySetInnerHTML: {
      __html: a
    }
  }), e.createElement(o, Ue({
    type: "text",
    variant: "outlined",
    error: c.touched && c.error && !0,
    helperText: s(),
    placeholder: !0
  }, i, r))) : e.createElement(o, Ue({
    type: "text",
    error: c.touched && c.error && !0,
    helperText: s(),
    placeholder: !0
  }, i, r));
}

var Qe = ["label"];

function Xe(t) {
  var n = t.label,
      a = He(t, Qe),
      r = $e(M(t), 3),
      l = r[0],
      o = r[1],
      m = r[2].setValue;
  return e.createElement(i, a, e.createElement(c, {
    value: l.checked,
    checked: l.checked,
    control: e.createElement(s, Ue({}, l, {
      onChange: function onChange(e) {
        m(e.target.checked);
      }
    })),
    label: n
  }), function () {
    var t = $e(j(o, "touched", "error"), 2),
        n = t[0],
        a = t[1];
    if (n && a) return e.createElement(d, null, a);
  }());
}

var et = ["label", "data"];

function tt(t) {
  var n = t.label,
      a = t.data,
      r = He(t, et),
      l = $e(M(t), 2),
      o = l[0],
      c = l[1],
      s = o.value,
      f = $e(j(c, "touched", "error"), 2),
      v = f[0],
      g = f[1],
      h = v && g && !0;
  return e.createElement(i, Ue({}, r, {
    error: h
  }), e.createElement(m, null, n), e.createElement(u, Ue({}, o, {
    value: s || ""
  }), a.map(function (t, n) {
    return e.createElement(p, {
      key: n,
      value: t.value
    }, t.label);
  })), function () {
    if (h) return e.createElement(d, null, g);
  }());
}

function nt(a) {
  var r = $e(M(a), 3),
      l = r[0],
      o = r[1],
      i = r[2],
      c = o.touched,
      s = o.error,
      d = i.setValue,
      m = c && s && !0,
      u = l.value,
      p = $e(t(null), 2),
      f = p[0],
      v = p[1];
  return n(function () {
    if (u) {
      var e = new Date(u);
      v(e);
    }
  }, [u]), e.createElement(U, {
    container: !0
  }, e.createElement(H, {
    utils: $
  }, e.createElement(q, Ue({}, l, a, {
    value: f,
    onChange: function onChange(e) {
      if (e) {
        v(e);

        try {
          var t = e.toISOString();
          d(t);
        } catch (t) {
          d(e);
        }
      } else d(e);
    },
    error: m,
    invalidDateMessage: m && s,
    helperText: m && s,
    autoOk: !0,
    format: a.format
  }))));
}

tt.defaultProps = {
  data: []
}, tt.propTypes = {
  data: V.array.isRequired
};
var at = ["errorText"];

function rt(t) {
  t.errorText;
  var n = He(t, at),
      a = $e(M(t), 2),
      r = a[0];
  return a[1], e.createElement(z, Ue({
    onChange: function onChange(e) {
      console.log(r.name + " cambió..."), formik.handleChange(r.name);
    },
    type: "hidden"
  }, r, n));
}

var lt = ["errorText", "name", "label", "className"];

function ot(t) {
  t.errorText;
  var n = t.name,
      a = t.label;
  t.className;
  var r = He(t, lt),
      l = $e(M(t), 2),
      o = l[0],
      i = l[1];

  function c() {
    var e = $e(j(i, "touched", "error"), 2),
        t = e[0],
        n = e[1];
    if (t && n) return n;
  }

  return a ? e.createElement("div", {
    className: "ondeff-textarea-with-label"
  }, a && e.createElement("label", {
    htmlFor: n,
    dangerouslySetInnerHTML: {
      __html: a
    }
  }), e.createElement(f, Ue({
    type: "text",
    multiline: !0,
    maxRows: 8,
    minRows: 8,
    "aria-label": "maximum height",
    error: i.touched && i.error && !0,
    helperText: c()
  }, o, r))) : e.createElement(f, Ue({
    type: "text",
    multiline: !0,
    maxRows: 8,
    minRows: 8,
    "aria-label": "maximum height",
    error: i.touched && i.error && !0,
    helperText: c()
  }, o, r));
}

var it = ["label", "data"];

function ct(t) {
  var n;
  t.label;
  var a = t.data,
      r = He(t, it),
      l = $e(M(t), 3),
      o = l[0],
      s = l[1];
  return l[2].setValue, e.createElement(i, r, e.createElement(v, Ue({}, o, {
    "aria-labelledby": "demo-controlled-radio-buttons-group"
  }), a.map(function (t, n) {
    return e.createElement(c, {
      key: n,
      value: t.value,
      control: e.createElement(g, null),
      label: t.label
    });
  })), e.createElement("p", {
    className: "quotes-message"
  }, (null == o ? void 0 : o.value) && (null === (n = a.find(function (e) {
    return e.value === o.value;
  })) || void 0 === n ? void 0 : n.message)), function () {
    var t = $e(j(s, "touched", "error"), 2),
        n = t[0],
        a = t[1];
    if (n && a) return e.createElement(d, null, a);
  }());
}

var st = ["label", "data", "onChangeValue", "formValues"];

function dt(a) {
  var r = a.label;
  a.data;
  var l = a.onChangeValue,
      o = a.formValues,
      c = He(a, st),
      s = $e(M(a), 2),
      u = s[0],
      p = s[1],
      f = $e(t(0), 2),
      v = f[0],
      g = f[1],
      h = $e(j(p, "touched", "error"), 2),
      y = h[0],
      C = h[1],
      x = y && C && !0;
  return n(function () {
    null != o && o.rating && g(o.rating);
  }, []), e.createElement(i, Ue({}, c, {
    error: x
  }), e.createElement(m, {
    className: a.className
  }, r, " ", e.createElement("b", null, "*")), e.createElement(z, {
    type: "hidden",
    onChange: function onChange(e) {
      console.log(u.name + " cambió...");
    },
    name: u.name,
    value: v
  }), e.createElement(K, {
    name: u.name + "rtg",
    size: "large",
    value: v,
    onChange: function onChange(e, t) {
      console.log(t), g(t), l("rating", t);
    }
  }), function () {
    if (x) return e.createElement(d, null, C);
  }());
}

var mt,
    ut = ["errorText", "dependencies", "label", "name"];

function pt(t) {
  var n, a, r, l, o, i, c, s;
  t.errorText, t.dependencies;
  var d = t.label,
      m = t.name,
      u = He(t, ut),
      p = $e(M(t), 3),
      f = p[0],
      v = p[1],
      g = p[2];

  function h() {
    var e = $e(j(v, "touched", "error"), 2),
        t = e[0],
        n = e[1];
    if (t && n) return n;
  }

  var y = function y(e) {
    var t = "",
        n = e.target.value.replace(/[^0-9]/g, "");
    "1" === n[0] && (n = "");
    var a = n.substr(0, 3),
        r = n.substr(3, 3),
        l = n.substr(6, 4);
    0 === a.length ? t = "" : a.length < 3 ? t = "(" + a : 3 == a.length && r.length < 3 ? t = "(" + a + ") " + r : 3 == a.length && 3 == r.length && (t = "(" + a + ") " + r + "-" + l), g && g.setValue(t);
  };

  return d ? e.createElement("div", {
    className: "ondeff-input-with-label"
  }, d && e.createElement("label", {
    htmlFor: m,
    dangerouslySetInnerHTML: {
      __html: d
    }
  }), e.createElement(J, Ue({
    type: "tel",
    variant: "outlined",
    error: v.touched && v.error && !0,
    helperText: h(),
    placeholder: !0
  }, f, u, {
    onKeyUp: y,
    inputProps: {
      maxLength: null !== (o = f.value) && void 0 !== o && o.includes(" ") || null !== (i = f.value) && void 0 !== i && i.includes("(") || null !== (c = f.value) && void 0 !== c && c.includes(")") || null !== (s = f.value) && void 0 !== s && s.includes("-") ? 14 : 10
    }
  }))) : e.createElement(e.Fragment, null, e.createElement(J, Ue({
    type: "tel",
    error: v.touched && v.error && !0,
    helperText: h(),
    placeholder: !0
  }, f, u, {
    onKeyUp: y,
    inputProps: {
      maxLength: null !== (n = f.value) && void 0 !== n && n.includes(" ") || null !== (a = f.value) && void 0 !== a && a.includes("(") || null !== (r = f.value) && void 0 !== r && r.includes(")") || null !== (l = f.value) && void 0 !== l && l.includes("-") ? 14 : 10
    }
  })));
}

var ft = function ft(e) {
  return mt || (mt = new Y({
    apiKey: e,
    version: "weekly",
    libraries: ["places"]
  })), mt;
},
    vt = function vt(e) {
  var t = [],
      n = e.getPlace();
  return ["place_id", "address_components", "formatted_address"].map(function (e) {
    switch (e) {
      case "place_id":
        n.place_id && t.push(["place_id", n.place_id]);
        break;

      case "formatted_address":
        !function () {
          if (n.formatted_address) {
            var e = n.formatted_address.split(",");
            e.length > 0 && (t.push(["street", e[0]]), e.shift(), t.push(["street2", e.join().trim()]));
          }
        }();
        break;

      case "address_components":
        !function () {
          if (n.address_components) {
            var e = ["postal_code", "locality", "country", "administrative_area_level_1"],
                a = n.address_components;
            Object.keys(a).map(function (n) {
              var r = a[n].types[0],
                  l = a[n].long_name;
              e.map(function (e) {
                e === r && ("administrative_area_level_1" === r && (r = "state"), t.push([r, l]));
              });
            });
          }
        }();
    }
  }), t;
};

function gt(r) {
  var l,
      o,
      i = r.apiKey,
      c = r.defaultValue,
      s = r.name,
      d = r.placeholder,
      m = r.resetError,
      u = r.onChange,
      p = r.onResetField,
      f = r.onChangeValue,
      v = r.formValues,
      g = r.label,
      h = r.size,
      y = void 0 === h ? "medium" : h,
      C = r.showSearchIcon,
      x = void 0 !== C && C,
      E = r.className,
      b = r.id,
      N = ft(i),
      w = a(),
      k = a(),
      S = $e(t(Math.floor(9999 * Math.random())), 2),
      F = S[0],
      I = S[1],
      T = $e(t(function () {}), 2);
  T[0];

  var D = T[1],
      P = $e(t("google-place-autocomplete-input"), 2),
      L = P[0],
      A = P[1],
      O = $e(t(c || v && v.odf_street && v.odf_street + ", " + v.odf_street2), 2),
      M = O[0],
      z = O[1],
      W = function W() {
    m && m(), u && u(vt(l));
  };

  n(function () {
    "" !== f && function (e) {
      JSON.parse(e).map(function (e) {
        v["odf_" + e[0]] = e[1];
      });
    }(f);
  }, [f]);

  var B = function B() {
    "undefined" != typeof window && window.google.maps.event.removeListener(o), D(function () {});
    var e = w.current.value;
    I(Math.random()), w.current.value = e, m && m();
  };

  return n(function () {
    "undefined" != typeof window && (window.gm_authFailure = function () {
      console.log("Google Api Error"), A(s || "google-place-autocomplete-input"), B();
    }), m && m(), N.load().then(function (e) {
      l = new e.maps.places.Autocomplete(w.current, {
        types: ["address"],
        componentRestrictions: {
          country: ["US"]
        },
        fields: []
      }), o = l.addListener("place_changed", W);
    }).catch(function (e) {
      console.log(e);
    });
  }, [F]), e.createElement("div", {
    className: "".concat(E, " google-place-autocomplete")
  }, e.createElement(J, {
    id: b,
    disabled: !!r.disabled && r.disabled,
    defaultValue: M,
    className: E,
    variant: "outlined",
    size: y,
    inputRef: w,
    label: g,
    InputProps: {
      key: F,
      placeholder: d,
      name: L,
      startAdornment: x ? e.createElement(G, {
        color: "action"
      }) : null,
      endAdornment: r.disabled ? e.createElement(e.Fragment, null) : e.createElement(Z, {
        className: "google-place-autocomplete-clear",
        ref: k,
        onClick: function onClick(e) {
          e.preventDefault(), z(""), Object.keys(v).map(function (e) {
            e.startsWith("odf_") && (v[e] = "");
          }), p(), B();
        }
      })
    }
  }));
}

function ht(a) {
  var r = $e(t({
    id: "",
    show: !1
  }), 2),
      l = r[0],
      o = r[1];
  return n(function () {
    a.data.options && a.data.options.forEach(function (e, t) {
      e.options.find(function (e) {
        return e.value === a.formValues[a.data.name];
      }) && o({
        id: t,
        show: !0
      });
    });
  }, [a.formValues[a.data.name]]), a.data.options && a.data.options.map(function (t, n) {
    return e.createElement("div", {
      key: n
    }, e.createElement("h4", {
      onClick: function onClick(e) {
        return t = n, void (l.id === t ? o({
          id: t,
          show: !l.show
        }) : o({
          id: t,
          show: !0
        }));
        var t;
      },
      id: n
    }, e.createElement("span", null, t.label), l.id === n && l.show ? e.createElement(Q, {
      style: {
        color: "#999"
      }
    }) : e.createElement(X, {
      style: {
        color: "#999"
      }
    })), e.createElement("div", null, l.id === n && l.show && e.createElement(ct, {
      className: "ondeff-radios",
      name: a.data.name,
      label: a.data.label,
      data: t.options,
      fullWidth: a.fullWidth
    })));
  });
}

function yt(n) {
  var a = n.name,
      r = n.value,
      l = n.label,
      o = n.type,
      i = n.checked,
      c = n.onChange,
      s = $e(t(null), 2),
      d = (s[0], s[1]),
      m = function m(e) {
    if ("fancy-checkbox" === o) u();else {
      e.currentTarget, d(e.currentTarget), p(e);
    }
  },
      u = function u(e) {
    c(r, i ? "remove" : "add");
  },
      p = function p(e) {
    for (var t = document.getElementsByName(a), n = 2; n < t.length; n++) {
      t[n].parentElement.classList.remove("ondeff-fancy-stylized-checkbox-checked"), t[n].parentElement.classList.add("ondeff-fancy-stylized-checkbox");
    }

    e.currentTarget.classList.contains("checked") ? e.currentTarget.classList.remove("ondeff-fancy-stylized-checkbox-checked") : (e.currentTarget.classList.add("ondeff-fancy-stylized-checkbox-checked"), c(r, "add"));
  };

  return "fancy-checkbox" === o ? e.createElement("div", {
    className: i ? "ondeff-fancy-stylized-checkbox-checked" : "ondeff-fancy-stylized-checkbox",
    onClick: m,
    "data-status": i
  }, e.createElement("div", {
    className: "label"
  }, l)) : e.createElement("div", {
    className: i ? "ondeff-fancy-stylized-checkbox-checked" : "ondeff-fancy-stylized-checkbox",
    onClick: m
  }, e.createElement("input", {
    className: "input_" + a,
    type: "radio",
    name: a,
    value: r,
    checked: i
  }), e.createElement("div", {
    className: "label"
  }, l));
}

var Ct = ["name", "label", "options", "type", "formValues", "onChangeValue"];

function xt(a) {
  var r,
      l = a.name,
      o = a.label,
      c = a.options,
      s = a.type,
      m = a.formValues,
      u = a.onChangeValue,
      p = He(a, Ct),
      f = $e(t(""), 2),
      v = f[0],
      g = f[1],
      h = $e(M(a), 2),
      y = h[0],
      C = h[1],
      x = $e(j(C, "touched", "error"), 2),
      E = x[0],
      b = x[1],
      N = E && b && !0;
  n(function () {
    "radio-custom" === s && u(l, m[l] ? m[l] : "1"), m[l] && g(m[l]);
  }, []);

  var w = function w(e, t) {
    var n = "" === v ? [] : "fancy-checkbox" === s ? v.split(",") : v;

    switch (t) {
      case "add":
        if ("fancy-checkbox" === s) {
          n.push(e.toString());
          break;
        }

        n = [e.toString()];
        break;

      case "remove":
        if ("fancy-checkbox" === s) {
          var a = n.indexOf(e.toString());
          a > -1 && n.splice(a, 1);
          break;
        }

        n = [e.toString()];
    }

    "fancy-checkbox" === s ? (g(n.join(",")), u(l, n.join(","))) : (g(n), u(l, n[0]));
  };

  return e.createElement(i, Ue({}, p, {
    error: N
  }), e.createElement(z, {
    type: "hidden",
    name: y.name,
    value: v
  }), e.createElement("div", {
    id: "radioContainer",
    className: "ondeff-fancy-checkbox"
  }, o && e.createElement("label", {
    htmlFor: l,
    dangerouslySetInnerHTML: {
      __html: o
    }
  }), e.createElement("input", {
    className: "input_" + l,
    type: "hidden",
    name: l,
    value: v
  }), e.createElement("div", {
    className: "ondeff-fancy-checkbox-group"
  }, null == c ? void 0 : c.map(function (t, n) {
    return r = !1, "radio-custom" === s && parseInt(m[l]) == c.length - n - 1 && (r = !0), "fancy-checkbox" === s && v.includes(t.value) && (r = !0), e.createElement(yt, {
      name: l,
      value: t.value,
      type: s,
      label: t.label,
      onChange: w,
      checked: r
    });
  }))), function () {
    if (N) return e.createElement(d, null, b);
  }());
}

function Et(n) {
  var a = n.formField,
      r = n.handleChangeFields,
      l = n.formValues,
      o = n.googleApiKey,
      i = $e(t(""), 2),
      c = i[0],
      s = i[1];

  Date.prototype.addDays = function (e) {
    var t = new Date(this.valueOf());
    return t.setDate(t.getDate() + e), t;
  };

  var d = function d(e) {
    return e ? e.startsWith("+") || e.startsWith("-") ? new Date().addDays(parseInt(e)) : new Date(e) : new Date();
  };

  return e.createElement(e.Fragment, null, e.createElement(h, {
    container: !0,
    spacing: 3
  }, a.map(function (t) {
    if ("paragraph" === t.type) {
      var n,
          a,
          i,
          m,
          u,
          p,
          f,
          v = e.createElement(e.Fragment, null);

      if (null !== (n = t.preConditions) && void 0 !== n && n.name || null !== (a = t.preConditions) && void 0 !== a && a.value) {
        if (l && t.preConditions && l[t.preConditions.name] === t.preConditions.value) {
          var g, y, C, x, E;
          v = e.createElement(h, {
            key: t.name ? t.name : (1e4 * Math.random()).toFixed(0),
            item: !0,
            xs: null !== (g = t.gridCols) && void 0 !== g && g.xs ? t.gridCols.xs : 12,
            sm: null !== (y = t.gridCols) && void 0 !== y && y.sm ? t.gridCols.sm : 12,
            md: null !== (C = t.gridCols) && void 0 !== C && C.md ? t.gridCols.md : 12,
            lg: null !== (x = t.gridCols) && void 0 !== x && x.lg ? t.gridCols.lg : 12,
            xl: null !== (E = t.gridCols) && void 0 !== E && E.xl ? t.gridCols.xl : 12,
            className: t.className
          }, e.createElement("div", {
            className: "accept-terms-message" === t.className ? "accept-terms-message" : "ondeff-paragraph",
            dangerouslySetInnerHTML: {
              __html: t.value
            }
          }));
        }
      } else v = e.createElement(h, {
        key: t.name ? t.name : (1e4 * Math.random()).toFixed(0),
        item: !0,
        xs: null !== (i = t.gridCols) && void 0 !== i && i.xs ? t.gridCols.xs : 12,
        sm: null !== (m = t.gridCols) && void 0 !== m && m.sm ? t.gridCols.sm : 12,
        md: null !== (u = t.gridCols) && void 0 !== u && u.md ? t.gridCols.md : 12,
        lg: null !== (p = t.gridCols) && void 0 !== p && p.lg ? t.gridCols.lg : 12,
        xl: null !== (f = t.gridCols) && void 0 !== f && f.xl ? t.gridCols.xl : 12,
        className: t.className
      }, e.createElement("div", {
        className: "accept-terms-message" === t.className ? "accept-terms-message" : "ondeff-paragraph",
        dangerouslySetInnerHTML: {
          __html: t.value
        }
      }));

      return v;
    }

    if ("hidden" === t.type) {
      var b,
          N,
          w,
          k,
          S,
          F,
          I,
          T = e.createElement(e.Fragment, null);

      if (null !== (b = t.preConditions) && void 0 !== b && b.name || null !== (N = t.preConditions) && void 0 !== N && N.value) {
        if (l && t.preConditions && l[t.preConditions.name] === t.preConditions.value) {
          var D, P, L, A, O;
          T = e.createElement(h, {
            key: t.name,
            item: !0,
            xs: null !== (D = t.gridCols) && void 0 !== D && D.xs ? t.gridCols.xs : 12,
            sm: null !== (P = t.gridCols) && void 0 !== P && P.sm ? t.gridCols.sm : 12,
            md: null !== (L = t.gridCols) && void 0 !== L && L.md ? t.gridCols.md : 12,
            lg: null !== (A = t.gridCols) && void 0 !== A && A.lg ? t.gridCols.lg : 12,
            xl: null !== (O = t.gridCols) && void 0 !== O && O.xl ? t.gridCols.xl : 12,
            className: t.className
          }, e.createElement(rt, {
            name: t.name,
            label: t.label
          }));
        }
      } else T = e.createElement(h, {
        key: t.name,
        item: !0,
        xs: null !== (w = t.gridCols) && void 0 !== w && w.xs ? t.gridCols.xs : 12,
        sm: null !== (k = t.gridCols) && void 0 !== k && k.sm ? t.gridCols.sm : 12,
        md: null !== (S = t.gridCols) && void 0 !== S && S.md ? t.gridCols.md : 12,
        lg: null !== (F = t.gridCols) && void 0 !== F && F.lg ? t.gridCols.lg : 12,
        xl: null !== (I = t.gridCols) && void 0 !== I && I.xl ? t.gridCols.xl : 12,
        className: t.className
      }, e.createElement(rt, {
        name: t.name,
        label: t.label
      }));

      return T;
    }

    if ("mobile" === t.type) {
      var M,
          z,
          W,
          B,
          R,
          _,
          j,
          V = e.createElement(e.Fragment, null);

      if (null !== (M = t.preConditions) && void 0 !== M && M.name || null !== (z = t.preConditions) && void 0 !== z && z.value) {
        if (l && t.preConditions && l[t.preConditions.name] === t.preConditions.value) {
          var U, H, q, $, K;
          V = e.createElement(h, {
            key: t.name,
            item: !0,
            xs: null !== (U = t.gridCols) && void 0 !== U && U.xs ? t.gridCols.xs : 12,
            sm: null !== (H = t.gridCols) && void 0 !== H && H.sm ? t.gridCols.sm : 12,
            md: null !== (q = t.gridCols) && void 0 !== q && q.md ? t.gridCols.md : 12,
            lg: null !== ($ = t.gridCols) && void 0 !== $ && $.lg ? t.gridCols.lg : 12,
            xl: null !== (K = t.gridCols) && void 0 !== K && K.xl ? t.gridCols.xl : 12,
            className: t.className
          }, e.createElement(pt, {
            key: "key.name_1",
            className: "ondeff-text",
            name: t.name,
            label: t.label,
            placeholder: t.placeholder
          }));
        }
      } else V = e.createElement(h, {
        key: t.name,
        item: !0,
        xs: null !== (W = t.gridCols) && void 0 !== W && W.xs ? t.gridCols.xs : 12,
        sm: null !== (B = t.gridCols) && void 0 !== B && B.sm ? t.gridCols.sm : 12,
        md: null !== (R = t.gridCols) && void 0 !== R && R.md ? t.gridCols.md : 12,
        lg: null !== (_ = t.gridCols) && void 0 !== _ && _.lg ? t.gridCols.lg : 12,
        xl: null !== (j = t.gridCols) && void 0 !== j && j.xl ? t.gridCols.xl : 12,
        className: t.className
      }, e.createElement(pt, {
        key: "key.name_1",
        className: "ondeff-text",
        name: t.name,
        label: t.label,
        placeholder: t.placeholder
      }));

      return V;
    }

    if ("textarea" === t.type) {
      var J,
          Y,
          G,
          Z,
          Q,
          X,
          ee,
          te = e.createElement(e.Fragment, null);

      if (null !== (J = t.preConditions) && void 0 !== J && J.name || null !== (Y = t.preConditions) && void 0 !== Y && Y.value) {
        if (l && t.preConditions && l[t.preConditions.name] === t.preConditions.value) {
          var ne, ae, re, le, oe;
          te = e.createElement(h, {
            key: t.name,
            item: !0,
            xs: null !== (ne = t.gridCols) && void 0 !== ne && ne.xs ? t.gridCols.xs : 12,
            sm: null !== (ae = t.gridCols) && void 0 !== ae && ae.sm ? t.gridCols.sm : 12,
            md: null !== (re = t.gridCols) && void 0 !== re && re.md ? t.gridCols.md : 12,
            lg: null !== (le = t.gridCols) && void 0 !== le && le.lg ? t.gridCols.lg : 12,
            xl: null !== (oe = t.gridCols) && void 0 !== oe && oe.xl ? t.gridCols.xl : 12,
            className: t.className
          }, e.createElement(ot, {
            name: t.name,
            label: t.label,
            className: t.className
          }));
        }
      } else te = e.createElement(h, {
        key: t.name,
        item: !0,
        xs: null !== (G = t.gridCols) && void 0 !== G && G.xs ? t.gridCols.xs : 12,
        sm: null !== (Z = t.gridCols) && void 0 !== Z && Z.sm ? t.gridCols.sm : 12,
        md: null !== (Q = t.gridCols) && void 0 !== Q && Q.md ? t.gridCols.md : 12,
        lg: null !== (X = t.gridCols) && void 0 !== X && X.lg ? t.gridCols.lg : 12,
        xl: null !== (ee = t.gridCols) && void 0 !== ee && ee.xl ? t.gridCols.xl : 12,
        className: t.className
      }, e.createElement(ot, {
        name: t.name,
        label: t.label,
        className: t.className
      }));

      return te;
    }

    if ("text" === t.type) {
      var ie,
          ce,
          se,
          de,
          me,
          ue,
          pe,
          fe = e.createElement(e.Fragment, null);

      if (null !== (ie = t.preConditions) && void 0 !== ie && ie.name || null !== (ce = t.preConditions) && void 0 !== ce && ce.value) {
        if (l && t.preConditions && l[t.preConditions.name] === t.preConditions.value) {
          var ve, ge, he, ye, Ce;
          fe = e.createElement(h, {
            key: t.name,
            item: !0,
            xs: null !== (ve = t.gridCols) && void 0 !== ve && ve.xs ? t.gridCols.xs : 12,
            sm: null !== (ge = t.gridCols) && void 0 !== ge && ge.sm ? t.gridCols.sm : 12,
            md: null !== (he = t.gridCols) && void 0 !== he && he.md ? t.gridCols.md : 12,
            lg: null !== (ye = t.gridCols) && void 0 !== ye && ye.lg ? t.gridCols.lg : 12,
            xl: null !== (Ce = t.gridCols) && void 0 !== Ce && Ce.xl ? t.gridCols.xl : 12,
            className: t.className
          }, e.createElement(Ze, {
            className: "ondeff-text",
            name: t.name,
            label: t.label,
            fullWidth: !0,
            placeholder: t.placeholder
          }));
        }
      } else fe = e.createElement(h, {
        key: t.name,
        item: !0,
        xs: null !== (se = t.gridCols) && void 0 !== se && se.xs ? t.gridCols.xs : 12,
        sm: null !== (de = t.gridCols) && void 0 !== de && de.sm ? t.gridCols.sm : 12,
        md: null !== (me = t.gridCols) && void 0 !== me && me.md ? t.gridCols.md : 12,
        lg: null !== (ue = t.gridCols) && void 0 !== ue && ue.lg ? t.gridCols.lg : 12,
        xl: null !== (pe = t.gridCols) && void 0 !== pe && pe.xl ? t.gridCols.xl : 12,
        className: t.className
      }, e.createElement(Ze, {
        className: "ondeff-text",
        name: t.name,
        label: t.label,
        fullWidth: !0,
        placeholder: t.placeholder
      }));

      return fe;
    }

    if ("select" === t.type) {
      var xe,
          Ee,
          be,
          Ne,
          we,
          ke,
          Se,
          Fe = e.createElement(e.Fragment, null);

      if (null !== (xe = t.preConditions) && void 0 !== xe && xe.name || null !== (Ee = t.preConditions) && void 0 !== Ee && Ee.value) {
        if (l && t.preConditions && l[t.preConditions.name] === t.preConditions.value) {
          var Ie, Te, De, Pe, Le;
          Fe = e.createElement(h, {
            key: t.name,
            item: !0,
            xs: null !== (Ie = t.gridCols) && void 0 !== Ie && Ie.xs ? t.gridCols.xs : 12,
            sm: null !== (Te = t.gridCols) && void 0 !== Te && Te.sm ? t.gridCols.sm : 12,
            md: null !== (De = t.gridCols) && void 0 !== De && De.md ? t.gridCols.md : 12,
            lg: null !== (Pe = t.gridCols) && void 0 !== Pe && Pe.lg ? t.gridCols.lg : 12,
            xl: null !== (Le = t.gridCols) && void 0 !== Le && Le.xl ? t.gridCols.xl : 12,
            className: t.className
          }, e.createElement(tt, {
            className: "ondeff-select",
            name: t.name,
            label: t.label,
            data: t.options,
            fullWidth: !0
          }));
        }
      } else Fe = e.createElement(h, {
        key: t.name,
        item: !0,
        xs: null !== (be = t.gridCols) && void 0 !== be && be.xs ? t.gridCols.xs : 12,
        sm: null !== (Ne = t.gridCols) && void 0 !== Ne && Ne.sm ? t.gridCols.sm : 12,
        md: null !== (we = t.gridCols) && void 0 !== we && we.md ? t.gridCols.md : 12,
        lg: null !== (ke = t.gridCols) && void 0 !== ke && ke.lg ? t.gridCols.lg : 12,
        xl: null !== (Se = t.gridCols) && void 0 !== Se && Se.xl ? t.gridCols.xl : 12,
        className: t.className
      }, e.createElement(tt, {
        className: "ondeff-select",
        name: t.name,
        label: t.label,
        data: t.options,
        fullWidth: !0
      }));

      return Fe;
    }

    if ("radio" === t.type) {
      var Ae,
          Oe,
          Me,
          ze,
          We,
          Be,
          Re,
          _e = e.createElement(e.Fragment, null);

      if (null !== (Ae = t.preConditions) && void 0 !== Ae && Ae.name || null !== (Oe = t.preConditions) && void 0 !== Oe && Oe.value) {
        if (l && t.preConditions && l[t.preConditions.name] === t.preConditions.value) {
          var je, Ve, Ue, He, qe;
          _e = e.createElement(h, {
            key: t.name,
            item: !0,
            xs: null !== (je = t.gridCols) && void 0 !== je && je.xs ? t.gridCols.xs : 12,
            sm: null !== (Ve = t.gridCols) && void 0 !== Ve && Ve.sm ? t.gridCols.sm : 12,
            md: null !== (Ue = t.gridCols) && void 0 !== Ue && Ue.md ? t.gridCols.md : 12,
            lg: null !== (He = t.gridCols) && void 0 !== He && He.lg ? t.gridCols.lg : 12,
            xl: null !== (qe = t.gridCols) && void 0 !== qe && qe.xl ? t.gridCols.xl : 12,
            className: t.className
          }, e.createElement(ct, {
            className: "ondeff-radios",
            name: t.name,
            label: t.label,
            data: t.options,
            fullWidth: !0
          }));
        }
      } else _e = e.createElement(h, {
        key: t.name,
        item: !0,
        xs: null !== (Me = t.gridCols) && void 0 !== Me && Me.xs ? t.gridCols.xs : 12,
        sm: null !== (ze = t.gridCols) && void 0 !== ze && ze.sm ? t.gridCols.sm : 12,
        md: null !== (We = t.gridCols) && void 0 !== We && We.md ? t.gridCols.md : 12,
        lg: null !== (Be = t.gridCols) && void 0 !== Be && Be.lg ? t.gridCols.lg : 12,
        xl: null !== (Re = t.gridCols) && void 0 !== Re && Re.xl ? t.gridCols.xl : 12,
        className: t.className
      }, e.createElement(ct, {
        className: "ondeff-radios",
        name: t.name,
        label: t.label,
        data: t.options,
        fullWidth: !0
      }));

      return _e;
    }

    if ("funcy-radio" === t.type) {
      var $e,
          Ke,
          Je,
          Ye,
          Ge,
          Qe,
          et,
          at = e.createElement(e.Fragment, null);

      if (null !== ($e = t.preConditions) && void 0 !== $e && $e.name || null !== (Ke = t.preConditions) && void 0 !== Ke && Ke.value) {
        if (l && t.preConditions && l[t.preConditions.name] === t.preConditions.value) {
          var lt, it, st, mt, ut;
          at = e.createElement(h, {
            key: t.name,
            item: !0,
            xs: null !== (lt = t.gridCols) && void 0 !== lt && lt.xs ? t.gridCols.xs : 12,
            sm: null !== (it = t.gridCols) && void 0 !== it && it.sm ? t.gridCols.sm : 12,
            md: null !== (st = t.gridCols) && void 0 !== st && st.md ? t.gridCols.md : 12,
            lg: null !== (mt = t.gridCols) && void 0 !== mt && mt.lg ? t.gridCols.lg : 12,
            xl: null !== (ut = t.gridCols) && void 0 !== ut && ut.xl ? t.gridCols.xl : 12,
            className: t.className
          }, e.createElement(ht, {
            data: t,
            fullWidth: !0,
            formValues: l
          }));
        }
      } else at = e.createElement(h, {
        key: t.name,
        item: !0,
        xs: null !== (Je = t.gridCols) && void 0 !== Je && Je.xs ? t.gridCols.xs : 12,
        sm: null !== (Ye = t.gridCols) && void 0 !== Ye && Ye.sm ? t.gridCols.sm : 12,
        md: null !== (Ge = t.gridCols) && void 0 !== Ge && Ge.md ? t.gridCols.md : 12,
        lg: null !== (Qe = t.gridCols) && void 0 !== Qe && Qe.lg ? t.gridCols.lg : 12,
        xl: null !== (et = t.gridCols) && void 0 !== et && et.xl ? t.gridCols.xl : 12,
        className: t.className
      }, e.createElement(ht, {
        data: t,
        fullWidth: !0,
        formValues: l
      }));

      return at;
    }

    if ("checkbox" === t.type) {
      var ft,
          vt,
          yt,
          Ct,
          Et,
          bt,
          Nt,
          wt = e.createElement(e.Fragment, null);

      if (null !== (ft = t.preConditions) && void 0 !== ft && ft.name || null !== (vt = t.preConditions) && void 0 !== vt && vt.value) {
        if (l && t.preConditions && l[t.preConditions.name] === t.preConditions.value) {
          var kt, St, Ft, It, Tt;
          wt = e.createElement(h, {
            key: t.name,
            item: !0,
            xs: null !== (kt = t.gridCols) && void 0 !== kt && kt.xs ? t.gridCols.xs : 12,
            sm: null !== (St = t.gridCols) && void 0 !== St && St.sm ? t.gridCols.sm : 12,
            md: null !== (Ft = t.gridCols) && void 0 !== Ft && Ft.md ? t.gridCols.md : 12,
            lg: null !== (It = t.gridCols) && void 0 !== It && It.lg ? t.gridCols.lg : 12,
            xl: null !== (Tt = t.gridCols) && void 0 !== Tt && Tt.xl ? t.gridCols.xl : 12,
            className: t.className
          }, e.createElement(Xe, {
            className: "ondeff-checkbox",
            name: t.name,
            label: t.label
          }));
        }
      } else wt = e.createElement(h, {
        key: t.name,
        item: !0,
        xs: null !== (yt = t.gridCols) && void 0 !== yt && yt.xs ? t.gridCols.xs : 12,
        sm: null !== (Ct = t.gridCols) && void 0 !== Ct && Ct.sm ? t.gridCols.sm : 12,
        md: null !== (Et = t.gridCols) && void 0 !== Et && Et.md ? t.gridCols.md : 12,
        lg: null !== (bt = t.gridCols) && void 0 !== bt && bt.lg ? t.gridCols.lg : 12,
        xl: null !== (Nt = t.gridCols) && void 0 !== Nt && Nt.xl ? t.gridCols.xl : 12,
        className: t.className
      }, e.createElement(Xe, {
        className: "ondeff-checkbox",
        name: t.name,
        label: t.label
      }));

      return wt;
    }

    if ("rating" === t.type) {
      var Dt,
          Pt,
          Lt,
          At,
          Ot,
          Mt,
          zt,
          Wt = e.createElement(e.Fragment, null);

      if (null !== (Dt = t.preConditions) && void 0 !== Dt && Dt.name || null !== (Pt = t.preConditions) && void 0 !== Pt && Pt.value) {
        if (l && t.preConditions && l[t.preConditions.name] === t.preConditions.value) {
          var Bt, Rt, _t, jt, Vt;

          Wt = e.createElement(h, {
            key: t.name,
            item: !0,
            xs: null !== (Bt = t.gridCols) && void 0 !== Bt && Bt.xs ? t.gridCols.xs : 12,
            sm: null !== (Rt = t.gridCols) && void 0 !== Rt && Rt.sm ? t.gridCols.sm : 12,
            md: null !== (_t = t.gridCols) && void 0 !== _t && _t.md ? t.gridCols.md : 12,
            lg: null !== (jt = t.gridCols) && void 0 !== jt && jt.lg ? t.gridCols.lg : 12,
            xl: null !== (Vt = t.gridCols) && void 0 !== Vt && Vt.xl ? t.gridCols.xl : 12,
            className: t.className
          }, e.createElement(dt, {
            className: "ondeff-rating",
            name: t.name + "rto",
            label: t.label,
            onChangeValue: r,
            formValues: l
          }));
        }
      } else Wt = e.createElement(h, {
        key: t.name,
        item: !0,
        xs: null !== (Lt = t.gridCols) && void 0 !== Lt && Lt.xs ? t.gridCols.xs : 12,
        sm: null !== (At = t.gridCols) && void 0 !== At && At.sm ? t.gridCols.sm : 12,
        md: null !== (Ot = t.gridCols) && void 0 !== Ot && Ot.md ? t.gridCols.md : 12,
        lg: null !== (Mt = t.gridCols) && void 0 !== Mt && Mt.lg ? t.gridCols.lg : 12,
        xl: null !== (zt = t.gridCols) && void 0 !== zt && zt.xl ? t.gridCols.xl : 12,
        className: t.className
      }, e.createElement(dt, {
        className: t.className ? t.className : "ondeff-rating",
        name: t.name + "rto",
        label: t.label,
        onChangeValue: r,
        formValues: l
      }));

      return Wt;
    }

    if ("date" === t.type) {
      var Ut,
          Ht,
          qt,
          $t,
          Kt,
          Jt,
          Yt,
          Gt = e.createElement(e.Fragment, null);

      if (null !== (Ut = t.preConditions) && void 0 !== Ut && Ut.name || null !== (Ht = t.preConditions) && void 0 !== Ht && Ht.value) {
        if (l && t.preConditions && l[t.preConditions.name] === t.preConditions.value) {
          var Zt, Qt, Xt, en, tn;
          Gt = e.createElement(h, {
            key: t.name,
            item: !0,
            xs: null !== (Zt = t.gridCols) && void 0 !== Zt && Zt.xs ? t.gridCols.xs : 12,
            sm: null !== (Qt = t.gridCols) && void 0 !== Qt && Qt.sm ? t.gridCols.sm : 12,
            md: null !== (Xt = t.gridCols) && void 0 !== Xt && Xt.md ? t.gridCols.md : 12,
            lg: null !== (en = t.gridCols) && void 0 !== en && en.lg ? t.gridCols.lg : 12,
            xl: null !== (tn = t.gridCols) && void 0 !== tn && tn.xl ? t.gridCols.xl : 12,
            className: t.className
          }, e.createElement(nt, {
            key: "key.name_1",
            name: t.name,
            label: t.label,
            value: t.value,
            format: t.format,
            views: ["year", "month", "date"],
            minDate: d(t.minDate),
            maxDate: d(t.maxDate),
            fullWidth: !0,
            placeholder: t.placeholder
          }));
        }
      } else Gt = e.createElement(h, {
        key: t.name,
        item: !0,
        xs: null !== (qt = t.gridCols) && void 0 !== qt && qt.xs ? t.gridCols.xs : 12,
        sm: null !== ($t = t.gridCols) && void 0 !== $t && $t.sm ? t.gridCols.sm : 12,
        md: null !== (Kt = t.gridCols) && void 0 !== Kt && Kt.md ? t.gridCols.md : 12,
        lg: null !== (Jt = t.gridCols) && void 0 !== Jt && Jt.lg ? t.gridCols.lg : 12,
        xl: null !== (Yt = t.gridCols) && void 0 !== Yt && Yt.xl ? t.gridCols.xl : 12,
        className: t.className
      }, e.createElement(nt, {
        key: "key.name_1",
        name: t.name,
        label: t.label,
        value: t.value,
        format: t.format,
        views: ["year", "month", "date"],
        minDate: d(t.minDate),
        maxDate: d(t.maxDate),
        fullWidth: !0,
        placeholder: t.placeholder
      }));

      return Gt;
    }

    if ("google-address" === t.type) {
      var nn,
          an,
          rn,
          ln,
          on,
          cn,
          sn,
          dn = e.createElement(e.Fragment, null);

      if (null !== (nn = t.preConditions) && void 0 !== nn && nn.name || null !== (an = t.preConditions) && void 0 !== an && an.value) {
        if (l && t.preConditions && l[t.preConditions.name] === t.preConditions.value) {
          var mn, un, pn, fn, vn;
          dn = e.createElement(h, {
            key: t.name,
            item: !0,
            xs: null !== (mn = t.gridCols) && void 0 !== mn && mn.xs ? t.gridCols.xs : 12,
            sm: null !== (un = t.gridCols) && void 0 !== un && un.sm ? t.gridCols.sm : 12,
            md: null !== (pn = t.gridCols) && void 0 !== pn && pn.md ? t.gridCols.md : 12,
            lg: null !== (fn = t.gridCols) && void 0 !== fn && fn.lg ? t.gridCols.lg : 12,
            xl: null !== (vn = t.gridCols) && void 0 !== vn && vn.xl ? t.gridCols.xl : 12,
            className: t.className
          }, e.createElement(gt, {
            name: t.name,
            label: t.label,
            fieldName: t.name,
            placeholder: "enter an address",
            apiKey: o,
            resetError: function resetError() {},
            onResetField: function onResetField() {
              s("");
            },
            onChange: function onChange(e) {
              s(JSON.stringify(e));
            },
            onChangeValue: r,
            formValues: l,
            fullWidth: !0
          }));
        }
      } else dn = e.createElement(h, {
        key: t.name,
        item: !0,
        xs: null !== (rn = t.gridCols) && void 0 !== rn && rn.xs ? t.gridCols.xs : 12,
        sm: null !== (ln = t.gridCols) && void 0 !== ln && ln.sm ? t.gridCols.sm : 12,
        md: null !== (on = t.gridCols) && void 0 !== on && on.md ? t.gridCols.md : 12,
        lg: null !== (cn = t.gridCols) && void 0 !== cn && cn.lg ? t.gridCols.lg : 12,
        xl: null !== (sn = t.gridCols) && void 0 !== sn && sn.xl ? t.gridCols.xl : 12,
        className: t.className
      }, e.createElement(gt, {
        name: t.name,
        label: t.label,
        fieldName: t.name,
        placeholder: "enter an address",
        apiKey: o,
        resetError: function resetError() {},
        onResetField: function onResetField() {
          s("");
        },
        onChange: function onChange(e) {
          s(JSON.stringify(e));
        },
        onChangeValue: c,
        formValues: l,
        fullWidth: !0
      }));

      return dn;
    }

    if ("fancy-checkbox" === t.type || "radio-custom" === t.type) {
      var gn,
          hn,
          yn,
          Cn,
          xn,
          En,
          bn,
          Nn = e.createElement(e.Fragment, null);

      if (null !== (gn = t.preConditions) && void 0 !== gn && gn.name || null !== (hn = t.preConditions) && void 0 !== hn && hn.value) {
        if (l && t.preConditions && l[t.preConditions.name] === t.preConditions.value) {
          var wn, kn, Sn, Fn, In;
          Nn = e.createElement(h, {
            key: t.name,
            item: !0,
            xs: null !== (wn = t.gridCols) && void 0 !== wn && wn.xs ? t.gridCols.xs : 12,
            sm: null !== (kn = t.gridCols) && void 0 !== kn && kn.sm ? t.gridCols.sm : 12,
            md: null !== (Sn = t.gridCols) && void 0 !== Sn && Sn.md ? t.gridCols.md : 12,
            lg: null !== (Fn = t.gridCols) && void 0 !== Fn && Fn.lg ? t.gridCols.lg : 12,
            xl: null !== (In = t.gridCols) && void 0 !== In && In.xl ? t.gridCols.xl : 12,
            className: t.className
          }, e.createElement(xt, {
            type: t.type,
            name: t.name,
            label: t.label,
            options: t.options,
            formValues: l,
            onChangeValue: r
          }));
        }
      } else Nn = e.createElement(h, {
        key: t.name,
        item: !0,
        xs: null !== (yn = t.gridCols) && void 0 !== yn && yn.xs ? t.gridCols.xs : 12,
        sm: null !== (Cn = t.gridCols) && void 0 !== Cn && Cn.sm ? t.gridCols.sm : 12,
        md: null !== (xn = t.gridCols) && void 0 !== xn && xn.md ? t.gridCols.md : 12,
        lg: null !== (En = t.gridCols) && void 0 !== En && En.lg ? t.gridCols.lg : 12,
        xl: null !== (bn = t.gridCols) && void 0 !== bn && bn.xl ? t.gridCols.xl : 12,
        className: t.className
      }, e.createElement(xt, {
        type: t.type,
        name: t.name,
        label: t.label,
        options: t.options,
        formValues: l,
        onChangeValue: r
      }));

      return Nn;
    }
  })));
}

function bt(e, t, n, a) {
  function r(e, t) {
    return "notRequired" === e.validationType ? t = t.notRequired() : "defined" === e.validationType ? t = t.defined() : "required" === e.validationType ? t = t.required(e.message) : "typeError" === e.validationType ? t = t.typeError(e.message) : "nullable" === e.validationType ? t = t.nullable(1 === e.value) : "oneOf" === e.validationType && (t = t.nullable(e.value, e.message)), t;
  }

  e.map(function (e) {
    if (e.name && e.validations && (null == e.preConditions || null == e.preConditions.value) || e.name && e.validations && e.preConditions && null != a && e.preConditions.value == a[e.preConditions.name]) {
      var n = _.string();

      switch (e.yupType) {
        case "string":
          e.validations.map(function (e) {
            n = r(e, n), "min" === e.validationType ? n = n.min(e.value, e.message) : "max" === e.validationType ? n = n.max(e.value, e.message) : "email" === e.validationType ? n = n.email(e.message) : "url" === e.validationType ? n = n.url(e.value, e.message) : "matches" === e.validationType && (n = n.matches(new RegExp(e.regex), {
              message: e.message,
              excludeEmptyString: !0
            }));
          });
          break;

        case "number":
          n = _.number(), e.validations.map(function (e) {
            n = r(e, n), "positive" === e.validationType ? n = n.positive(e.message) : "negative" === e.validationType ? n = n.negative(e.message) : "integer" === e.validationType ? n = n.integer(e.message) : "min" === e.validationType ? n = n.min(e.value, e.message) : "max" === e.validationType && (n = n.max(e.value, e.message));
          });
          break;

        case "boolean":
          n = _.boolean(), e.validations.map(function (e) {
            n = r(e, n);
          });
          break;

        case "date":
          n = _.date(), e.validations.map(function (e) {
            n = r(e, n), "min" === e.validationType ? n = n.min(Date.parse(e.value), e.message) : "max" === e.validationType && (n = n.max(Date.parse(e.value), e.message));
          });
      }

      t[e.ondeffStepsCode][e.name] = n;
    }
  });
  var l = 0;
  return Object.keys(t).map(function (e) {
    n[l] = _.object().shape(t[e]), l++;
  }), n;
}

var Nt,
    wt = ee(function (e) {
  return {
    stepper: {
      padding: e.spacing(3, 0, 5)
    },
    buttons: {
      display: "flex",
      justifyContent: "flex-end"
    },
    button: {
      marginTop: e.spacing(3),
      marginLeft: e.spacing(1)
    },
    wrapper: {
      margin: e.spacing(1),
      position: "relative"
    },
    buttonProgress: {
      position: "absolute",
      top: "50%",
      left: "50%"
    }
  };
}),
    kt = [],
    St = {},
    Ft = [],
    It = {
  watchQuery: {
    fetchPolicy: "no-cache",
    errorPolicy: "ignore"
  },
  query: {
    fetchPolicy: "no-cache",
    errorPolicy: "all"
  }
};

function Tt(a) {
  var o = a.apikeycaptcha,
      i = a.requireCaptcha,
      c = a.showStepper,
      s = a.showSuccessfulMessageAfterSubmit,
      d = a.handleAfterSubmit,
      m = a.handleAfterErrorOnSubmit,
      u = a.apolloUrl,
      p = a.googlePlaceAutocompleteApiKey,
      f = a.initialData,
      v = a.onSubmitFunction,
      g = $e(t({}), 2),
      w = g[0],
      k = g[1],
      S = wt(),
      F = $e(t(null), 2),
      I = F[0],
      T = F[1],
      D = $e(t(0), 2),
      P = D[0],
      L = D[1],
      A = $e(t(0), 2),
      O = A[0],
      M = A[1],
      z = $e(t(), 2),
      _ = z[0],
      j = z[1],
      V = P === kt.length - 1,
      U = $e(t(null), 2);
  U[0];
  var H = U[1],
      q = $e(t(null), 2),
      $ = q[0],
      K = q[1],
      J = $e(t(null), 2),
      Y = J[0],
      G = J[1],
      Z = $e(t(i), 2),
      Q = Z[0],
      X = Z[1],
      ee = $e(t(o), 2),
      le = ee[0],
      oe = ee[1],
      ie = $e(t(p), 2),
      ce = ie[0],
      se = ie[1],
      de = {
    "Ocp-Apim-Subscription-Key": "30ca1663de42420bb4a9894d1898e91e"
  },
      me = new te({
    link: new ne({
      uri: u,
      headers: de
    }),
    cache: new ae(),
    defaultOptions: It
  });

  function ue() {
    return (ue = je(Be().mark(function e(t, n) {
      var a, r, o, i, c;
      return Be().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (n.setSubmitting(!1), e.prev = 1, v(), a = JSON.stringify(t, null, 2), !St.ondeff.action) {
                e.next = 12;
                break;
              }

              return o = {}, (null === (r = St.ondeff.headers) || void 0 === r ? void 0 : r.length) > 0 && St.ondeff.headers.forEach(function (e) {
                o[e.key] = e.value;
              }), i = {
                headers: o
              }, e.next = 10, l.post(St.ondeff.action, a, i).then(function (e) {
                var t;
                j(null === (t = St.ondeff) || void 0 === t ? void 0 : t.succesMessage), s && L(P + 1), d(a);
              }).catch(function (e) {
                var t = St.ondeff.failMessage.find(function (t) {
                  return +t.code === e.response.status;
                });
                if (t) j(t.message);else {
                  var n = St.ondeff.failMessage.find(function (e) {
                    return "default" === e.code;
                  });
                  j(n.message);
                }
                s && L(P + 1), m();
              });

            case 10:
              e.next = 13;
              break;

            case 12:
              d(a);

            case 13:
              e.next = 22;
              break;

            case 15:
              e.prev = 15, e.t0 = e.catch(1), console.log(e.t0), c = St.ondeff.failMessage.find(function (e) {
                return "default" === e.code;
              }), j(c.message), s && L(P + 1), m();

            case 22:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[1, 15]]);
    }))).apply(this, arguments);
  }

  function pe() {
    L(P - 1);
  }

  var fe = function fe(e) {
    T(e);
  },
      ve = {
    ondeffCode: a.formCode
  };

  0 === O && null != a.formCode && me.query({
    query: re(Nt || (Nt = qe(["query Query($ondeffCode: String) {\n        ondeffDefinition(ondeffCode: $ondeffCode) {\n          ondeff {\n            code\n            name\n            succesMessage\n            failMessage {\n              code\n              message\n            }\n            action\n            nextLabel\n            previousLabel\n            headers {\n              key\n              value\n            }\n            requireCaptcha\n            apikeycaptcha\n            googlePlaceAutocompleteApiKey\n          }\n          steps {\n            code\n            name\n            ondeffCode\n            previousLabel\n            nextLabel\n            weight\n          }\n          fields {\n            type\n            name\n            label\n            value\n            format\n            minDate\n            maxDate\n            options {\n              value\n              label\n              message\n              options {\n                value\n                label\n              }\n            }\n            preConditions {\n              value\n              name\n            }\n            validations {\n              validationType\n              value\n              message\n              regex\n            }\n            gridCols {\n                xs\n                sm\n                md\n                lg\n                xl\n            }\n            className\n            ondeffCode\n            ondeffStepsCode\n            weight\n            yupType\n            placeholder\n          }\n        }\n      }"]))),
    variables: ve
  }).then(function (e) {
    M(1);
    var t = e.data.ondeffDefinition.steps.sort(function (e, t) {
      return e.weight - t.weight;
    }),
        n = e.data.ondeffDefinition.fields.sort(function (e, t) {
      return e.weight - t.weight;
    }),
        r = 0,
        l = {};
    St = e.data.ondeffDefinition, console.log(St), kt = [], Ft = [], t.map(function (e) {
      e.stepNumber = r, kt.push(e.name), r++, l[e.code] = {};
    }), Ft = bt(n, l, Ft, a.values);
    var c = We({}, a.values);
    f && f.map(function (e) {
      c[e.key] = e.value;
    });
    var s = We(We({}, function (e) {
      var t = {};
      return null != e && e.map(function (e) {
        e.name && e.value && "paragraph" !== e.type && (t[e.name] = e.value);
      }), t;
    }(St.fields)), c);
    X(!1 === i || !0 === i ? i : e.data.ondeffDefinition.ondeff.requireCaptcha), oe(o || e.data.ondeffDefinition.ondeff.apikeycaptcha), se(p || e.data.ondeffDefinition.ondeff.googlePlaceAutocompleteApiKey), k(s), H(t), K(n), G(l);
  }), n(function () {
    H(null), K(null), G(null), M(0);
  }, [a.formCode]);

  var ge = function ge() {
    var e = R().values;
    return n(function () {
      $ && Y && e && (Object.keys(Y).map(function (e) {
        Y[e] = [];
      }), Ft = bt($, Y, [], e));
    }, [e]), null;
  },
      he = a.formTitle ? a.formTitle : St.ondeff && St.ondeff.name,
      ye = St.steps && St.steps,
      Ce = P === kt.length ? "" : ye && P && null !== ye[P].nextLabel && void 0 !== ye[P].nextLabel ? ye[P].nextLabel : St.ondeff && null !== St.ondeff.nextLabel && void 0 !== St.ondeff.nextLabel ? St.ondeff.nextLabel : V ? "Submit" : P === kt.length ? "" : "Next",
      xe = P === kt.length ? "" : ye && null !== ye[P].previousLabel ? ye[P].previousLabel : St.ondeff && null !== St.ondeff.previousLabel ? St.ondeff.previousLabel : P === kt.length ? "" : "Previous";

  return 1 === O && null != a.formCode ? e.createElement("div", {
    className: "ondeff-form"
  }, e.createElement(e.Fragment, null, e.createElement(y, {
    component: "h1",
    variant: "h4",
    align: "center"
  }, he), c && P !== kt.length && e.createElement(C, {
    activeStep: P,
    className: S.stepper
  }, kt.map(function (t) {
    return e.createElement(x, {
      key: t
    }, e.createElement(E, null, t));
  })), e.createElement(e.Fragment, null, P === kt.length && _ ? e.createElement(e.Fragment, null, e.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: _
    }
  })) : e.createElement(W, {
    initialValues: w,
    validationSchema: Ft[P],
    onSubmit: function onSubmit(e, t) {
      var n = We(We({}, e), w);
      console.log(n), V ? (console.log("validCaptcha?", I), !1 === Q || Q && null !== I ? function (e, t) {
        ue.apply(this, arguments);
      }(n, t) : (t.setTouched({}), t.setSubmitting(!1))) : (L(P + 1), t.setTouched({}), t.setSubmitting(!1));
    }
  }, function (t) {
    return e.createElement(B, {
      id: St.ondeff && "form-".concat(St.ondeff.code)
    }, function (t, n, a) {
      if (St.steps) {
        var r,
            l = St.steps.filter(function (e) {
          return e.stepNumber === t;
        });
        return r = St.fields.filter(function (e) {
          return e.ondeffStepsCode === l[0].code;
        }), e.createElement(Et, {
          key: "ondeff-step-" + l,
          formField: r,
          handleChangeFields: n,
          formValues: a,
          googleApiKey: ce
        });
      }
    }(P, t.setFieldValue, t.values), e.createElement(ge, null), V && Q && e.createElement(h, {
      key: "captcha-ondeff"
    }, e.createElement("div", {
      key: "captcha-ondeff-1"
    }, e.createElement("span", null, "Verification *"), e.createElement(r, {
      key: "captcha-ondeff-cpt",
      sitekey: le,
      onChange: fe
    }))), e.createElement("div", {
      className: "ondeff-actions-wrapper ".concat(S.buttons)
    }, 0 !== P && e.createElement(b, {
      onClick: pe,
      className: S.button
    }, xe && xe), e.createElement("div", {
      className: S.wrapper
    }, e.createElement(b, {
      disabled: t.isSubmitting,
      type: "submit",
      variant: "contained",
      color: "primary",
      className: S.button
    }, Ce && Ce), t.isSubmitting && e.createElement(N, {
      size: 24,
      className: S.buttonProgress
    }))));
  })))) : e.createElement(e.Fragment, null);
}

function Dt(t) {
  var n = t.price;
  return e.createElement(e.Fragment, null, e.createElement("div", {
    className: "priceContainer"
  }, e.createElement("span", {
    className: t.placeId ? "priceTextFirst" : "priceTextFirst priceTextGrey"
  }, "$"), e.createElement("span", {
    className: t.placeId ? "priceTextSecond" : "priceTextSecond priceTextGrey"
  }, n), !t.placeId && e.createElement("span", {
    className: "priceRef",
    onClick: function onClick() {
      var e = document.getElementById("online-booking-address");
      e && (window.scrollTo(0, 0), e.focus());
    }
  }, "Add address for price")));
}

function Pt(t) {
  var n = t.detail,
      a = t.detail.text1.split(". <br>");
  return n.text2 = a[1], n.text3 = a[0], e.createElement(e.Fragment, null, e.createElement("div", {
    className: "detailContainer"
  }, e.createElement(de, {
    sx: {
      color: "#546E7A",
      verticalAlign: "top"
    },
    className: "detailIcon"
  }, e.createElement("path", {
    d: n.iconSvg
  })), e.createElement("span", {
    className: "detailText"
  }, n.text3, 0 === (null == n ? void 0 : n.id) && e.createElement(w, {
    className: "tooltip",
    title: "Landfills weigh your debris and charge service pros by the ton. That cost is passed on to the customer."
  }, e.createElement(me, {
    className: "tooltip-icon",
    color: "action"
  })), e.createElement("br", null), n.text2)));
}

var Lt = function Lt() {
  alert("BOOK CLICKEDDDD!!!!");
};

function At(t) {
  var n,
      a,
      r,
      l,
      o,
      i = t.service ? t.service : auxService,
      c = t.callbackFunction ? t.callbackFunction : Lt,
      s = t.imageStaticEnv,
      d = t.finalData,
      m = t.placeId;
  return e.createElement(e.Fragment, null, e.createElement("div", {
    "data-testid": "service",
    className: "cardContainer"
  }, e.createElement(k, {
    className: "card"
  }, e.createElement(oe, null, e.createElement("div", {
    className: "title"
  }, i.title), e.createElement("div", {
    className: "subtitle"
  }, (r = "", l = null === (n = i.details[0]) || void 0 === n ? void 0 : n.text3, o = null === (a = i.details[1]) || void 0 === a ? void 0 : a.text3, l && o && (r = "".concat(o.replace("(s) included", ""), " / ").concat(l.replace("included", ""))), r)), e.createElement("div", {
    className: "imageContainer"
  }, e.createElement("img", {
    className: "image",
    src: s + i.image,
    alt: i.title
  })), e.createElement(Dt, {
    price: i.price,
    placeId: m
  }), e.createElement("div", {
    className: "subtitleContainer"
  }, e.createElement(se, {
    className: "iconColor"
  }), e.createElement(ce, {
    sx: {
      mb: 1
    },
    style: {
      fontSize: "18px",
      marginBottom: "0px"
    },
    color: "text.secondary"
  }, i.subtitle)), i.details.map(function (t) {
    return e.createElement(Pt, {
      key: t.id,
      detail: t
    });
  })), e.createElement(le, {
    className: "buttonContainer"
  }, e.createElement(ie, {
    disabled: !m,
    onClick: function onClick() {
      var e = [].concat(Ke(d), [{
        key: "service",
        value: i
      }]);
      c(e);
    },
    variant: "contained",
    className: "bookButton"
  }, "Book Now")))));
}

function Ot(n) {
  var a = n.cards,
      r = void 0 === a ? [] : a,
      l = n.finalData,
      o = n.onCardActionClick,
      i = void 0 === o ? function () {} : o,
      c = n.onSeeMoreClick,
      s = void 0 === c ? function () {} : c,
      d = n.showSeeMoreButton,
      m = void 0 !== d && d,
      u = n.imageStaticEnv;
  n.isLoadingServices;

  var p = n.placeId,
      f = $e(t(!1), 2),
      v = f[0],
      g = f[1],
      y = function () {
    var e = je(Be().mark(function e() {
      return Be().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, g(!0), e.next = 4, s();

            case 4:
              e.next = 9;
              break;

            case 6:
              throw e.prev = 6, e.t0 = e.catch(0), e.t0;

            case 9:
              return e.prev = 9, g(!1), e.finish(9);

            case 12:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 6, 9, 12]]);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }();

  return e.createElement(e.Fragment, null, e.createElement(h, {
    container: !0,
    direction: "row"
  }, r.map(function (t, n) {
    return e.createElement(e.Fragment, {
      key: "card-".concat(t.title, "-").concat(n)
    }, e.createElement(h, {
      xs: 12,
      sm: 12,
      md: 4,
      lg: 4,
      xl: 4,
      className: "gridContainer"
    }, e.createElement(At, {
      finalData: l,
      service: t,
      callbackFunction: i,
      imageStaticEnv: u,
      placeId: p
    })));
  })), e.createElement("br", null), e.createElement(h, {
    container: !0,
    direction: "row",
    justifyContent: "center",
    alignItems: "center"
  }, m && e.createElement(b, {
    className: "seeMoreButton",
    variant: "contained",
    disabled: v,
    onClick: y
  }, v ? e.createElement(N, {
    size: 24
  }) : "See More")));
}

Ot.propTypes = {
  cards: V.array.isRequired,
  onCardActionClick: V.func,
  onSeeMoreClick: V.func,
  showSeeMoreButton: V.bool,
  imageStaticEnv: V.string.isRequired
};
var Mt = l.create();
Mt.defaults.headers.common["Ocp-Apim-Subscription-Key"] = "30ca1663de42420bb4a9894d1898e91e";

var zt,
    Wt,
    Bt = function Bt(e, t, n) {
  var a = arguments;
  return je(Be().mark(function r() {
    var l, o, i, c;
    return Be().wrap(function (r) {
      for (;;) {
        switch (r.prev = r.next) {
          case 0:
            return l = a.length > 3 && void 0 !== a[3] ? a[3] : "", (o = {})["Ocp-Apim-Subscription-Key"] = "30ca1663de42420bb4a9894d1898e91e", r.prev = 3, i = l ? "/".concat(l) : "", r.next = 7, Mt.get("".concat(e, "/place-by-zip-and-name/").concat(t, "/").concat(n).concat(i), {
              headers: o
            });

          case 7:
            return c = r.sent, r.abrupt("return", c);

          case 11:
            throw r.prev = 11, r.t0 = r.catch(3), r.t0;

          case 14:
          case "end":
            return r.stop();
        }
      }
    }, r, null, [[3, 11]]);
  }))();
},
    Rt = {
  watchQuery: {
    fetchPolicy: "no-cache",
    errorPolicy: "ignore"
  },
  query: {
    fetchPolicy: "no-cache",
    errorPolicy: "all"
  }
},
    _t = {
  "Ocp-Apim-Subscription-Key": "30ca1663de42420bb4a9894d1898e91e"
},
    jt = function jt(e) {
  return new te({
    link: new ne({
      uri: e,
      headers: _t
    }),
    cache: new ae(),
    ssrMode: !0,
    defaultOptions: Rt
  });
},
    Vt = function Vt(e) {
  return e.filter(function (e) {
    return e.active && e.currentValue;
  }).reduce(function (e, t) {
    return e[t.id] = t.currentValue, e;
  }, {});
},
    Ut = {
  name: "servicesAPI",
  get: function get(e, t, n, a) {
    var r = arguments;
    return je(Be().mark(function l() {
      var o, i, c, s, d, m, u, p, f, v, g;
      return Be().wrap(function (l) {
        for (;;) {
          switch (l.prev = l.next) {
            case 0:
              return o = r.length > 4 && void 0 !== r[4] ? r[4] : 0, i = r.length > 5 && void 0 !== r[5] ? r[5] : 1e4, c = r.length > 6 ? r[6] : void 0, s = r.length > 7 ? r[7] : void 0, d = r.length > 8 ? r[8] : void 0, m = r.length > 9 ? r[9] : void 0, u = r.length > 10 ? r[10] : void 0, p = jt(e), f = {}, f = t && u ? {
                placesId: [t],
                placeIdName: u,
                idBaseService: n,
                street1: s,
                street2: d,
                wasteTypeLabel: m
              } : {
                idBaseService: n,
                street1: s,
                street2: d,
                wasteTypeLabel: m
              }, a && (f.proId = a), v = Vt(c), l.prev = 12, l.next = 15, p.query({
                query: re(zt || (zt = qe(["\n          query HtServices($idBaseService: String!, $wasteType: [Int], $dumpsterType: Int, $dumpsterSize: Int, $proId: Int, $placesId: [Int], $skip: Int, $limit: Int, $street1: String, $street2: String, $date: String, $wasteTypeLabel: String, $placeIdName: String){\n            htServices(idBaseService: $idBaseService, wasteType: $wasteType, dumpsterType: $dumpsterType, dumpsterSize: $dumpsterSize, proId: $proId, placesId: $placesId, skip: $skip, limit: $limit, street1: $street1, street2: $street2, date: $date, wasteTypeLabel: $wasteTypeLabel, placeIdName: $placeIdName) {\n              nodes {\n                _id\n                idBaseService\n                price\n                proId\n                description\n                areaId\n                dumpsterId\n                placesId {\n                  placeId\n                  distanceFee\n                }\n                dimensions\n                wasteType\n                dumpsterSize\n                dumpsterType\n                details {\n                  icon\n                  details\n                }\n                image\n                suggestedPros {\n                  _attributes_id\n                  n\n                  ur\n                }\n              }\n              pageInfo {\n                currentPage\n                hasNextPage\n                perPage\n                totalCount\n                hasPreviousPage\n                pageCount\n                itemCount\n              }\n            }\n          }\n        "]))),
                variables: We(We({}, f), {}, {
                  skip: o,
                  limit: i
                }, v)
              });

            case 15:
              return g = l.sent, l.abrupt("return", {
                data: {
                  data: g.data.htServices.nodes,
                  pageInfo: g.data.htServices.pageInfo
                }
              });

            case 19:
              throw l.prev = 19, l.t0 = l.catch(12), l.t0;

            case 22:
            case "end":
              return l.stop();
          }
        }
      }, l, null, [[12, 19]]);
    }))();
  },
  getServicePrice: function getServicePrice(e, t) {
    return je(Be().mark(function n() {
      var a;
      return Be().wrap(function (n) {
        for (;;) {
          switch (n.prev = n.next) {
            case 0:
              return n.prev = 0, n.next = 3, Mt.post("".concat(e, "/service-price"), t);

            case 3:
              return a = n.sent, n.abrupt("return", a);

            case 7:
              throw n.prev = 7, n.t0 = n.catch(0), n.t0;

            case 10:
            case "end":
              return n.stop();
          }
        }
      }, n, null, [[0, 7]]);
    }))();
  },
  getServiceById: function getServiceById(e, t, n) {
    return je(Be().mark(function a() {
      var r;
      return Be().wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return a.prev = 0, a.next = 3, Mt.get("".concat(e, "/pros/").concat(t, "/services/").concat(n));

            case 3:
              return r = a.sent, a.abrupt("return", r);

            case 7:
              throw a.prev = 7, a.t0 = a.catch(0), a.t0;

            case 10:
            case "end":
              return a.stop();
          }
        }
      }, a, null, [[0, 7]]);
    }))();
  },
  getProAreaSegment: function getProAreaSegment(e, t) {
    return je(Be().mark(function n() {
      var a;
      return Be().wrap(function (n) {
        for (;;) {
          switch (n.prev = n.next) {
            case 0:
              return n.prev = 0, n.next = 3, Mt.get("".concat(e, "/pros/").concat(t, "/default-area-segments"));

            case 3:
              return a = n.sent, n.abrupt("return", a);

            case 7:
              throw n.prev = 7, n.t0 = n.catch(0), n.t0;

            case 10:
            case "end":
              return n.stop();
          }
        }
      }, n, null, [[0, 7]]);
    }))();
  }
},
    Ht = function Ht(e, t, n) {
  return je(Be().mark(function a() {
    var r, l;
    return Be().wrap(function (a) {
      for (;;) {
        switch (a.prev = a.next) {
          case 0:
            return a.prev = 0, r = jt(e), a.next = 4, r.query({
              query: re(Wt || (Wt = qe(["\n          query HtAvailableFiltersPerPro($idBaseService: String, $proId: Int) {\n            htAvailableFiltersPerPro(idBaseService: $idBaseService, proId: $proId) {\n              filter {\n                _id\n                name\n                supportedValues {\n                  id\n                  value\n                  parentFilter\n                  parentValue\n                  code\n                }\n                type\n                exposed\n                defaultValue\n                label\n                weight\n                active\n              }\n            }\n          }\n        "]))),
              variables: {
                idBaseService: t,
                proId: n
              }
            });

          case 4:
            return l = a.sent, a.abrupt("return", {
              data: {
                data: l.data.htAvailableFiltersPerPro.filter
              }
            });

          case 8:
            throw a.prev = 8, a.t0 = a.catch(0), a.t0;

          case 11:
          case "end":
            return a.stop();
        }
      }
    }, a, null, [[0, 8]]);
  }))();
},
    qt = {
  name: "stripeAPI",
  createPaymentIntent: function createPaymentIntent(e, t, n, a, r, l) {
    return je(Be().mark(function o() {
      var i;
      return Be().wrap(function (o) {
        for (;;) {
          switch (o.prev = o.next) {
            case 0:
              return o.prev = 0, o.next = 3, Mt.post("".concat(e, "/create-payment"), {
                serviceId: t,
                proId: n,
                startDate: a,
                endDate: r,
                placeId: l
              });

            case 3:
              return i = o.sent, o.abrupt("return", i);

            case 7:
              throw o.prev = 7, o.t0 = o.catch(0), o.t0;

            case 10:
            case "end":
              return o.stop();
          }
        }
      }, o, null, [[0, 7]]);
    }))();
  },
  addPaymentMethodToPaymentIntent: function addPaymentMethodToPaymentIntent(e, t, n) {
    return je(Be().mark(function a() {
      var r;
      return Be().wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return a.prev = 0, a.next = 3, Mt.post("".concat(e, "/add-payment-method"), {
                methodId: t,
                intentId: n
              });

            case 3:
              return r = a.sent, a.abrupt("return", r);

            case 7:
              throw a.prev = 7, a.t0 = a.catch(0), a.t0;

            case 10:
            case "end":
              return a.stop();
          }
        }
      }, a, null, [[0, 7]]);
    }))();
  },
  attachPaymentMethodToCustomer: function attachPaymentMethodToCustomer(e, t, n) {
    return je(Be().mark(function a() {
      var r;
      return Be().wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return a.prev = 0, a.next = 3, Mt.post("".concat(e, "/attach-payment-method"), {
                methodId: t,
                customerId: n
              });

            case 3:
              return r = a.sent, a.abrupt("return", r);

            case 7:
              throw a.prev = 7, a.t0 = a.catch(0), a.t0;

            case 10:
            case "end":
              return a.stop();
          }
        }
      }, a, null, [[0, 7]]);
    }))();
  },
  addFullCheckout: function addFullCheckout(e, t) {
    return je(Be().mark(function n() {
      var a;
      return Be().wrap(function (n) {
        for (;;) {
          switch (n.prev = n.next) {
            case 0:
              return n.prev = 0, n.next = 3, Mt.post("".concat(e, "/full-checkout"), t);

            case 3:
              return a = n.sent, n.abrupt("return", a);

            case 7:
              throw n.prev = 7, n.t0 = n.catch(0), n.t0;

            case 10:
            case "end":
              return n.stop();
          }
        }
      }, n, null, [[0, 7]]);
    }))();
  },
  completeCheckout: function completeCheckout(e, t) {
    return je(Be().mark(function n() {
      var a;
      return Be().wrap(function (n) {
        for (;;) {
          switch (n.prev = n.next) {
            case 0:
              return n.prev = 0, n.next = 3, Mt.post("".concat(e, "/confirmed-payment-checkout"), t);

            case 3:
              return a = n.sent, n.abrupt("return", a);

            case 7:
              throw n.prev = 7, n.t0 = n.catch(0), n.t0;

            case 10:
            case "end":
              return n.stop();
          }
        }
      }, n, null, [[0, 7]]);
    }))();
  },
  deleteCard: function deleteCard(e, t) {
    return je(Be().mark(function n() {
      var a;
      return Be().wrap(function (n) {
        for (;;) {
          switch (n.prev = n.next) {
            case 0:
              return n.prev = 0, n.next = 3, Mt.post("".concat(e, "/dettach-payment-method"), t);

            case 3:
              return a = n.sent, n.abrupt("return", a);

            case 7:
              throw n.prev = 7, n.t0 = n.catch(0), n.t0;

            case 10:
            case "end":
              return n.stop();
          }
        }
      }, n, null, [[0, 7]]);
    }))();
  }
},
    $t = {
  name: "customersAPI",
  addCustomer: function addCustomer(e, t, n) {
    return je(Be().mark(function a() {
      var r, l, o, i, c;
      return Be().wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return r = n.customerEmail, l = n.customerName, o = n.customerSurname, i = n.customerPhone, a.prev = 1, a.next = 4, Mt.post("".concat(e, "/add-customer"), {
                intentId: t,
                customerEmail: r,
                customerName: l,
                customerSurname: o,
                customerPhone: i
              });

            case 4:
              return c = a.sent, a.abrupt("return", c);

            case 8:
              throw a.prev = 8, a.t0 = a.catch(1), a.t0;

            case 11:
            case "end":
              return a.stop();
          }
        }
      }, a, null, [[1, 8]]);
    }))();
  },
  getCustomerList: function getCustomerList(e, t) {
    return je(Be().mark(function n() {
      var a;
      return Be().wrap(function (n) {
        for (;;) {
          switch (n.prev = n.next) {
            case 0:
              return n.prev = 0, n.next = 3, Mt.post("".concat(e, "/list-customer-pms"), {
                customerId: t
              });

            case 3:
              return a = n.sent, n.abrupt("return", a);

            case 7:
              throw n.prev = 7, n.t0 = n.catch(0), n.t0;

            case 10:
            case "end":
              return n.stop();
          }
        }
      }, n, null, [[0, 7]]);
    }))();
  },
  checkCustomer: function checkCustomer(e, t) {
    return je(Be().mark(function n() {
      var a;
      return Be().wrap(function (n) {
        for (;;) {
          switch (n.prev = n.next) {
            case 0:
              return n.prev = 0, n.next = 3, Mt.post("".concat(e, "/check-customer"), {
                customerPhone: t
              });

            case 3:
              return a = n.sent, n.abrupt("return", a);

            case 7:
              throw n.prev = 7, n.t0 = n.catch(0), n.t0;

            case 10:
            case "end":
              return n.stop();
          }
        }
      }, n, null, [[0, 7]]);
    }))();
  },
  generateCode: function generateCode(e, t) {
    return je(Be().mark(function n() {
      var a;
      return Be().wrap(function (n) {
        for (;;) {
          switch (n.prev = n.next) {
            case 0:
              return n.prev = 0, n.next = 3, Mt.post("".concat(e, "/generate-code-customer"), t);

            case 3:
              return a = n.sent, n.abrupt("return", a);

            case 7:
              throw n.prev = 7, n.t0 = n.catch(0), n.t0;

            case 10:
            case "end":
              return n.stop();
          }
        }
      }, n, null, [[0, 7]]);
    }))();
  },
  validateCode: function validateCode(e, t) {
    return je(Be().mark(function n() {
      var a;
      return Be().wrap(function (n) {
        for (;;) {
          switch (n.prev = n.next) {
            case 0:
              return n.prev = 0, n.next = 3, Mt.post("".concat(e, "/validate-code-customer"), t);

            case 3:
              return a = n.sent, n.abrupt("return", a);

            case 7:
              throw n.prev = 7, n.t0 = n.catch(0), n.t0;

            case 10:
            case "end":
              return n.stop();
          }
        }
      }, n, null, [[0, 7]]);
    }))();
  }
},
    Kt = {
  name: "bookingRequestsAPI",
  getBookingById: function getBookingById(e, t) {
    return je(Be().mark(function n() {
      var a;
      return Be().wrap(function (n) {
        for (;;) {
          switch (n.prev = n.next) {
            case 0:
              return n.prev = 0, n.next = 3, Mt.get("".concat(e, "/job-request/").concat(t));

            case 3:
              return a = n.sent, n.abrupt("return", a);

            case 7:
              throw n.prev = 7, n.t0 = n.catch(0), n.t0;

            case 10:
            case "end":
              return n.stop();
          }
        }
      }, n, null, [[0, 7]]);
    }))();
  },
  getWasteTreatmentByPro: function getWasteTreatmentByPro(e, t, n) {
    return je(Be().mark(function a() {
      var r;
      return Be().wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return a.prev = 0, a.next = 3, Mt.get("".concat(e, "/pros/").concat(n, "/waste-treatment"), {
                headers: {
                  "X-Gatsby-Header": t
                }
              });

            case 3:
              return r = a.sent, a.abrupt("return", r);

            case 7:
              throw a.prev = 7, a.t0 = a.catch(0), a.t0;

            case 10:
            case "end":
              return a.stop();
          }
        }
      }, a, null, [[0, 7]]);
    }))();
  }
},
    Jt = {
  name: "dumpsterAPI",
  getSizes: function getSizes(e) {
    return je(Be().mark(function t() {
      var n;
      return Be().wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.prev = 0, t.next = 3, Mt.get("".concat(e, "/dumpster-sizes"));

            case 3:
              return n = t.sent, t.abrupt("return", n);

            case 7:
              throw t.prev = 7, t.t0 = t.catch(0), t.t0;

            case 10:
            case "end":
              return t.stop();
          }
        }
      }, t, null, [[0, 7]]);
    }))();
  },
  getTypes: function getTypes(e) {
    return je(Be().mark(function t() {
      var n;
      return Be().wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.prev = 0, t.next = 3, Mt.get("".concat(e, "/dumpster-types"));

            case 3:
              return n = t.sent, t.abrupt("return", n);

            case 7:
              throw t.prev = 7, t.t0 = t.catch(0), t.t0;

            case 10:
            case "end":
              return t.stop();
          }
        }
      }, t, null, [[0, 7]]);
    }))();
  },
  getWasteTypes: function getWasteTypes(e) {
    return je(Be().mark(function t() {
      var n;
      return Be().wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              return t.prev = 0, t.next = 3, Mt.get("".concat(e, "/waste-types"));

            case 3:
              return n = t.sent, t.abrupt("return", n);

            case 7:
              throw t.prev = 7, t.t0 = t.catch(0), t.t0;

            case 10:
            case "end":
              return t.stop();
          }
        }
      }, t, null, [[0, 7]]);
    }))();
  }
};

function Yt(n) {
  var a,
      r = n.filters,
      l = void 0 === r ? [] : r,
      o = n.onChange,
      i = void 0 === o ? function () {} : o,
      c = n.googlePlaceAutocompleteApiKey,
      s = n.onResetServices,
      d = void 0 === s ? function () {} : s,
      m = $e(t(""), 2),
      u = m[0];
  m[1];

  var p = function p(e, t, n) {
    var a;
    i(null === (a = e.target) || void 0 === a ? void 0 : a.value, t, n);
  },
      f = null == l || null === (a = l.filter(function (e) {
    return e.exposed;
  })) || void 0 === a ? void 0 : a.length;

  return e.createElement(e.Fragment, null, e.createElement(U, {
    container: !0,
    justifyContent: "flex-start",
    alignItems: "center",
    className: "ss-filters-wrapper",
    spacing: 2
  }, l.filter(function (e) {
    return e.exposed;
  }).map(function (t, n) {
    return e.createElement(e.Fragment, {
      key: "filter-".concat(n)
    }, "googleAddress" === t.type ? e.createElement(U, {
      xs: 12,
      sm: 12,
      md: 2 === f ? 6 : 4,
      lg: 2 === f ? 6 : 4,
      xl: 2 === f ? 6 : 4
    }, e.createElement("div", {
      "data-testid": "filter-input",
      className: "inputContainer marginBottom"
    }, e.createElement(gt, {
      id: "online-booking-address",
      apiKey: c,
      defaultValue: t.currentValue,
      name: t.name,
      label: t.label,
      className: "fill-available",
      fieldName: "c",
      placeholder: "Enter an address",
      resetError: function resetError() {},
      onResetField: function onResetField() {
        return d();
      },
      onChange: function onChange(e) {
        p(e, n, JSON.stringify(e));
      },
      onChangeValue: u,
      formValues: [],
      size: "small",
      fullWidth: !0,
      showSearchIcon: !0
    }))) : "select" === t.type ? e.createElement(U, {
      xs: 12,
      sm: 12,
      md: 2,
      lg: 2,
      xl: 2
    }, e.createElement("div", {
      className: "inputContainer marginBottom"
    }, e.createElement(ve, {
      variant: "outlined",
      size: "small",
      className: "filterInput"
    }, e.createElement(fe, {
      htmlFor: "outlined-age-native-simple"
    }, t.label), e.createElement(ue, {
      value: t.currentValue,
      onChange: function onChange(e) {
        p(e, n);
      },
      labelId: "demo-simple-select-outlined-label",
      id: "demo-simple-select-outlined",
      label: t.label,
      inputProps: {
        "data-testid": "filter-input"
      }
    }, e.createElement(pe, {
      value: ""
    }, e.createElement("em", null, "None")), t.options.map(function (t) {
      return e.createElement(pe, {
        key: "option-".concat(t.value),
        value: t.value
      }, e.createElement("em", null, t.label));
    }))))) : e.createElement(U, {
      xs: 12,
      sm: 12,
      md: 4,
      lg: 4,
      xl: 4
    }, e.createElement("div", {
      className: "inputContainer marginBottom"
    }, e.createElement(J, {
      onChange: function onChange(e) {
        p(e, n);
      },
      id: t.id,
      className: "form-online-control-date",
      value: t.currentValue,
      label: t.label,
      type: "date",
      variant: "outlined",
      size: "small",
      inputProps: {
        "data-testid": "filter-input",
        placeholder: "when",
        min: new Date().toISOString().split("T")[0]
      },
      InputLabelProps: {
        shrink: !0
      }
    }))));
  })));
}

Yt.propTypes = {
  filters: V.array.isRequired,
  onChange: V.func,
  googlePlaceAutocompleteApiKey: V.string.isRequired
};
var Gt = {
  select: "select",
  textfield: "textfield",
  date: "date",
  googleAddress: "googleAddress"
},
    Zt = 21;

function Qt(a) {
  var r = a.zipcode,
      l = a.proId,
      o = a.baseServiceId,
      i = a.initialValues,
      c = void 0 === i ? [] : i,
      s = a.googlePlaceAutocompleteApiKey,
      d = a.placesApiUrl,
      m = a.servicesApiUrl,
      u = a.imageStaticEnv,
      p = a.serviceCardCallback,
      f = $e(t(a.defaultServices ? Ke(a.defaultServices) : []), 2),
      v = f[0],
      g = f[1],
      C = $e(t(), 2),
      x = C[0],
      E = C[1],
      w = $e(t(), 2),
      k = w[0],
      I = w[1],
      T = $e(t(0), 2),
      D = T[0],
      P = T[1],
      L = $e(t({}), 2),
      A = L[0],
      O = L[1],
      M = $e(t(!a.defaultServices), 2),
      z = M[0],
      W = M[1],
      B = $e(t(!a.defaultFilters), 2),
      R = B[0],
      _ = B[1],
      j = $e(t(a.defaultFilters ? Ke(a.defaultFilters) : []), 2),
      V = j[0],
      U = j[1],
      H = $e(t(!1), 2),
      q = H[0],
      $ = H[1],
      K = $e(t([]), 2),
      J = K[0],
      Y = K[1],
      G = $e(t([]), 2),
      Z = G[0],
      Q = G[1],
      X = $e(t(a.defaultFilters), 2),
      ee = X[0],
      te = X[1],
      ne = $e(t(a.defaultServices), 2),
      ae = ne[0],
      re = ne[1],
      le = $e(t(""), 2),
      oe = le[0],
      ie = le[1],
      ce = function ce(e) {
    var t = e.find(function (e) {
      return "fullFormData" === e.key;
    }).value,
        n = Object.keys(t).map(function (e) {
      return [e, t[e]];
    }),
        a = [];
    return n.forEach(function (e) {
      if (e[0].includes("odf_")) {
        var t = e[0].replace("odf_", ""),
            n = e[1];
        a.push([t, n]);
      }
    }), e.find(function (e) {
      return "fullFormData" === e.key;
    }).value = JSON.stringify(a), e.push({
      key: "placeId",
      value: null
    }), e;
  },
      se = $e(t(ce(JSON.parse(JSON.stringify(c)))), 2),
      de = se[0],
      me = se[1];

  n(function () {
    (null == ee ? void 0 : ee.length) > 0 && (null == ae ? void 0 : ae.length) > 0 ? (te([]), re([])) : ue();
  }, [l, r, o, c]);

  var ue = function () {
    var e = je(Be().mark(function e() {
      var t, n, a, i, s, d, m, u, p, f, v, h, y;
      return Be().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (e.prev = 0, W(!0), _(!0), $(!1), !r) {
                e.next = 26;
                break;
              }

              if (!(n = null === (t = JSON.parse(JSON.stringify(c)).find(function (e) {
                return "fullFormData" === e.key;
              })) || void 0 === t || null === (t = t.value) || void 0 === t || null === (t = t.odf_locality) || void 0 === t ? void 0 : t.replace(/ /g, "-"))) {
                e.next = 24;
                break;
              }

              return e.next = 9, pe(r, n);

            case 9:
              return a = e.sent, E(+a.id), I(a.name), (i = ce(JSON.parse(JSON.stringify(c)))).find(function (e) {
                return "placeId" === e.key;
              }).value = a.id, me(i), s = JSON.parse(JSON.stringify(c)).map(function (e) {
                return {
                  active: !0,
                  id: e.key,
                  currentValue: e.value
                };
              }), e.next = 18, Promise.allSettled([fe(+a.id, o, l, D * Zt, Zt, s, a.name), ve(o, l)]);

            case 18:
              d = e.sent, m = d[1].value, U(ge(m.data, Ke(JSON.parse(JSON.stringify(c))))), u = d[0].value, g(xe(u.data, +a.id)), O(u.pageInfo);

            case 24:
              e.next = 37;
              break;

            case 26:
              return p = ce(JSON.parse(JSON.stringify(c))), me(p), f = JSON.parse(JSON.stringify(c)).map(function (e) {
                return {
                  active: !0,
                  id: e.key,
                  currentValue: e.value
                };
              }), e.next = 31, Promise.allSettled([fe(null, o, l, D * Zt, Zt, f, null), ve(o, l)]);

            case 31:
              v = e.sent, h = v[1].value, U(ge(h.data, Ke(JSON.parse(JSON.stringify(c))))), y = v[0].value, g(xe(y.data, null)), O(y.pageInfo);

            case 37:
              e.next = 42;
              break;

            case 39:
              throw e.prev = 39, e.t0 = e.catch(0), e.t0;

            case 42:
              return e.prev = 42, _(!1), W(!1), e.finish(42);

            case 46:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 39, 42, 46]]);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }(),
      pe = function () {
    var e = je(Be().mark(function e(t, n) {
      var a;
      return Be().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, e.next = 3, Bt(d, t, n);

            case 3:
              return a = e.sent, e.abrupt("return", a.data);

            case 7:
              throw e.prev = 7, e.t0 = e.catch(0), e.t0;

            case 10:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 7]]);
    }));
    return function (t, n) {
      return e.apply(this, arguments);
    };
  }(),
      fe = function () {
    var e = je(Be().mark(function e(t, n, a, r, l, o, i) {
      var s, d, u, p, f, v, g, h, y, C, x, E, b, N;
      return Be().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (e.prev = 0, u = [], p = "", f = "", v = "", 0 !== Z.length) {
                e.next = 10;
                break;
              }

              return e.next = 8, Jt.getWasteTypes(m.split("graphql")[0] + "api/v1");

            case 8:
              u = e.sent, Q(u.data);

            case 10:
              return (de || c).forEach(function (e) {
                if ("fullFormData" === e.key) {
                  if ("object" === Re(e.value)) {
                    var t, n;
                    p = null === (t = e.value) || void 0 === t ? void 0 : t.odf_street, f = null === (n = e.value) || void 0 === n ? void 0 : n.odf_street2;
                  } else {
                    var a = JSON.parse(e.value);
                    (p = a.find(function (e) {
                      return "street" === e[0];
                    })) && (p = p[1]), (f = a.find(function (e) {
                      return "street2" === e[0];
                    })) && (f = f[1]);
                  }
                } else if ("wasteType" === e.key) {
                  var r,
                      l,
                      o = Z.length > 0 ? Z : null === (r = u) || void 0 === r ? void 0 : r.data;
                  v = null === (l = o.find(function (t) {
                    return t.id === e.value;
                  })) || void 0 === l ? void 0 : l.value;
                }
              }), Y([]), localStorage.setItem("onlineBookingData", JSON.stringify({
                placeId: t,
                baseServiceId: n,
                skip: r,
                limit: l,
                initialValues: c,
                finalDataForBooking: de
              })), e.next = 16, Ut.get(m, t, n, a, r, l, o, p, f, v, i);

            case 16:
              if (g = e.sent, !((null === (s = g.data) || void 0 === s || null === (s = s.data) || void 0 === s ? void 0 : s.length) > 0 && null === (null === (d = g.data) || void 0 === d || null === (d = d.data[0]) || void 0 === d ? void 0 : d._id))) {
                e.next = 20;
                break;
              }

              return Y(null === (h = g.data.data.map(function (e) {
                return e.suggestedPros;
              })) || void 0 === h ? void 0 : h.slice(0, 5)), e.abrupt("return", {
                data: [],
                pageInfo: g.data.pageInfo
              });

            case 20:
              if (t) {
                e.next = 29;
                break;
              }

              if (y = oe) {
                e.next = 27;
                break;
              }

              return e.next = 25, Ut.getProAreaSegment(m.split("graphql")[0] + "api/v1", a);

            case 25:
              x = e.sent, null !== (C = x.data) && void 0 !== C && C.defaultArea && (ie(null === (E = x.data) || void 0 === E ? void 0 : E.defaultArea), y = null === (b = x.data) || void 0 === b ? void 0 : b.defaultArea);

            case 27:
              return N = g.data.data.filter(function (e) {
                return e.areaId === y;
              }), e.abrupt("return", {
                data: N,
                pageInfo: g.data.pageInfo
              });

            case 29:
              return e.abrupt("return", g.data);

            case 32:
              throw e.prev = 32, e.t0 = e.catch(0), $(!0), e.t0;

            case 36:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 32]]);
    }));
    return function (t, n, a, r, l, o, i) {
      return e.apply(this, arguments);
    };
  }(),
      ve = function () {
    var e = je(Be().mark(function e(t, n) {
      var a;
      return Be().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, e.next = 3, Ht(m, t, n);

            case 3:
              return a = e.sent, e.abrupt("return", a.data);

            case 7:
              throw e.prev = 7, e.t0 = e.catch(0), $(!0), e.t0;

            case 11:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 7]]);
    }));
    return function (t, n) {
      return e.apply(this, arguments);
    };
  }(),
      ge = function ge(e, t) {
    return ye(he(function (e) {
      return e.sort(function (e, t) {
        return e.weight - t.weight;
      });
    }(e)), t);
  },
      he = function he(e) {
    return e.map(function (e) {
      return Ce(e);
    });
  },
      ye = function ye(e, t) {
    return t.forEach(function (t) {
      var n = e.find(function (e) {
        return e.id === t.key;
      });
      n && (n.currentValue = t.value);
    }), e;
  },
      Ce = function Ce(e) {
    return {
      id: e.name,
      label: e.label,
      type: (n = e.type, Gt[n]),
      options: (t = e.supportedValues, t.map(function (e) {
        return {
          label: e.value,
          value: e.id,
          parentValue: e.parentValue
        };
      })),
      currentValue: "",
      exposed: e.exposed,
      active: e.active,
      weight: e.weight,
      dependency: e.supportedValues && e.supportedValues.length && e.supportedValues[0].parentFilter
    };
    var t, n;
  },
      xe = function xe(e, t) {
    return e.map(function (e) {
      return Ee(e, t);
    });
  },
      Ee = function Ee(e, t) {
    var n,
        a = null === (n = e.placesId) || void 0 === n || null === (n = n.find(function (e) {
      return e.placeId === t;
    })) || void 0 === n ? void 0 : n.distanceFee;
    return {
      id: e._id,
      title: e.description,
      subtitle: e.dimensions,
      imagePath: "",
      price: a ? (e.price + +a).toFixed(2) : e.price.toFixed(2),
      image: e.image,
      details: e.details.map(function (e, t) {
        return {
          id: t,
          text1: e.details,
          iconSvg: e.icon
        };
      })
    };
  },
      be = function () {
    var e = je(Be().mark(function e(t, n, a) {
      var r, i, s, d, m, u, p, f, v, h;
      return Be().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (!a) {
                e.next = 31;
                break;
              }

              return s = JSON.parse(a).filter(function (e) {
                return "postal_code" == e[0];
              }), d = JSON.parse(a).filter(function (e) {
                return "locality" == e[0];
              }), (null === (r = d) || void 0 === r ? void 0 : r.length) > 0 && (d = null === (i = d[0][1]) || void 0 === i ? void 0 : i.replace(/ /g, "-")), e.prev = 4, W(!0), e.next = 8, pe(s[0][1], d);

            case 8:
              return m = e.sent, E(+m.id), I(m.name), P(0), (u = de).find(function (e) {
                return "fullFormData" === e.key;
              }).value = a, u.find(function (e) {
                return "placeId" === e.key;
              }).value = m.id, me(u), e.next = 18, fe(+m.id, o, l, 0, Zt, V, m.name);

            case 18:
              p = e.sent, g(xe(p.data, +m.id)), O(p.pageInfo), e.next = 26;
              break;

            case 23:
              throw e.prev = 23, e.t0 = e.catch(4), e.t0;

            case 26:
              return e.prev = 26, W(!1), e.finish(26);

            case 29:
              e.next = 47;
              break;

            case 31:
              if (f = de, t.length > 2 ? f.find(function (e) {
                return "date" === e.key;
              }).value = t : f.find(function (e) {
                return "wasteType" === e.key;
              }).value = t, me(f), localStorage.setItem("onlineBookingData", JSON.stringify({
                placeId: x,
                baseServiceId: o,
                skip: 0,
                limit: Zt,
                initialValues: c,
                finalDataForBooking: f
              })), (v = V)[n].currentValue = t, U(Ke(v)), !v[n].active) {
                e.next = 47;
                break;
              }

              return W(!0), P(0), e.next = 43, fe(x, o, l, 0, Zt, v, k);

            case 43:
              h = e.sent, g(xe(h.data, x)), O(h.pageInfo), W(!1);

            case 47:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[4, 23, 26, 29]]);
    }));
    return function (t, n, a) {
      return e.apply(this, arguments);
    };
  }(),
      Ne = function () {
    var e = je(Be().mark(function e() {
      var t, n, a;
      return Be().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (!de) {
                e.next = 13;
                break;
              }

              return (t = de).find(function (e) {
                return "placeId" === e.key;
              }).value = null, t.find(function (e) {
                return "fullFormData" === e.key;
              }).value = "[]", me(t), n = JSON.parse(JSON.stringify(t)).map(function (e) {
                return {
                  active: !0,
                  id: e.key,
                  currentValue: e.value
                };
              }), e.next = 8, fe(null, o, l, D * Zt, Zt, n, null);

            case 8:
              a = e.sent, g(xe(a.data, null)), O(a.pageInfo), E(null), I(null);

            case 13:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }(),
      we = function () {
    var e = je(Be().mark(function e() {
      var t, n;
      return Be().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, e.next = 3, Ut.get(m, x, o, l, (D + 1) * Zt, Zt, V);

            case 3:
              t = e.sent, O(t.data.pageInfo), P(D + 1), n = t.data.data, g([].concat(Ke(v), Ke(xe(n))), x), e.next = 13;
              break;

            case 10:
              throw e.prev = 10, e.t0 = e.catch(0), e.t0;

            case 13:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 10]]);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }();

  return e.createElement(e.Fragment, null, e.createElement(h, {
    container: !0,
    direction: "column",
    justifyContent: "flex-start",
    alignItems: z || R || q ? "center" : "flex-start"
  }, R ? e.createElement(N, {
    size: 24
  }) : q ? e.createElement(e.Fragment, null, e.createElement(y, {
    className: "notFound"
  }, "An error ocurred while loading services"), e.createElement("br", null), e.createElement(b, {
    variant: "contained",
    className: "tryAgainButton",
    onClick: ue
  }, "Try Again")) : e.createElement(e.Fragment, null, e.createElement("div", {
    className: "filtersContainer"
  }, e.createElement(y, {
    variant: "h2",
    className: "filterTitle"
  }, "Add your address & waste type for pricing"), e.createElement(Yt, {
    filters: V,
    onChange: be,
    onResetServices: Ne,
    googlePlaceAutocompleteApiKey: s
  })), e.createElement(S, {
    className: "divider"
  }), e.createElement("br", null), z && e.createElement(F, {
    style: {
      zIndex: 11
    },
    className: "backdrop",
    open: !0
  }, e.createElement(N, {
    className: "white-loader"
  })), v.length ? e.createElement(e.Fragment, null, e.createElement(Ot, {
    cards: v,
    placeId: x,
    showSeeMoreButton: A.hasNextPage,
    onCardActionClick: p,
    onSeeMoreClick: we,
    imageStaticEnv: u,
    isLoadingServices: z,
    finalData: de
  })) : e.createElement(e.Fragment, null, e.createElement(y, {
    className: "suggestedTitle suggestedAlign"
  }, "No matching services were found for this pro."), (null == J ? void 0 : J.length) > 0 && e.createElement("div", {
    className: "suggestedContainer"
  }, e.createElement(y, {
    className: "suggestedTitle"
  }, "Here is a list of pros that match with your search:"), e.createElement("div", {
    className: "prosContainer"
  }, J.map(function (t, n) {
    return e.createElement("a", {
      key: n,
      className: "prosClas",
      href: "/".concat(t.ur)
    }, t.n);
  })))))));
}

function Xt(e, t) {
  var n = [];

  function a(e, t) {
    return "notRequired" === e.validationType ? t = t.notRequired() : "defined" === e.validationType ? t = t.defined() : "required" === e.validationType ? t = t.required(e.message) : "typeError" === e.validationType ? t = t.typeError(e.message) : "nullable" === e.validationType ? t = t.nullable(1 === e.value) : "oneOf" === e.validationType && (t = t.nullable(e.value, e.message)), t;
  }

  return e.map(function (e) {
    if (e.name && e.validations) {
      var r = _.string();

      switch (e.yupType) {
        case "string":
          (!e.preConditions || e.preConditions && t[e.preConditions.name] === e.preConditions.value) && e.validations.map(function (e) {
            r = a(e, r), "min" === e.validationType ? r = r.min(e.value, e.message) : "max" === e.validationType ? r = r.max(e.value, e.message) : "email" === e.validationType ? r = r.email(e.message) : "url" === e.validationType ? r = r.url(e.value, e.message) : "matches" === e.validationType && (r = r.matches(new RegExp(e.value), {
              message: e.message,
              excludeEmptyString: !0
            }));
          });
          break;

        case "number":
          (!e.preConditions || e.preConditions && t[e.preConditions.name] === e.preConditions.value) && (r = _.number(), e.validations.map(function (e) {
            r = a(e, r), "positive" === e.validationType ? r = r.positive(e.message) : "negative" === e.validationType ? r = r.negative(e.message) : "integer" === e.validationType ? r = r.integer(e.message) : "min" === e.validationType ? r = r.min(e.value, e.message) : "max" === e.validationType && (r = r.max(e.value, e.message));
          }));
          break;

        case "boolean":
          (!e.preConditions || e.preConditions && t[e.preConditions.name] === e.preConditions.value) && (r = _.boolean(), e.validations.map(function (e) {
            r = a(e, r);
          }));
          break;

        case "date":
          (!e.preConditions || e.preConditions && t[e.preConditions.name] === e.preConditions.value) && (r = _.date(), e.validations.map(function (e) {
            r = a(e, r), "min" === e.validationType ? r = r.min(Date.parse(e.value), e.message) : "max" === e.validationType && (r = r.max(Date.parse(e.value), e.message));
          }));
      }

      n[e.name] = r;
    }
  }), _.object().shape(n);
}

Qt.propTypes = {
  zipcode: V.oneOfType([V.number, V.string]).isRequired,
  proId: V.oneOfType([V.number, V.string]),
  baseServiceId: V.string.isRequired,
  initialValues: V.array,
  googlePlaceAutocompleteApiKey: V.string.isRequired,
  placesApiUrl: V.string.isRequired,
  servicesApiUrl: V.string.isRequired,
  imageStaticEnv: V.string.isRequired
};
var en = ee(function (e) {
  return {
    stepper: {
      padding: e.spacing(3, 0, 5)
    },
    buttons: {
      display: "flex",
      justifyContent: "flex-end"
    },
    button: {
      marginTop: e.spacing(3),
      marginLeft: e.spacing(1)
    },
    wrapper: {
      margin: e.spacing(1),
      position: "relative"
    },
    buttonProgress: {
      position: "absolute",
      top: "50%",
      left: "50%"
    },
    flexcontainer: {
      display: "flex"
    },
    flexcontainer2: {
      display: "flex",
      flexDirection: "column"
    },
    justifyspacebetween: {
      justifyContent: "space-between",
      alignItems: "center"
    },
    topContainer: {
      width: "85%",
      display: "flex",
      alignItems: "center",
      gap: "15px"
    },
    topContainer2: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      gap: "15px",
      justifyContent: "space-around"
    },
    image: {
      maxWidth: "150px",
      maxHeight: "80px"
    },
    imageConfirmation: {
      maxWidth: "300px",
      maxHeight: "160px",
      marginTop: "20px",
      marginBottom: "20px"
    },
    price: {
      width: "15%",
      fontSize: "1.4rem",
      lineHeight: "2rem"
    },
    boldFont: {
      fontWeight: "600",
      fontSize: "1.7rem",
      lineHeight: "2rem"
    },
    boldFontConfirmation: {
      fontWeight: "600",
      fontSize: "2.8rem",
      lineHeight: "2rem",
      marginBottom: "5px",
      padding: "5px 0 5px 0"
    },
    linkColor: {
      color: "#f58220",
      "&:hover": {
        color: "#f58220",
        textDecoration: "none"
      }
    },
    proLink: {
      color: "#212529",
      textDecoration: "none",
      "&:hover": {
        color: "#212529",
        textDecoration: "underline"
      }
    },
    cursorPointer: {
      cursor: "pointer"
    },
    marginY: {
      margin: "10px 0px"
    },
    divider: {
      margin: "10px 0px 10px 0px"
    },
    dividerConfirmation: {
      margin: "20px 0px 20px 0px",
      backgroundColor: "#aeaeae !important",
      height: "2px !important"
    },
    marginYBig: {
      margin: "30px 0px",
      "& div": {
        "& div": {
          minWidth: "75%",
          "@media (max-width: 768px)": {
            minWidth: "100%"
          }
        }
      }
    },
    itemContainer: {
      "@media (max-width: 550px)": {
        maxWidth: "100%",
        flexBasis: "100%"
      }
    },
    dateContainer: {
      marginTop: "10px",
      "@media (max-width: 768px)": {
        flexDirection: "column",
        gap: "10px"
      }
    },
    marginRight: {
      marginRight: "20px"
    },
    mobileHelperText: {
      color: "#e76b6b",
      fontSize: "1.2rem",
      margin: "0px"
    },
    marginRightSmall: {
      marginRight: "10px"
    },
    marginTopBig: {
      marginTop: "30px"
    },
    marginTopDescription: {
      marginTop: "50px"
    },
    styledAccordion: {
      boxShadow: "none",
      position: "initial",
      minHeight: "fit-content",
      "& .MuiAccordionSummary-root": {
        flexDirection: "row-reverse",
        minHeight: "fit-content",
        padding: "0px",
        "& .MuiAccordionSummary-content": {
          margin: "5px 20px"
        },
        "& .MuiIconButton-root": {
          padding: "0px"
        }
      }
    },
    fullWidth: {
      width: "100%"
    },
    itemsList: {
      minWidth: "250px"
    },
    detailContainer: {
      width: "100%",
      "@media (min-width: 992px)": {
        maxWidth: "66.666667%"
      }
    },
    pricingContainer: {
      width: "100%",
      "@media (min-width: 992px)": {
        maxWidth: "33.333333%"
      }
    },
    detailsCard: {
      "@media (min-width: 1200px)": {
        minWidth: "700px"
      }
    },
    contactDetailsCard: {
      "@media (min-width: 1200px)": {
        minWidth: "700px"
      },
      width: "100%"
    },
    accordionContainer: {
      width: "100%"
    },
    helperText: {
      paddingLeft: "8px",
      marginLeft: "14px",
      marginRight: "14px",
      fontSize: "1.4rem !important",
      lineHeight: "2rem",
      fontStyle: "italic"
    },
    paymentTitle: {
      fontSize: "1.8rem"
    },
    checkLabel: {
      "& span": {
        fontSize: "1.6rem"
      }
    },
    emailHelper: {
      "& p": {
        fontSize: "1.2rem"
      }
    },
    inputFont: {
      fontSize: "1.3rem",
      color: "rgba(0, 0, 0, 0.54) !important"
    },
    descriptionFont: {
      fontSize: "1.7rem",
      lineHeight: "2rem"
    },
    titleModal: {
      fontSize: "1.8rem",
      lineHeight: "2rem",
      fontWeight: "600"
    },
    descriptionHelperFont: {
      fontSize: "1.4rem",
      lineHeight: "2rem"
    },
    inputMinWidth: {
      width: "200px"
    },
    element: {
      borderColor: "#c4c4c4",
      borderRadius: "5px",
      width: "400px",
      padding: "15px 15px",
      "&::-webkit-scrollbar": {
        display: "none"
      },
      "@media (max-width: 500px)": {
        width: "325px"
      },
      "@media (max-width: 420px)": {
        width: "270px"
      }
    },
    fakeLabelContainer: {
      position: "relative"
    },
    fakeLabel: {
      position: "absolute",
      backgroundColor: "white",
      color: "#757575",
      left: "15px",
      top: "-10px",
      padding: "0px 5px",
      fontSize: "1.1rem",
      fontWeight: "600",
      lineHeight: "1.4rem"
    },
    billingAddress: {
      width: "100%"
    },
    successIcon: {
      color: "#7dd773"
    },
    dotted: {
      minWidth: "70px"
    },
    paymentFormContainer: {
      padding: "20px",
      width: "100%"
    },
    paymentWidth: {
      width: "100%"
    },
    drawerHeader: {
      padding: "15px"
    },
    backgroundPrimary: {
      backgroundColor: "#f18605",
      color: "#FFF"
    },
    accentBookableColor: {
      backgroundColor: "#f18605",
      color: "#FFF",
      fontWeight: "600",
      textTransform: "none",
      "& span": {
        fontSize: "1.6rem",
        lineHeight: "2rem",
        textTransform: "none"
      },
      "&:hover": {
        backgroundColor: "#db6c0a"
      }
    },
    pointer: {
      cursor: "pointer"
    },
    cardNumberElement: {
      border: "1px solid #c4c4c4",
      borderRadius: "3px",
      padding: "10.5px"
    },
    stripeLabel: {
      position: "relative",
      top: "29px",
      left: "11px",
      fontSize: "16px",
      color: "#757575",
      lineHeight: "0px"
    },
    chargedToday: {
      padding: "25px",
      backgroundColor: "#fafafa",
      fontSize: "2rem !important"
    },
    headerContainer: {
      width: "calc(100% - 32px)",
      height: "80px",
      display: "flex",
      flexDirection: "column",
      background: "#FFFFFF",
      borderRadius: "4px",
      marginLeft: "12px",
      marginRight: "16px"
    },
    headerContainerColor: {
      width: "100%",
      height: "50px",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      background: "#F18400",
      borderRadius: "4px",
      marginBottom: "16px"
    },
    backButton: {
      width: "5%"
    },
    backButtonColor: {
      width: "5%",
      color: "#FFFFFF !important"
    },
    backHrefColor: {
      width: "5%",
      color: "#FFFFFF !important",
      textDecoration: "none",
      textAlign: "center",
      "&:hover": {
        color: "#FFFFFF !important",
        textDecoration: "none"
      }
    },
    fontHeader: {
      width: "95%",
      fontWeight: "700",
      fontSize: "20px",
      lineHeight: "1.5",
      letterSpacing: "0.00938em",
      color: "#263238",
      margin: "0px",
      marginLeft: "20px"
    },
    fontHeaderConfirmation: {
      width: "95%",
      fontWeight: "700",
      fontSize: "4rem",
      lineHeight: "1.5",
      letterSpacing: "0.00938em",
      color: "#263238",
      padding: "10px 0 10px 0"
    },
    fontSubTitleConfirmation: {
      fontSize: "2.3rem",
      padding: "10px 0 10px 0"
    },
    marginPhone: {
      marginBottom: "10px"
    },
    fontDatesConfirmation: {
      gap: "15px"
    },
    fontHeaderColor: {
      width: "95%",
      textAlign: "center",
      fontWeight: "700",
      fontSize: "18px",
      lineHeight: "1.5",
      letterSpacing: "0.00938em",
      color: "#FFFFFF",
      margin: "0px"
    },
    loader: {
      margin: "auto",
      color: "#F18400"
    },
    draweVisibility: {
      zIndex: "999 !important"
    },
    accordionSummary: {
      "& div:nth-child(2)": {
        transform: "rotate(0deg)"
      },
      "& .MuiAccordionSummary-content": {
        flexDirection: "column",
        cursor: "default"
      }
    },
    orderConfirmationContainer: {
      display: "flex",
      flexDirection: "column",
      width: "960px",
      alignItems: "center",
      margin: "auto !important",
      "@media (max-width: 1200px)": {
        width: "900px"
      },
      "@media (max-width: 992px)": {
        width: "100%"
      }
    },
    firstOrderColumn: {
      width: "100%"
    },
    secondOrderColumn: {
      width: "100%"
    },
    thirdOrderColumn: {
      width: "100%"
    },
    dividerVisibility: {
      "@media (min-width: 992px)": {
        display: "none"
      }
    },
    titleFont: {
      fontSize: "1.8rem"
    },
    titleCheckoutFont: {
      fontSize: "2rem"
    },
    titleAlign: {
      textAlign: "center",
      marginTop: "10px"
    },
    dateTitle: {
      fontSize: "1.7rem",
      fontWeight: "600",
      lineHeight: "2rem"
    },
    pricePadding: {
      padding: "10px"
    },
    taxesContainer: {
      "& div": {
        justifyContent: "space-between"
      }
    },
    priceSpace: {
      marginRight: "10px"
    },
    amountMargin: {
      marginRight: "12px",
      fontSize: "2rem !important"
    },
    datePicker: {
      "& label": {
        marginTop: "6px !important",
        marginLeft: "15px",
        backgroundColor: "#FFFFFF",
        padding: "5px",
        cursor: "pointer",
        zIndex: 1
      },
      "& div": {
        border: "solid 1px rgba(0, 0, 0, 0.23)",
        borderRadius: "4px",
        padding: "8px",
        cursor: "pointer",
        "& input": {
          padding: "0px",
          paddingTop: "3px !important",
          paddingLeft: "8px",
          cursor: "pointer"
        }
      },
      "& p": {
        fontSize: "1.2rem"
      },
      "& .MuiInput-underline:before": {
        borderBottom: "none !important"
      },
      "& .MuiInput-underline:after": {
        borderBottom: "none !important"
      }
    },
    containerWidth: {
      "@media (max-width: 768px)": {
        width: "100%"
      },
      "@media (min-width: 768px)": {
        width: "50%"
      }
    },
    inputWidth: {
      width: "100%"
    },
    marginLabelTop: {
      marginTop: "20px"
    },
    textAreaHeight: {
      height: "75px !important"
    },
    paymentLabel: {
      "& label": {
        backgroundColor: "#FFFFFF"
      },
      "& div": {
        "& div": {
          border: "none !important"
        }
      }
    },
    paymentLabelModal: {
      "& label": {
        backgroundColor: "#FFFFFF",
        fontSize: "1.5rem",
        fontWeight: "600",
        lineHeight: "1.4rem",
        paddingLeft: "10px",
        paddingRight: "8px",
        marginTop: "-2px"
      },
      "& div": {
        "& div": {
          border: "none !important"
        }
      }
    },
    inputError: {
      "& div": {
        "& input": {
          color: "#e76b6b"
        },
        "& fieldset": {
          borderColor: "#e76b6b"
        }
      }
    },
    textareaError: {
      borderColor: "#e76b6b"
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "flex-end"
    },
    buttonWidth: {
      width: "150px"
    },
    checkedIcon: {
      color: "#4CAF50"
    },
    contactSummaryContainer: {
      display: "flex",
      flexDirection: "row",
      width: "100%",
      justifyContent: "space-around"
    },
    contactSummary: {
      display: "flex",
      flexDirection: "column",
      width: "400px",
      "@media (max-width: 768px)": {
        width: "200px"
      }
    },
    contactSummaryCard: {
      display: "flex",
      flexDirection: "column",
      width: "400px",
      "@media (max-width: 768px)": {
        width: "fit-content"
      }
    },
    contactText: {
      fontSize: "1.6rem",
      lineHeight: "2rem",
      margin: "0px"
    },
    editButton: {
      border: "none",
      textDecoration: "underline",
      color: "#F18400",
      background: "none",
      fontSize: "1.7rem",
      lineHeight: "2rem",
      cursor: "pointer",
      "&:hover": {
        textDecoration: "none"
      }
    },
    cardInfo: {
      display: "flex",
      flexDirection: "row",
      gap: "10px",
      alignItems: "center",
      cursor: "pointer"
    },
    cardIcon: {
      maxWidth: "78px",
      maxHeight: "78px"
    },
    addCardContainer: {
      display: "flex",
      width: "100%",
      justifyContent: "center"
    },
    addCard: {
      border: "none",
      textDecoration: "underline",
      color: "#279AD5",
      background: "none",
      fontSize: "1.5rem",
      lineHeight: "2rem",
      cursor: "pointer",
      width: "fit-content !important",
      "&:hover": {
        textDecoration: "none",
        background: "none"
      }
    },
    removeCard: {
      cursor: "pointer",
      color: "#279AD5 !important"
    },
    alignCard: {
      alignItems: "center"
    },
    checkedButton: {
      color: "#279AD5",
      "&:hover": {
        background: "none"
      }
    },
    cancelButton: {
      backgroundColor: "#FFFFFF",
      color: "rgba(0, 0, 0, 0.26)",
      fontSize: "1.6rem",
      lineHeight: "2rem",
      "& span": {
        textTransform: "none"
      },
      "&:hover": {
        backgroundColor: "#FFFFFF"
      }
    },
    buttonsContainer: {
      display: "flex",
      flexDirection: "row",
      gap: "10px"
    },
    checkboxContainer: {
      "&:hover": {
        background: "none !important"
      }
    },
    popUp: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      minHeight: "150px"
    },
    cancelButtonModal: {
      background: "none",
      fontSize: "1.4rem",
      color: "#263238",
      boxShadow: "none",
      "&:hover": {
        backgroundImage: "linear-gradient(rgba(0,0,0,.1),rgba(0,0,0,.1))"
      },
      "& span": {
        textTransform: "none"
      }
    },
    confirmButtonModal: {
      backgroundColor: "#f18605",
      color: "#FFF",
      fontWeight: "600",
      textTransform: "none",
      "& span": {
        fontSize: "1.4rem",
        lineHeight: "2rem",
        textTransform: "none"
      },
      "&:hover": {
        backgroundColor: "#db6c0a"
      }
    },
    backdrop: {
      background: "#FFFFFF",
      zIndex: "3000"
    },
    buttonsContainerModal: {
      gap: "10px",
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end"
    },
    extaDataCard: {
      "@media (max-width: 768px)": {
        flexDirection: "column"
      }
    },
    cardExtraWidth: {
      "@media (max-width: 768px)": {
        maxWidth: "100%",
        flexBasis: "100%"
      }
    },
    errorIconContainer: {
      textAlign: "center"
    },
    errorIcon: {
      color: "#f27474",
      fontSize: "6rem !important"
    },
    verifyContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "15px"
    },
    verifyFont: {
      fontSize: "1.7rem",
      lineHeight: "2rem",
      margin: 0
    },
    verifyAgain: {
      fontSize: "1.7rem",
      lineHeight: "2rem",
      border: "none",
      background: "none",
      textTransform: "none",
      color: "#279AD5",
      "& span": {
        fontSize: "1.7rem",
        lineHeight: "2rem",
        textTransform: "none"
      },
      "&:hover": {
        textDecoration: "underline",
        background: "none"
      }
    },
    verifyButtons: {
      gap: "10px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    },
    failedContainer: {
      display: "flex",
      fontSize: "2.7rem",
      fontWeight: 700,
      lineHeight: "1.5",
      padding: "15px 15px",
      textAlign: "left",
      borderRadius: "5px",
      width: "100%",
      color: "rgb(191, 38, 0)",
      backgroundColor: "rgb(255, 235, 230)"
    }
  };
});

function tn(a) {
  var r = en(),
      l = a.isLoadingServices,
      o = a.additionalPeriodsAmount,
      i = a.extraPeriodCost,
      c = a.startDate,
      s = a.endDate,
      d = a.placeId,
      m = a.serviceId,
      u = a.apolloURL,
      p = a.serviceDescription,
      f = a.proId,
      v = $e(t(0), 2),
      g = v[0],
      C = v[1],
      x = $e(t(0), 2),
      E = x[0],
      b = x[1],
      w = $e(t(0), 2),
      S = w[0],
      O = w[1];
  n(function () {
    je(Be().mark(function e() {
      var t;
      return Be().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (!(c && s && d && m)) {
                e.next = 7;
                break;
              }

              return e.next = 3, Ut.getServicePrice(u, {
                startDate: c,
                endDate: s,
                placeId: d,
                serviceId: m,
                proId: f
              });

            case 3:
              t = e.sent, C(t.data.basePrice + t.data.distanceFee), b(t.data.extraDaysFee), O(t.data.serviceFee);

            case 7:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }))();
  }, [c, s, d, m]);
  var M;
  return e.createElement(e.Fragment, null, e.createElement(h, {
    container: !0,
    direction: "row"
  }, l ? e.createElement(F, {
    className: r.backdrop,
    open: !0
  }, e.createElement(N, {
    className: r.white
  })) : e.createElement(k, {
    className: r.fullWidth
  }, e.createElement(I, {
    className: r.noPadding
  }, e.createElement("div", {
    className: "".concat(r.flexcontainer, " ").concat(r.justifyspacebetween, " ").concat(r.pricePadding)
  }, e.createElement(y, {
    variant: "body2",
    className: r.descriptionFont
  }, p), e.createElement(y, {
    variant: "body2",
    className: "".concat(r.descriptionFont, " ").concat(r.priceSpace)
  }, "$", 0 === g ? g : g.toFixed(2))), e.createElement("div", {
    className: "".concat(r.flexcontainer, " ").concat(r.justifyspacebetween, " ").concat(r.pricePadding)
  }, o > 0 && i ? e.createElement(e.Fragment, null, e.createElement(y, {
    variant: "body2",
    className: r.descriptionFont
  }, "Extra time (", o, " @ $", i, ")"), e.createElement(y, {
    variant: "body2",
    className: "".concat(r.descriptionFont, " ").concat(r.priceSpace)
  }, "$", 0 === E ? E : E.toFixed(2))) : e.createElement(e.Fragment, null)), e.createElement(T, {
    className: "".concat(r.styledAccordion)
  }, e.createElement(D, {
    expandIcon: e.createElement(he, null),
    "aria-controls": "panel1a-content",
    id: "panel1a-header",
    className: r.taxesContainer
  }, e.createElement(y, {
    className: r.descriptionFont
  }, "Taxes & fees"), e.createElement(y, {
    variant: "body2",
    className: r.descriptionFont
  }, "$", 0 === S ? S : S.toFixed(2))), e.createElement(P, null, e.createElement(L, {
    className: r.itemsList,
    dense: !0
  }, e.createElement(A, null, e.createElement("div", {
    className: "".concat(r.flexcontainer, " ").concat(r.fullWidth, " ").concat(r.justifyspacebetween)
  }, e.createElement(y, {
    variant: "body2",
    className: r.descriptionFont
  }, "Taxes"), e.createElement(y, {
    variant: "body2",
    className: r.descriptionFont
  }, "$0"))), e.createElement(A, null, e.createElement("div", {
    className: "".concat(r.flexcontainer, " ").concat(r.fullWidth, " ").concat(r.justifyspacebetween)
  }, e.createElement(y, {
    variant: "body2",
    className: r.descriptionFont
  }, "Service Fee"), e.createElement(y, {
    variant: "body2",
    className: r.descriptionFont
  }, "$", 0 === S ? S : S.toFixed(2)))))))), e.createElement("div", {
    className: "".concat(r.flexcontainer, " ").concat(r.justifyspacebetween, " ").concat(r.chargedToday)
  }, e.createElement("strong", null, e.createElement(y, {
    className: r.boldFont
  }, "Total")), e.createElement("strong", null, e.createElement(y, {
    className: "".concat(r.boldFont, " ").concat(r.amountMargin)
  }, "$", 0 === (M = g + E + S) ? M : M.toFixed(2)))))));
}

function nn(a) {
  var r,
      l = en();
  a.servicesApiUrl;
  var o = a.placeId;
  a.baseServiceId;
  var i = a.proId,
      c = a.apolloURL,
      s = a.service;
  a.connectedAcountId;
  var d = a.handleCheckoutClick,
      m = a.staticUrl,
      u = a.proName,
      p = a.maxDatePicker,
      f = $e(t(!1), 2),
      v = f[0],
      g = f[1],
      C = $e(t(a.deliveryDates ? a.deliveryDates : [null, null]), 2),
      x = C[0],
      E = C[1],
      w = $e(t([]), 2);
  w[0];
  var S = w[1],
      F = $e(t([]), 2),
      T = F[0],
      D = F[1],
      P = $e(t([]), 2),
      L = P[0],
      A = P[1],
      M = $e(t(a.googlePlace ? a.googlePlace : ""), 2),
      z = M[0];
  M[1];

  var W = $e(t(!1), 2),
      B = W[0],
      R = W[1],
      _ = $e(t(X()), 2),
      j = _[0],
      V = _[1],
      U = $e(t({
    delivery: !1,
    removal: !1,
    message: "Please select a valid date"
  }), 2),
      K = U[0],
      J = U[1],
      Y = $e(t(""), 2),
      G = Y[0],
      Z = Y[1],
      Q = a.selectedWasteType && (Array.isArray(a.selectedWasteType) ? a.selectedWasteType[0] : a.selectedWasteType);

  function X() {
    return window.innerWidth;
  }

  n(function () {
    var e = function e() {
      V(X());
    };

    return window.addEventListener("resize", e), function () {
      window.removeEventListener("resize", e);
    };
  }, [j]), n(function () {
    je(Be().mark(function e() {
      var t, n, r, l, o, i, d;
      return Be().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, window.scrollTo(0, 0), g(!0), e.next = 5, Promise.all([Jt.getSizes(c), Jt.getTypes(c), Jt.getWasteTypes(c)]);

            case 5:
              n = e.sent, r = $e(n, 3), l = r[0], o = r[1], i = r[2], d = i.data.filter(function (e) {
                return s.wasteType.includes(e.id);
              }), S(d), Z(null == d || null === (t = d.find(function (e) {
                return e.id === Q;
              })) || void 0 === t ? void 0 : t.value), D(l.data), A(o.data), e.next = 22;
              break;

            case 17:
              e.prev = 17, e.t0 = e.catch(0), console.log(e.t0), a.setModalCode("pageOutOfOrder"), a.setShowModal(!0);

            case 22:
              return e.prev = 22, g(!1), e.finish(22);

            case 25:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 17, 22, 25]]);
    }))();
  }, []);

  var ee = function ee(e, t) {
    var n = t.getTime() - e.getTime();
    return Math.ceil(n / 864e5);
  },
      te = function te(e, t) {
    var n = e.find(function (e) {
      return e.id === t;
    });
    return n ? n.value : "";
  },
      ne = function ne(e, t) {
    var n = e.find(function (e) {
      return e.id === t;
    });
    return n ? n.value : "";
  },
      ae = function ae() {
    if (x[0] && x[1]) {
      var e = (ee(new Date(x[0]), new Date(x[1])) - s.details[1].period) / s.details[1].extraDayPeriod;
      if (e > 0) return Math.ceil(e);
    }

    return 0;
  },
      re = function () {
    var e = je(Be().mark(function e() {
      return Be().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              try {
                R(!0), d({
                  googlePlace: z,
                  deliveryDates: x,
                  selectedWasteType: Q,
                  selectedWasteTypeLabel: G,
                  getAditionalPeriodsAmount: ae,
                  serviceDescription: "".concat(te(T, s.dumpsterSize[0]), " ").concat(ne(L, s.dumpsterType[0]))
                });
              } catch (e) {
                console.log(e);
              } finally {
                R(!1);
              }

            case 1:
            case "end":
              return e.stop();
          }
        }
      }, e);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }(),
      le = function le(e) {
    return 0 === e.getDay() || 6 === e.getDay();
  },
      oe = null === (r = s.placesId) || void 0 === r || null === (r = r.find(function (e) {
    return e.placeId === +o;
  })) || void 0 === r ? void 0 : r.distanceFee;

  return e.createElement(e.Fragment, null, e.createElement(h, {
    spacing: 4,
    container: !0,
    direction: "row"
  }, v ? e.createElement(N, {
    size: 35,
    className: l.loader
  }) : e.createElement(e.Fragment, null, e.createElement("div", {
    className: l.headerContainer
  }, e.createElement(O, {
    className: l.backButton,
    onClick: function onClick() {
      return a.handleBack([{
        key: "wasteType",
        value: Q
      }, {
        key: "fullFormData",
        value: z
      }]);
    }
  }, e.createElement(ge, null)), e.createElement("p", {
    className: l.fontHeader
  }, e.createElement("strong", null, "Set dates and confirm order"))), e.createElement(h, {
    item: !0,
    className: l.detailContainer
  }, e.createElement(k, {
    className: "".concat(l.detailsCard)
  }, e.createElement(I, null, e.createElement("strong", null, e.createElement("p", {
    className: l.dateTitle
  }, e.createElement("strong", null, "Set delivery and removal dates"))), e.createElement(h, {
    container: !0,
    spacing: 2
  }, " ", e.createElement(h, {
    xs: 5,
    item: !0,
    className: l.itemContainer
  }, e.createElement(H, {
    utils: $
  }, e.createElement(q, {
    className: "".concat(l.marginRight, " ").concat(l.datePicker),
    value: x[0],
    onChange: function onChange(e) {
      var t = ee(new Date(), e);
      if (t > 0 || -0 === t) {
        if (x[1]) {
          var n = ee(e, new Date(x[1]));
          n > 0 || -0 === n ? (x[0] = e, E(Ke(x)), J(We(We({}, K), {}, {
            delivery: !1
          }))) : (x[0] = null, E(Ke(x)), J(We(We({}, K), {}, {
            delivery: !0
          })));
        } else x[0] = e, E(Ke(x)), J(We(We({}, K), {}, {
          delivery: !1
        }));
      } else x[0] = null, E(Ke(x)), J(We(We({}, K), {}, {
        delivery: !0
      }));
    },
    label: "Delivery date",
    fullWidth: !0,
    size: "small",
    variant: "outlined",
    required: !0,
    shouldDisableDate: le,
    minDate: new Date(Date.now() + 864e5),
    maxDate: x[1] ? new Date(x[1].getTime() - 864e5) : new Date(Date.now() + p),
    error: K.delivery,
    invalidDateMessage: K.delivery && K.message,
    helperText: K.delivery && K.message,
    autoOk: !0,
    format: "MM/dd/yyyy",
    inputProps: {
      "data-testid": "filter-input",
      placeholder: ""
    },
    InputProps: {
      endAdornment: e.createElement(Ce, null)
    }
  }))), e.createElement(h, {
    xs: 5,
    item: !0,
    className: l.itemContainer
  }, e.createElement(H, {
    utils: $
  }, e.createElement(q, {
    className: "".concat(l.marginRight, " ").concat(l.datePicker),
    value: x[1],
    onChange: function onChange(e) {
      var t = ee(x[0] ? new Date(x[0]) : new Date(), new Date(e));
      t > 0 || -0 === t ? (x[1] = e, E(Ke(x)), J(We(We({}, K), {}, {
        removal: !1
      }))) : (x[1] = null, E(Ke(x)), J(We(We({}, K), {}, {
        removal: !0
      })));
    },
    label: "Removal date",
    fullWidth: !0,
    size: "small",
    variant: "outlined",
    required: !0,
    shouldDisableDate: le,
    minDate: x[0] ? new Date(x[0].getTime() + 864e5) : new Date(Date.now() + 864e5),
    maxDate: new Date(Date.now() + p),
    error: K.removal,
    invalidDateMessage: K.removal && K.message,
    helperText: K.removal && K.message,
    autoOk: !0,
    format: "MM/dd/yyyy",
    inputProps: {
      "data-testid": "filter-input",
      placeholder: ""
    },
    InputProps: {
      endAdornment: e.createElement(Ce, null)
    }
  }))), e.createElement("p", {
    className: l.dateTitle,
    style: {
      fontWeight: "400",
      fontSize: "1.6rem",
      marginLeft: "20px"
    }
  }, s.details[1].details.replace("<br> ", "").replace(".", ","), ". Get delivery the day before loading begins")), !j || j > 600 ? e.createElement("div", {
    className: "".concat(l.flexcontainer, " ").concat(l.justifyspacebetween, " ").concat(l.marginTopDescription)
  }, e.createElement("div", {
    className: l.topContainer
  }, e.createElement("img", {
    src: "".concat(m).concat(s.image),
    className: l.image
  }), e.createElement(y, {
    className: "".concat(l.descriptionFont, " ").concat(l.titleFont)
  }, te(T, s.dumpsterSize[0]), " ", ne(L, s.dumpsterType[0]), ", ", u)), e.createElement(y, {
    className: "".concat(l.boldFont, " ").concat(l.price)
  }, "$", oe ? (s.price + +oe).toFixed(2) : s.price.toFixed(2))) : e.createElement("div", {
    className: "".concat(l.flexcontainer2, " ").concat(l.justifyspacebetween, " ").concat(l.marginTopDescription)
  }, e.createElement("div", {
    className: l.topContainer2
  }, e.createElement("img", {
    src: "".concat(m).concat(s.image),
    className: l.image
  }), e.createElement(y, {
    className: "".concat(l.boldFont, " ").concat(l.price)
  }, "$", s.price)), e.createElement(y, {
    className: "".concat(l.descriptionFont, " ").concat(l.titleFont, " ").concat(l.titleAlign)
  }, te(T, s.dumpsterSize[0]), " ", ne(L, s.dumpsterType[0]), ", ", u, ".")), e.createElement("div", {
    className: l.marginTopBig
  }, e.createElement("div", {
    className: l.marginTopBig
  }, e.createElement("p", {
    className: l.dateTitle
  }, "Waste type:"), e.createElement("p", {
    className: l.dateTitle,
    style: {
      fontWeight: "400",
      fontSize: "1.6rem"
    }
  }, G, " - ", s.details[0].details.replace("<br> ", ""))), e.createElement("div", {
    className: l.marginTopBig
  }, e.createElement("p", {
    className: l.dateTitle
  }, "Deliver to:"), e.createElement("p", {
    className: l.dateTitle,
    style: {
      fontWeight: "400",
      fontSize: "1.6rem"
    }
  }, z ? Object.fromEntries(JSON.parse(z)).street + ", " + Object.fromEntries(JSON.parse(z)).street2 : "")))))), e.createElement(h, {
    item: !0,
    className: l.pricingContainer
  }, e.createElement(h, {
    container: !0,
    spacing: 2
  }, e.createElement(h, {
    xs: 12,
    item: !0
  }, e.createElement(b, {
    onClick: re,
    className: l.accentBookableColor,
    size: "large",
    variant: "contained",
    fullWidth: !0,
    disabled: !(Q && x[0] && x[1] && z)
  }, B ? e.createElement(N, {
    size: 24,
    color: "inherit"
  }) : e.createElement("b", null, "Continue to Checkout"))), e.createElement(h, {
    xs: 12,
    item: !0
  }, e.createElement(h, {
    container: !0,
    alignItems: "center"
  }, e.createElement(ye, {
    className: l.marginRightSmall
  }), e.createElement(y, {
    variant: "subtitle1",
    className: l.descriptionFont
  }, "Secure checkout"))), e.createElement(h, {
    xs: 12,
    item: !0
  }, e.createElement(tn, {
    startDate: x[0],
    endDate: x[1],
    placeId: o,
    proId: i,
    additionalPeriodsAmount: ae(),
    extraPeriodCost: s.details[1].extraPeriodCost,
    serviceId: s._id,
    apolloURL: c,
    serviceDescription: "".concat(te(T, s.dumpsterSize[0]), " ").concat(ne(L, s.dumpsterType[0]))
  })))))));
}

function an(n) {
  var a = en(),
      r = n.isLoadingServices,
      l = n.handleFirstNameChange,
      i = n.handleLastnameChange,
      c = n.handleMobilePhoneChange,
      s = n.handleEmailChange,
      d = n.name,
      m = n.lastname,
      u = n.mobilePhone,
      p = n.email,
      f = n.error,
      v = n.dumpsterPlacement,
      g = n.emailError,
      C = n.handleContinue;
  n.getCustomerList;

  var x = n.getCustomer,
      E = n.changeShowModal,
      w = n.setCustomerList,
      S = n.setSelectedCard,
      T = $e(t(!1), 2),
      D = T[0],
      P = T[1],
      L = $e(t(!1), 2),
      A = L[0],
      O = L[1],
      M = $e(t(!1), 2),
      z = M[0],
      W = M[1],
      B = $e(t(!1), 2),
      R = B[0],
      _ = B[1],
      j = $e(t(!1), 2),
      V = j[0],
      U = j[1],
      H = function () {
    var e = je(Be().mark(function e() {
      var t;
      return Be().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (e.prev = 0, U(!0), !(t = JSON.parse(localStorage.getItem("Customer"))) || t.phone !== u || !Mt.defaults.headers.common.hashcode) {
                e.next = 7;
                break;
              }

              C(v ? "panel1" : "panel2"), e.next = 12;
              break;

            case 7:
              return (t || Mt.defaults.headers.common.hashcode) && (localStorage.removeItem("Customer"), delete Mt.defaults.headers.common.hashcode, w([]), S("")), e.next = 10, x();

            case 10:
              e.sent ? E("verificationCode") : C(v ? "panel1" : "panel2");

            case 12:
              e.next = 17;
              break;

            case 14:
              e.prev = 14, e.t0 = e.catch(0), console.log("error: ", e.t0);

            case 17:
              return e.prev = 17, U(!1), e.finish(17);

            case 20:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 14, 17, 20]]);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }();

  return e.createElement(e.Fragment, null, e.createElement(h, {
    container: !0,
    direction: "row"
  }, r ? e.createElement(F, {
    className: a.backdrop,
    open: !0
  }, e.createElement(N, {
    className: a.white
  })) : e.createElement(k, {
    className: "".concat(a.contactDetailsCard)
  }, e.createElement(I, null, e.createElement(y, {
    variant: "caption",
    style: {
      fontSize: "1.1rem",
      color: "rgba(0, 0, 0, 0.54)"
    }
  }, "* Required fields"), e.createElement("br", null), e.createElement("br", null), e.createElement("div", null, e.createElement(h, {
    container: !0,
    spacing: 2
  }, e.createElement(h, {
    item: !0,
    className: a.containerWidth
  }, e.createElement(o, {
    className: "".concat(a.marginRight, " ").concat(a.inputWidth, " ").concat(D && !d && a.inputError),
    onChange: l,
    value: d,
    label: "First name *",
    variant: "outlined",
    type: "text",
    size: "small",
    onFocus: function onFocus() {
      return P(!1);
    },
    onBlur: function onBlur() {
      P(!d);
    },
    helperText: D && !d && e.createElement("p", {
      className: a.mobileHelperText
    }, "Enter first name"),
    inputProps: {
      "data-testid": "filter-input",
      placeholder: ""
    }
  })), e.createElement(h, {
    item: !0,
    className: a.containerWidth
  }, e.createElement(o, {
    className: "".concat(a.marginRight, " ").concat(a.inputWidth, " ").concat(A && !m && a.inputError),
    onChange: i,
    label: "Last name *",
    value: m,
    variant: "outlined",
    type: "text",
    size: "small",
    onFocus: function onFocus() {
      return O(!1);
    },
    onBlur: function onBlur() {
      O(!m);
    },
    helperText: A && !m && e.createElement("p", {
      className: a.mobileHelperText
    }, "Enter last name"),
    inputProps: {
      "data-testid": "filter-input",
      placeholder: ""
    }
  }))), e.createElement("br", null), e.createElement(h, {
    container: !0,
    spacing: 2
  }, e.createElement(h, {
    item: !0,
    className: a.containerWidth
  }, e.createElement(o, {
    className: "".concat(a.marginRight, " ").concat(a.inputWidth, " ").concat(R && f && a.inputError),
    onChange: c,
    label: "Mobile phone (10 digits) *",
    value: u,
    variant: "outlined",
    type: "tel",
    size: "small",
    onFocus: function onFocus() {
      return _(!1);
    },
    onBlur: function onBlur() {
      _(!!f);
    },
    helperText: R && f ? e.createElement("p", {
      className: a.mobileHelperText
    }, f) : e.createElement("p", {
      className: a.descriptionHelperFont
    }, "Service info texted here"),
    inputProps: {
      "data-testid": "filter-input",
      placeholder: "",
      maxLength: null != u && u.includes(" ") || null != u && u.includes("(") || null != u && u.includes(")") || null != u && u.includes("-") ? 14 : 10
    }
  })), e.createElement(h, {
    item: !0,
    className: a.containerWidth
  }, e.createElement(o, {
    className: "".concat(a.marginRight, " ").concat(a.inputWidth, " ").concat(z && g && a.inputError),
    onChange: s,
    label: "Email *",
    value: p,
    variant: "outlined",
    type: "email",
    size: "small",
    onFocus: function onFocus() {
      return W(!1);
    },
    onBlur: function onBlur() {
      W(!!g);
    },
    helperText: z && g ? e.createElement("p", {
      className: a.mobileHelperText
    }, g) : e.createElement("p", {
      className: a.descriptionHelperFont
    }, "Your receipt will be emailed here"),
    inputProps: {
      "data-testid": "filter-input",
      placeholder: ""
    }
  })))), e.createElement("br", null), e.createElement("div", {
    className: a.buttonContainer
  }, e.createElement(b, {
    onClick: H,
    className: "".concat(a.accentBookableColor, " ").concat(a.buttonWidth),
    size: "large",
    variant: "contained",
    fullWidth: !0,
    disabled: !d || !m || 14 !== (null == u ? void 0 : u.length) || !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(p) || V
  }, V ? e.createElement(N, {
    size: 24,
    color: "inherit"
  }) : e.createElement("b", null, "Continue")))))));
}

function rn(n) {
  var a = en(),
      r = n.isLoadingServices,
      l = n.handleDumpsterPlacementChange,
      o = n.dumpsterPlacement,
      i = n.handleContinue,
      c = n.setIsShowingCards,
      s = n.customerList,
      m = n.setIsContinuePress,
      u = $e(t(!1), 2),
      p = u[0],
      v = u[1];
  return e.createElement(e.Fragment, null, e.createElement(h, {
    container: !0,
    direction: "row"
  }, r ? e.createElement(F, {
    className: a.backdrop,
    open: !0
  }, e.createElement(N, {
    className: a.white
  })) : e.createElement("div", {
    className: a.fullWidth
  }, e.createElement(y, {
    variant: "body2",
    className: "".concat(a.descriptionFont, " ").concat(a.marginLabelTop)
  }, "Describe where the dumpster should be placed. Include any access issues (gates, lock codes, hours of operation, etc)."), e.createElement("div", {
    className: "".concat(a.marginYBig, " ").concat(a.fakeLabelContainer)
  }, e.createElement(y, {
    variant: "caption",
    className: a.fakeLabel
  }, "Dumpster Placement *"), e.createElement(f, {
    className: "".concat(a.element, " ").concat(a.textAreaHeight, " ").concat(p && !o && a.textareaError),
    value: o,
    onChange: l,
    minRows: 10,
    maxRows: 10,
    onFocus: function onFocus() {
      return v(!1);
    },
    onBlur: function onBlur() {
      v(!o);
    },
    "aria-label": "maximum height"
  }), e.createElement(d, {
    className: p && !o ? a.mobileHelperText : a.helperText
  }, p && !o ? "Enter instructions" : "On the left side of the driveway near the garage")), e.createElement("br", null), e.createElement("div", {
    className: a.buttonContainer
  }, e.createElement(b, {
    onClick: function onClick() {
      (null == s ? void 0 : s.length) > 0 ? (c(!0), i("panel2")) : (c(!1), i("panel3")), m(!0);
    },
    className: "".concat(a.accentBookableColor, " ").concat(a.buttonWidth),
    size: "large",
    variant: "contained",
    fullWidth: !0,
    disabled: !o
  }, e.createElement("b", null, "Continue"))))));
}

function ln(t) {
  var n = en(),
      a = Se(),
      r = Fe(),
      l = t.isLoadingServices,
      i = t.customerEmail;
  t.customerName, t.customerPhone, t.customerLastname, t.pi, t.apolloURL;
  var d = t.defaultAddress,
      m = t.stripeApiKey,
      u = t.handleContinue,
      p = t.setIsShowingCards,
      f = t.addCustomerList,
      v = $e(e.useState(!1), 2),
      g = v[0],
      C = v[1],
      x = $e(e.useState(""), 2),
      E = x[0],
      w = x[1],
      k = $e(e.useState(!1), 2),
      I = k[0],
      T = k[1],
      D = $e(e.useState("Enter a valid card"), 2),
      P = D[0],
      L = D[1],
      A = $e(e.useState("Enter expiration date"), 2),
      O = A[0],
      M = A[1],
      z = $e(e.useState("Enter security code"), 2),
      W = z[0],
      B = z[1],
      R = $e(e.useState(""), 2),
      _ = R[0],
      j = R[1],
      V = $e(e.useState(""), 2),
      U = V[0],
      H = V[1],
      q = $e(e.useState(""), 2),
      $ = q[0],
      K = q[1],
      J = $e(e.useState(!1), 2),
      Y = J[0],
      G = J[1],
      Z = $e(e.useState(!1), 2),
      Q = Z[0],
      X = Z[1],
      ee = $e(e.useState(!1), 2),
      te = ee[0],
      ne = ee[1];
  Le(m);

  var ae = function () {
    var e = je(Be().mark(function e() {
      var t, n, l, o;
      return Be().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (event.preventDefault(), a && r) {
                e.next = 3;
                break;
              }

              return e.abrupt("return");

            case 3:
              return C(!0), t = {}, I ? (n = Object.fromEntries(JSON.parse(E)), t = {
                city: n.locality,
                country: "US",
                postal_code: n.postal_code,
                state: n.state,
                line1: n.street
              }) : t = {
                city: d.locality,
                country: "US",
                postal_code: d.postal_code,
                state: d.state,
                line1: d.street
              }, l = {
                email: i,
                address: t
              }, e.prev = 7, e.next = 10, a.createPaymentMethod({
                type: "card",
                card: r.getElement(Ie),
                billing_details: l
              });

            case 10:
              (o = e.sent).paymentMethod && (f({
                id: o.paymentMethod.id,
                brand: o.paymentMethod.card.brand,
                last4: o.paymentMethod.card.last4,
                expiration: "".concat(o.paymentMethod.card.exp_month / 10 > 1 ? o.paymentMethod.card.exp_month : "0" + o.paymentMethod.card.exp_month, "/").concat(o.paymentMethod.card.exp_year),
                attachedMethod: !1
              }), p(!0), u("panel3")), e.next = 18;
              break;

            case 14:
              e.prev = 14, e.t0 = e.catch(7), console.log(e.t0), C(!1);

            case 18:
              return e.prev = 18, C(!1), e.finish(18);

            case 21:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[7, 14, 18, 21]]);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }(),
      re = function re(e) {
    "cardNumber" === e.elementType && (e.complete ? L("") : (e.error, L("Enter a valid card"))), "cardExpiry" === e.elementType && (e.complete ? M("") : (e.error, M("Enter expiration date"))), "cardCvc" === e.elementType && (e.complete ? B("") : (e.error, B("Enter security code")));
  };

  return e.createElement(e.Fragment, null, e.createElement(h, {
    container: !0,
    direction: "row"
  }, l ? e.createElement(F, {
    className: n.backdrop,
    open: !0
  }, e.createElement(N, {
    className: n.white
  })) : e.createElement(e.Fragment, null, e.createElement("div", {
    className: n.paymentWidth
  }, e.createElement(y, {
    variant: "subtitle2",
    className: n.inputFont
  }, "*Required fields"), e.createElement(h, {
    container: !0,
    spacing: 2,
    className: "".concat(n.flex, " ").concat(n.marginY)
  }, e.createElement(h, {
    className: n.inputContainer,
    item: !0,
    xs: 12
  }, e.createElement(o, {
    fullWidth: !0,
    value: U,
    className: "".concat(n.paymentLabel, " ").concat(P && Y && n.inputError),
    onChange: function onChange(e) {
      H(e.empty ? "" : " ");
    },
    label: "Card number *",
    size: "small",
    variant: "outlined",
    onFocus: function onFocus() {
      return G(!1);
    },
    onBlur: function onBlur() {
      G(!!P);
    },
    helperText: Y && P && e.createElement("p", {
      className: n.mobileHelperText
    }, P),
    InputProps: {
      inputComponent: Ie
    },
    inputProps: {
      className: n.cardNumberElement,
      onChange: re,
      options: {
        placeholder: "",
        showIcon: !!U
      }
    }
  }))), e.createElement(h, {
    container: !0,
    spacing: 2,
    className: "".concat(n.flex, " ").concat(n.marginY, " ").concat(n.extaDataCard)
  }, e.createElement(h, {
    item: !0,
    xs: 6,
    className: n.cardExtraWidth
  }, e.createElement(o, {
    fullWidth: !0,
    value: _,
    className: "".concat(n.paymentLabel, " ").concat(O && Q && n.inputError),
    onChange: function onChange(e) {
      j(e.empty ? "" : " ");
    },
    label: "MM/YY *",
    size: "small",
    variant: "outlined",
    onFocus: function onFocus() {
      return X(!1);
    },
    onBlur: function onBlur() {
      X(!!O);
    },
    helperText: Q && O && e.createElement("p", {
      className: n.mobileHelperText
    }, O),
    InputProps: {
      inputComponent: Te
    },
    inputProps: {
      className: n.cardNumberElement,
      onChange: re,
      options: {
        placeholder: ""
      }
    }
  })), e.createElement(h, {
    item: !0,
    xs: 6,
    className: n.cardExtraWidth
  }, e.createElement(o, {
    fullWidth: !0,
    value: $,
    className: "".concat(n.paymentLabel, " ").concat(W && te && n.inputError),
    onChange: function onChange(e) {
      K(e.empty ? "" : " ");
    },
    label: "Security code *",
    size: "small",
    variant: "outlined",
    onFocus: function onFocus() {
      return ne(!1);
    },
    onBlur: function onBlur() {
      ne(!!W);
    },
    helperText: te && W && e.createElement("p", {
      className: n.mobileHelperText
    }, W),
    InputProps: {
      inputComponent: De
    },
    inputProps: {
      className: n.cardNumberElement,
      onChange: re,
      options: {
        placeholder: ""
      }
    }
  })))))), e.createElement("br", null), e.createElement(S, null), e.createElement("br", null), e.createElement("div", null, e.createElement(y, null, e.createElement("b", {
    className: n.paymentTitle
  }, "Billing Address")), e.createElement("br", null), e.createElement(c, {
    className: n.checkLabel,
    control: e.createElement(s, {
      onChange: function onChange() {
        T(!I);
      },
      name: "checkedB",
      color: "primary",
      defaultChecked: !0
    }),
    label: "Same as service address"
  }), e.createElement("br", null), e.createElement("br", null), I ? e.createElement(e.Fragment, null, e.createElement(h, {
    spacing: 2,
    container: !0,
    className: "".concat(n.flex, " ").concat(n.marginY)
  }, e.createElement(h, {
    item: !0,
    xs: 12
  }, e.createElement(gt, {
    apiKey: t.googlePlaceAutocompleteApiKey,
    className: n.billingAddress,
    defaultValue: E ? Object.fromEntries(JSON.parse(E)).street + ", " + Object.fromEntries(JSON.parse(E)).street2 : "",
    name: "",
    label: "Street address *",
    fieldName: "c",
    placeholder: "Street address",
    resetError: function resetError() {},
    onResetField: function onResetField() {
      w("");
    },
    onChange: function onChange(e) {
      w(JSON.stringify(e));
    },
    onChangeValue: E,
    formValues: [],
    size: "small",
    fullWidth: !0,
    showSearchIcon: !0
  })))) : e.createElement("p", {
    className: n.dateTitle,
    style: {
      fontWeight: "400",
      fontSize: "1.6rem"
    }
  }, d ? d.street + ", " + d.street2 : "")), e.createElement("br", null), e.createElement("br", null), e.createElement(h, {
    xs: 12,
    item: !0,
    className: n.buttonsContainer
  }, e.createElement(b, {
    className: n.cancelButton,
    variant: "contained",
    size: "large",
    fullWidth: !0,
    onClick: function onClick() {
      p(!0), u("panel3");
    }
  }, "Cancel"), e.createElement(b, {
    disabled: (I ? !E : !d) || g || P || O || W,
    className: n.accentBookableColor,
    variant: "contained",
    size: "large",
    fullWidth: !0,
    onClick: ae
  }, g ? e.createElement(N, {
    size: 24,
    color: "inherit"
  }) : "Continue")));
}

function on(t) {
  var n = t.customerName,
      a = t.customerLastname,
      r = t.customerPhone,
      l = t.customerEmail,
      o = t.pi,
      i = t.apolloURL,
      c = t.defaultAddress,
      s = t.stripeApiKey,
      d = t.handleContinue,
      m = t.setIsShowingCards,
      u = t.addCustomerList,
      p = Le(s);
  return e.createElement(Pe, {
    stripe: p,
    options: {}
  }, e.createElement(ln, {
    googlePlaceAutocompleteApiKey: t.googlePlaceAutocompleteApiKey,
    pi: o,
    customerName: n,
    customerLastname: a,
    customerPhone: r,
    customerEmail: l,
    apolloURL: i,
    defaultAddress: c,
    stripeApiKey: s,
    handleContinue: d,
    setIsShowingCards: m,
    addCustomerList: u
  }));
}

function cn(t) {
  var a = t.cardId,
      r = t.handleCheckoutFinishWithPayment,
      l = t.setShowModal,
      i = t.apolloURL,
      c = t.service,
      s = t.proId,
      d = t.fromDate,
      m = t.toDate,
      u = t.placeId,
      p = t.customerEmail,
      f = t.customerName,
      v = t.customerPhone,
      g = t.customerSurname,
      y = t.count,
      C = t.setCount,
      x = t.removeCard,
      E = Se(),
      w = Fe(),
      k = en(),
      S = $e(e.useState(""), 2),
      I = S[0],
      T = S[1],
      D = $e(e.useState(!1), 2),
      P = D[0],
      L = D[1],
      A = $e(e.useState(!1), 2),
      O = A[0],
      M = A[1],
      z = $e(e.useState(!1), 2),
      W = z[0],
      B = z[1],
      R = $e(e.useState("Enter security code"), 2),
      _ = R[0],
      j = R[1],
      V = $e(e.useState(), 2),
      U = V[0],
      H = V[1],
      q = $e(e.useState(), 2),
      $ = q[0],
      K = q[1],
      J = $e(e.useState(), 2),
      Y = J[0],
      G = J[1],
      Z = $e(e.useState(!1), 2),
      Q = Z[0],
      X = Z[1];
  n(function () {
    je(Be().mark(function e() {
      var t, n;
      return Be().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, M(!0), e.next = 4, qt.createPaymentIntent(i, c._id, s, d, m, u);

            case 4:
              if (t = e.sent, H(t.data.clientSecret), K(t.data.mongoPayment), !t.data.mongoPayment) {
                e.next = 12;
                break;
              }

              return e.next = 10, $t.addCustomer(i, t.data.mongoPayment.intentId, {
                customerEmail: p,
                customerName: f,
                customerPhone: v,
                customerSurname: g
              });

            case 10:
              n = e.sent, G(n.data.customerId);

            case 12:
              e.next = 17;
              break;

            case 14:
              e.prev = 14, e.t0 = e.catch(0), console.log(e.t0);

            case 17:
              return e.prev = 17, M(!1), e.finish(17);

            case 20:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 14, 17, 20]]);
    }))();
  }, []);

  var ee = function () {
    var e = je(Be().mark(function e() {
      var t;
      return Be().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (E && w) {
                e.next = 2;
                break;
              }

              return e.abrupt("return");

            case 2:
              return e.prev = 2, B(!0), e.next = 6, E.confirmCardPayment(U, {
                payment_method: a,
                payment_method_options: {
                  card: {
                    cvc: w.getElement(De)
                  }
                }
              });

            case 6:
              (t = e.sent).error ? "card_declined" === t.error.code || y - 1 == 0 ? (x(a, !0), X(!0)) : (L(!0), j("Enter a valid security code"), C(--y)) : t.paymentIntent && r({
                customerId: Y,
                paymentId: $._id,
                pi: $.intentId
              }), e.next = 13;
              break;

            case 10:
              e.prev = 10, e.t0 = e.catch(2), console.log(e.t0);

            case 13:
              return e.prev = 13, B(!1), e.finish(13);

            case 16:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[2, 10, 13, 16]]);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }();

  return e.createElement(h, {
    container: !0,
    className: k.popUp
  }, O ? e.createElement(F, {
    className: k.backdrop,
    open: !0
  }, e.createElement(N, {
    className: k.white
  })) : Q ? e.createElement(e.Fragment, null, e.createElement("div", {
    className: k.errorIconContainer
  }, e.createElement(Oe, {
    className: k.errorIcon
  })), e.createElement(h, {
    item: !0,
    xs: 12
  }, e.createElement("p", {
    className: k.descriptionFont
  }, "Your card was declined. You can try a different card or contact the card issuer for more information.")), e.createElement(h, {
    xs: 12,
    item: !0,
    className: k.buttonsContainerModal
  }, e.createElement(b, {
    className: k.confirmButtonModal,
    variant: "contained",
    size: "medium",
    onClick: function onClick() {
      return l(!1);
    }
  }, "Ok"))) : e.createElement(e.Fragment, null, e.createElement(h, {
    item: !0,
    xs: 12
  }, e.createElement(o, {
    fullWidth: !0,
    value: I,
    className: "".concat(k.paymentLabelModal, " ").concat(_ && P && k.inputError),
    onChange: function onChange(e) {
      T(e.empty ? "" : " ");
    },
    label: "Security code *",
    size: "small",
    variant: "outlined",
    onFocus: function onFocus() {
      return L(!1);
    },
    onBlur: function onBlur() {
      L(!!_);
    },
    helperText: P && _ && e.createElement("p", {
      className: k.mobileHelperText
    }, _),
    InputProps: {
      inputComponent: De
    },
    inputProps: {
      className: k.cardNumberElement,
      onChange: function onChange(e) {
        "cardCvc" === e.elementType && (e.complete ? j("") : (e.error, j("Enter security code")));
      },
      options: {
        placeholder: ""
      }
    }
  })), e.createElement(h, {
    xs: 12,
    item: !0,
    className: k.buttonsContainerModal
  }, e.createElement(b, {
    className: k.cancelButtonModal,
    variant: "contained",
    size: "medium",
    onClick: function onClick() {
      return l(!1);
    }
  }, "Cancel"), e.createElement(b, {
    disabled: _,
    className: k.confirmButtonModal,
    variant: "contained",
    size: "medium",
    onClick: function onClick() {
      return ee();
    }
  }, W ? e.createElement(N, {
    size: 24,
    color: "inherit"
  }) : "Continue"))));
}

function sn(n) {
  var a = n.phone,
      r = n.setShowModal,
      l = n.handleContinue,
      o = n.getCustomerList,
      i = n.dumpsterPlacement,
      c = n.apolloURL,
      s = n.customerId,
      d = n.popUpClass,
      m = n.setPopUpClass,
      u = en(),
      p = $e(t(!1), 2),
      f = p[0],
      v = p[1],
      g = $e(t(""), 2),
      y = g[0],
      C = g[1],
      x = $e(t(!1), 2),
      E = x[0],
      w = x[1],
      k = $e(t(!1), 2),
      S = k[0],
      F = k[1],
      I = function () {
    var e = je(Be().mark(function e() {
      var t;
      return Be().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, F(!0), t = null == a ? void 0 : a.replace(/ /g, "").replace(/-/g, "").replace("(", "").replace(")", ""), e.next = 5, $t.generateCode(c, {
                customerId: s,
                phone: t
              });

            case 5:
              e.sent, m("verify"), w(!1), e.next = 14;
              break;

            case 10:
              e.prev = 10, e.t0 = e.catch(0), 1039 !== e.t0.response.data.code && 1044 !== e.t0.response.data.code || (w(!1), m("verifyFail")), 429 === e.t0.response.status && (w(!0), m("verifyFail"));

            case 14:
              return e.prev = 14, F(!1), e.finish(14);

            case 17:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 10, 14, 17]]);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }(),
      T = function () {
    var e = je(Be().mark(function e() {
      var t, n;
      return Be().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, e.next = 3, $t.validateCode(c, {
                customerId: s,
                code: y
              });

            case 3:
              n = e.sent, null !== (t = n.data) && void 0 !== t && t.hash ? (v(!1), localStorage.setItem("Customer", JSON.stringify({
                phone: a
              })), Mt.defaults.headers.common.hashcode = n.data.hash, o() && (r(!1), m("welcome"), l(i ? "panel1" : "panel2"))) : v(!0), e.next = 11;
              break;

            case 7:
              e.prev = 7, e.t0 = e.catch(0), console.log(e.t0), 1041 === e.t0.response.data.code && v(!0);

            case 11:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 7]]);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }(),
      D = function D() {
    r(!1), m("welcome"), l(i ? "panel1" : "panel2");
  };

  return e.createElement(h, {
    container: !0,
    className: u.popUp
  }, function () {
    switch (d) {
      case "welcome":
        return e.createElement(e.Fragment, null, e.createElement(h, {
          item: !0,
          xs: 12
        }, e.createElement("p", {
          className: u.descriptionFont
        }, "It looks like you've booked before. Continue as ", a, " to speed up your checkout.")), e.createElement(h, {
          xs: 12,
          item: !0,
          className: u.verifyButtons
        }, e.createElement(b, {
          disabled: S,
          className: u.confirmButtonModal,
          variant: "contained",
          size: "medium",
          onClick: I
        }, S ? e.createElement(N, {
          size: 24,
          color: "inherit"
        }) : e.createElement("b", null, "Continue as ", a)), e.createElement(b, {
          className: u.cancelButtonModal,
          variant: "contained",
          size: "medium",
          onClick: D
        }, "Continue as a guest")));

      case "verify":
        return e.createElement(h, {
          item: !0,
          xs: 12
        }, e.createElement("div", {
          className: u.verifyContainer
        }, e.createElement("p", {
          className: u.verifyFont
        }, "Enter the 6-digit verification code we just sent by text message."), e.createElement(Me, {
          length: 6,
          placeholder: "-",
          value: y,
          onChange: function onChange(e) {
            return C(e);
          }
        }), f && e.createElement("p", {
          className: u.mobileHelperText
        }, "This code is incorrect or it has expired. Please try again."), e.createElement(b, {
          disabled: (null == y ? void 0 : y.includes("-")) || (null == y ? void 0 : y.length) < 6,
          className: u.confirmButtonModal,
          style: {
            minWidth: "200px"
          },
          variant: "contained",
          size: "medium",
          onClick: T
        }, "Continue"), e.createElement("br", null), e.createElement("div", {
          className: u.verifyContainer
        }, e.createElement("p", {
          className: u.verifyFont
        }, "Didn't receive the code?"), e.createElement(b, {
          onClick: I,
          className: u.verifyAgain
        }, "Send code again"))));

      case "verifyFail":
        return e.createElement(e.Fragment, null, e.createElement(h, {
          item: !0,
          xs: 12
        }, e.createElement("div", {
          className: u.errorIconContainer
        }, e.createElement(Oe, {
          className: u.errorIcon
        }), e.createElement("p", {
          className: u.descriptionFont
        }, E ? "You've reached the limit on verification attempts." : "Our verification text message to your number was not delivered for some reason."))), e.createElement(h, {
          xs: 12,
          item: !0,
          className: u.verifyButtons
        }, e.createElement(b, {
          className: u.confirmButtonModal,
          variant: "contained",
          size: "medium",
          onClick: D
        }, "Continue as a guest")));

      case "expired":
        return e.createElement(e.Fragment, null, e.createElement(h, {
          item: !0,
          xs: 12
        }, e.createElement("p", {
          className: u.descriptionFont
        }, "The code you entered has expired.")), e.createElement(h, {
          xs: 12,
          item: !0,
          className: u.verifyButtons
        }, e.createElement(b, {
          className: u.confirmButtonModal,
          variant: "contained",
          size: "medium",
          onClick: I
        }, "Send a new code"), e.createElement(b, {
          className: u.cancelButtonModal,
          variant: "contained",
          size: "medium",
          onClick: D
        }, "Continue as a guest")));
    }
  }());
}

function dn(n) {
  var a = en(),
      r = n.modalCode,
      l = n.changeShowModal,
      o = n.showModal,
      i = n.setShowModal,
      c = {},
      s = n.stripeApiKey && Le(n.stripeApiKey),
      d = $e(t({
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      borderRadius: "10px",
      border: "none",
      backgroundColor: "#FFFFFF",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      padding: "0px 20px",
      minHeight: "fit-content !important",
      width: "500px"
    }
  }), 2),
      m = d[0];
  d[1];

  var u = function u() {
    i(!1), window.location.reload();
  },
      p = function p() {
    l(), n.setPopUpClass("welcome");
  };

  return e.createElement(Ae, {
    id: "online-booking-checkout",
    isOpen: o,
    style: m,
    contentLabel: "",
    shouldCloseOnOverlayClick: !1,
    preventScroll: !0,
    ariaHideApp: !1
  }, function () {
    switch (r) {
      case "security":
        var t,
            o,
            d,
            m,
            f = null === (t = n.customerList) || void 0 === t ? void 0 : t.find(function (e) {
          return e.id === n.selectedCard;
        });
        return e.createElement(e.Fragment, null, e.createElement("div", {
          className: "modal-header"
        }, e.createElement("p", {
          className: a.titleModal
        }, (null == f || null === (o = f.brand) || void 0 === o ? void 0 : o.charAt(0).toUpperCase()) + (null == f || null === (d = f.brand) || void 0 === d ? void 0 : d.slice(1)), " ...", null == f ? void 0 : f.last4), e.createElement("button", {
          type: "button",
          className: "close closermodal",
          onClick: l,
          "aria-label": "Close"
        }, e.createElement("span", {
          "aria-hidden": "true"
        }, "×"))), e.createElement("div", {
          className: "modal-container"
        }, e.createElement(h, {
          item: !0,
          xs: 12
        }, e.createElement("p", {
          className: a.descriptionFont
        }, "Please enter the 3- or 4-digit security code for this card.")), e.createElement(Pe, {
          stripe: s,
          options: c
        }, e.createElement(cn, {
          cardId: n.selectedCard,
          handleCheckoutFinishWithPayment: n.handleCheckoutFinishWithPayment,
          setShowModal: i,
          service: n.service,
          apolloURL: n.apolloURL,
          proId: n.proId,
          fromDate: n.fromDate,
          toDate: n.toDate,
          placeId: n.placeId,
          customerEmail: n.email,
          customerName: n.name,
          customerPhone: null === (m = n.mobilePhone) || void 0 === m ? void 0 : m.replace(/ /g, "").replace(/-/g, "").replace("(", "").replace(")", ""),
          customerSurname: n.lastname,
          count: n.count,
          setCount: n.setCount,
          removeCard: n.removeCard
        }))));

      case "goBack":
        return e.createElement(e.Fragment, null, e.createElement("div", {
          className: "modal-header"
        }, e.createElement("p", {
          className: a.titleModal
        }, "You're almost there!"), e.createElement("button", {
          type: "button",
          className: "close closermodal",
          onClick: l,
          "aria-label": "Close"
        }, e.createElement("span", {
          "aria-hidden": "true"
        }, "×"))), e.createElement("div", {
          className: "modal-container"
        }, e.createElement(h, {
          container: !0,
          className: a.popUp
        }, e.createElement(h, {
          item: !0,
          xs: 12
        }, e.createElement("p", {
          className: a.descriptionFont
        }, "You'll have to start over if you leave")), e.createElement(h, {
          xs: 12,
          item: !0,
          className: a.buttonsContainerModal
        }, e.createElement(b, {
          className: a.cancelButtonModal,
          variant: "contained",
          size: "medium",
          onClick: function onClick() {
            return n.handleBack({
              name: n.name,
              lastname: n.lastname,
              mobilePhone: n.mobilePhone,
              email: n.email,
              dumpsterPlacement: n.dumpsterPlacement,
              customerList: n.customerList,
              customerId: n.customerId
            });
          }
        }, "Leave anyway"), e.createElement(b, {
          className: a.confirmButtonModal,
          variant: "contained",
          size: "medium",
          onClick: function onClick() {
            return i(!1);
          }
        }, "Keep checking out")))));

      case "removeCard":
        return e.createElement(e.Fragment, null, e.createElement("div", {
          className: "modal-header"
        }, e.createElement("p", {
          className: a.titleModal
        }, "Delete this card?"), e.createElement("button", {
          type: "button",
          className: "close closermodal",
          onClick: l,
          "aria-label": "Close"
        }, e.createElement("span", {
          "aria-hidden": "true"
        }, "×"))), e.createElement("div", {
          className: "modal-container"
        }, e.createElement(h, {
          container: !0
        }, e.createElement(h, {
          xs: 12,
          item: !0,
          className: a.buttonsContainerModal
        }, e.createElement(b, {
          className: a.cancelButtonModal,
          variant: "contained",
          size: "medium",
          onClick: function onClick() {
            return i(!1);
          }
        }, "Cancel"), e.createElement(b, {
          className: a.confirmButtonModal,
          variant: "contained",
          size: "medium",
          onClick: function onClick() {
            return n.removeCard(n.cardToRemove);
          }
        }, "Continue")))));

      case "declinedCard":
        return e.createElement(e.Fragment, null, e.createElement("div", {
          className: "modal-header"
        }, e.createElement("p", {
          className: a.titleModal
        }, "Your card was declined."), e.createElement("button", {
          type: "button",
          className: "close closermodal",
          onClick: l,
          "aria-label": "Close"
        }, e.createElement("span", {
          "aria-hidden": "true"
        }, "×"))), e.createElement("div", {
          className: "modal-container"
        }, e.createElement(h, {
          container: !0,
          className: a.popUp
        }, e.createElement(h, {
          item: !0,
          xs: 12
        }, e.createElement("p", {
          className: a.descriptionFont
        }, "You can try a different card or contact the card issuer for more information.")), e.createElement(h, {
          xs: 12,
          item: !0,
          className: a.buttonsContainerModal
        }, e.createElement(b, {
          className: a.confirmButtonModal,
          variant: "contained",
          size: "medium",
          onClick: function onClick() {
            return i(!1);
          }
        }, "Ok")))));

      case "declinedPayment":
        return e.createElement(e.Fragment, null, e.createElement("div", {
          className: "modal-header"
        }, e.createElement("p", {
          className: a.titleModal
        }, "Something went wrong"), e.createElement("button", {
          type: "button",
          className: "close closermodal",
          onClick: l,
          "aria-label": "Close"
        }, e.createElement("span", {
          "aria-hidden": "true"
        }, "×"))), e.createElement("div", {
          className: "modal-container"
        }, e.createElement(h, {
          container: !0,
          className: a.popUp
        }, e.createElement("div", {
          className: a.errorIconContainer
        }, e.createElement(Oe, {
          className: a.errorIcon
        })), e.createElement(h, {
          item: !0,
          xs: 12
        }, e.createElement("p", {
          className: a.descriptionFont,
          style: {
            textAlign: "center"
          }
        }, "Please try again.")), e.createElement(h, {
          xs: 12,
          item: !0,
          className: a.buttonsContainerModal
        }, e.createElement(b, {
          className: a.confirmButtonModal,
          variant: "contained",
          size: "medium",
          onClick: function onClick() {
            return i(!1);
          }
        }, "Ok")))));

      case "verificationCode":
        return e.createElement(e.Fragment, null, e.createElement("div", {
          className: "modal-header"
        }, e.createElement("p", {
          className: a.titleModal
        }, function () {
          switch (n.popUpClass) {
            case "welcome":
              return "Welcome back!";

            case "verify":
              return "Verify its you";

            case "verifyFail":
              return "Verification failed";

            case "expired":
              return "Expired verification code";
          }
        }()), e.createElement("button", {
          type: "button",
          className: "close closermodal",
          onClick: p,
          "aria-label": "Close"
        }, e.createElement("span", {
          "aria-hidden": "true"
        }, "×"))), e.createElement("div", {
          className: "modal-container"
        }, e.createElement(sn, {
          phone: n.mobilePhone,
          setShowModal: i,
          handleContinue: n.handleChange,
          dumpsterPlacement: n.dumpsterPlacement,
          getCustomerList: n.getCustomerList,
          apolloURL: n.apolloURL,
          customerId: n.customerId,
          setPopUpClass: n.setPopUpClass,
          popUpClass: n.popUpClass
        })));

      case "pageOutOfDate":
        return e.createElement(e.Fragment, null, e.createElement("div", {
          className: "modal-header"
        }, e.createElement("p", {
          className: a.titleModal
        }, "This page is out of date"), e.createElement("button", {
          type: "button",
          className: "close closermodal",
          onClick: n.handleClose,
          "aria-label": "Close"
        }, e.createElement("span", {
          "aria-hidden": "true"
        }, "×"))), e.createElement("div", {
          className: "modal-container"
        }, e.createElement("div", {
          className: a.errorIconContainer
        }, e.createElement(Oe, {
          className: a.errorIcon
        })), e.createElement(h, {
          item: !0,
          xs: 12
        }, e.createElement("p", {
          className: a.descriptionFont
        }, "Please refresh this page to get the latest."), e.createElement("br", null), e.createElement("div", {
          className: a.verifyContainer
        }, e.createElement(b, {
          className: a.confirmButtonModal,
          variant: "contained",
          size: "medium",
          onClick: n.handleClose
        }, "Refresh")))));

      case "pageOutOfOrder":
        return e.createElement(e.Fragment, null, e.createElement("div", {
          className: "modal-header"
        }, e.createElement("p", {
          className: a.titleModal
        }, "Something went wrong"), e.createElement("button", {
          type: "button",
          className: "close closermodal",
          onClick: u,
          "aria-label": "Close"
        }, e.createElement("span", {
          "aria-hidden": "true"
        }, "×"))), e.createElement("div", {
          className: "modal-container"
        }, e.createElement("div", {
          className: a.errorIconContainer
        }, e.createElement(Oe, {
          className: a.errorIcon
        })), e.createElement(h, {
          item: !0,
          xs: 12
        }, e.createElement("p", {
          className: a.descriptionFont
        }, "Please reload the page."), e.createElement("br", null), e.createElement("div", {
          className: a.verifyContainer
        }, e.createElement(b, {
          className: a.confirmButtonModal,
          variant: "contained",
          size: "medium",
          onClick: u
        }, "Refresh")))));
    }
  }());
}

function mn(a) {
  var r,
      l,
      o = en(),
      i = a.isLoadingServices,
      c = a.proId,
      d = a.pi,
      m = a.placeId,
      u = a.stripeApiKey,
      p = a.staticUrl,
      f = a.proName,
      v = $e(e.useState(!(a.defaultDumpsterPlacement && a.defaultName && a.defaultLastname && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(a.defaultEmail) && 14 === (null === (r = a.defaultMobilePhone) || void 0 === r ? void 0 : r.length)) && (a.defaultName && a.defaultLastname && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(a.defaultEmail) && 14 === (null === (l = a.defaultMobilePhone) || void 0 === l ? void 0 : l.length) ? "panel2" : "panel1")), 2),
      g = v[0],
      C = v[1],
      x = $e(e.useState(a.defaultName), 2),
      E = x[0],
      w = x[1],
      k = $e(e.useState(a.defaultLastname), 2),
      S = k[0],
      I = k[1],
      L = $e(e.useState(a.defaultMobilePhone), 2),
      A = L[0],
      M = L[1],
      z = $e(e.useState(a.defaultEmail), 2),
      W = z[0],
      B = z[1],
      R = $e(e.useState(a.defaultDumpsterPlacement), 2),
      _ = R[0],
      j = R[1],
      V = $e(e.useState(""), 2),
      U = V[0],
      H = V[1],
      q = $e(e.useState(""), 2),
      $ = q[0],
      K = q[1],
      J = $e(e.useState(!1), 2),
      Y = J[0],
      G = J[1],
      Z = $e(e.useState(a.defaultCustomerList ? a.defaultCustomerList : []), 2),
      Q = Z[0],
      X = Z[1],
      ee = $e(e.useState(!(!a.defaultCustomerList || !a.defaultDumpsterPlacement)), 2),
      te = ee[0],
      ne = ee[1],
      ae = $e(e.useState(""), 2),
      re = ae[0],
      le = ae[1],
      oe = $e(e.useState(!1), 2),
      ie = oe[0],
      ce = oe[1],
      se = $e(e.useState(""), 2),
      de = se[0],
      me = se[1],
      ue = $e(e.useState(""), 2),
      pe = ue[0],
      fe = ue[1],
      ve = $e(e.useState(3), 2),
      he = ve[0],
      Ce = ve[1],
      Se = $e(e.useState(!!a.defaultDumpsterPlacement), 2),
      Fe = Se[0],
      Ie = Se[1],
      Te = $e(e.useState(a.defaultCustomerId ? a.defaultCustomerId : ""), 2),
      De = Te[0],
      Pe = Te[1],
      Le = $e(t("welcome"), 2),
      Ae = Le[0],
      Oe = Le[1],
      Me = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
      ze = function ze(e) {
    e && me(e), ce(!ie);
  };

  n(function () {
    window.scrollTo(0, 0);
  }, []);

  var We = function We(e) {
    var t = g !== e;
    "panel1" === e ? C(!!t && e) : "panel2" === e ? E && S && Me.test(W) && 14 === (null == A ? void 0 : A.length) ? (E || S || Me.test(W) || null == A || A.length, C(!!t && e)) : C("panel1") : "panel3" === e && (E && S && Me.test(W) && 14 === (null == A ? void 0 : A.length) ? C(_ ? !!t && e : "panel2") : C("panel1"));
  },
      Re = function () {
    var e = je(Be().mark(function e() {
      var t, n, r, l, o;
      return Be().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, r = null == A ? void 0 : A.replace(/ /g, "").replace(/-/g, "").replace("(", "").replace(")", ""), e.next = 4, $t.checkCustomer(a.apolloURL, r);

            case 4:
              return l = e.sent, null !== (t = l.data) && void 0 !== t && t.customerFound ? Pe(null === (o = l.data) || void 0 === o ? void 0 : o.customerId) : (Pe(""), X([])), e.abrupt("return", null === (n = l.data) || void 0 === n ? void 0 : n.customerFound);

            case 9:
              e.prev = 9, e.t0 = e.catch(0), console.log(e.t0);

            case 12:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 9]]);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }(),
      _e = function () {
    var e = je(Be().mark(function e() {
      var t, n, r;
      return Be().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, e.next = 3, $t.getCustomerList(a.apolloURL, De);

            case 3:
              if (n = e.sent, null === (t = n.data) || void 0 === t || !t.customerFound) {
                e.next = 11;
                break;
              }

              return r = n.data.paymentMethods.map(function (e) {
                return {
                  id: e.paymentMethodId,
                  brand: e.brand,
                  last4: e.last4,
                  expiration: "".concat(e.expirationMonth / 10 > 1 ? e.expirationMonth : "0" + e.expirationMonth, "/").concat(e.expirationYear),
                  attachedMethod: !0
                };
              }), X(r), (null == r ? void 0 : r.length) > 0 ? le(r[0].id) : le(""), e.abrupt("return", !0);

            case 11:
              X([]), le("");

            case 13:
              e.next = 18;
              break;

            case 15:
              e.prev = 15, e.t0 = e.catch(0), 1042 === e.t0.response.data.code && (X([]), le(""), delete Mt.defaults.headers.common.hashcode, Oe("expired"), ze("verificationCode"), ce(!0));

            case 18:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 15]]);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }(),
      Ve = function Ve(e) {
    var t = "".concat(p.split("assets")[0], "images/icons/payment-cards/generic.png");

    switch (e) {
      case "visa":
        t = "".concat(p.split("assets")[0], "images/icons/payment-cards/visa.png");
        break;

      case "mastercard":
        t = "".concat(p.split("assets")[0], "images/icons/payment-cards/master.png");
        break;

      case "amex":
        t = "".concat(p.split("assets")[0], "images/icons/payment-cards/american.png");
        break;

      case "discover":
        t = "".concat(p.split("assets")[0], "images/icons/payment-cards/discover.png");
    }

    return t;
  },
      Ue = function () {
    var e = je(Be().mark(function e(t, n) {
      var r, l, o, i;
      return Be().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              if (e.prev = 0, !(l = null == Q || null === (r = Q.find(function (e) {
                return e.id === t;
              })) || void 0 === r ? void 0 : r.attachedMethod)) {
                e.next = 9;
                break;
              }

              return e.next = 5, qt.deleteCard(a.apolloURL, {
                methodId: t,
                customerId: De
              });

            case 5:
              e.sent.data && (o = Q.filter(function (e) {
                return e.id !== t;
              }), X(o), re === t && le("")), e.next = 10;
              break;

            case 9:
              !1 === l && (i = Q.filter(function (e) {
                return e.id !== t;
              }), X(i), re === t && le(""));

            case 10:
              n || ce(!1), e.next = 17;
              break;

            case 13:
              e.prev = 13, e.t0 = e.catch(0), console.log(e.t0), 1042 === e.t0.response.data.code && (X([]), le(""), delete Mt.defaults.headers.common.hashcode, Oe("expired"), ze("verificationCode"), ce(!0));

            case 17:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 13]]);
    }));
    return function (t, n) {
      return e.apply(this, arguments);
    };
  }(),
      He = function () {
    var e = je(Be().mark(function e(t) {
      var n;
      return Be().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, G(!0), ce(!1), e.next = 5, qt.completeCheckout(a.apolloURL, {
                jobData: {
                  customerId: t.customerId,
                  customerEmail: W,
                  addressData: {
                    address: a.addressData.street,
                    address2: a.addressData.street2,
                    address_id: a.addressData.place_id,
                    city: a.addressData.locality,
                    instructions: _,
                    state: a.addressData.state,
                    zip: a.addressData.postal_code,
                    place: m
                  },
                  placeId: m,
                  proId: c,
                  proName: f,
                  phone: null == A ? void 0 : A.replace(/ /g, "").replace(/-/g, "").replace("(", "").replace(")", ""),
                  startDate: a.fromDate,
                  endDate: a.toDate,
                  serviceId: a.service._id,
                  debrisValue: Array.isArray(a.selectedWasteType) ? a.selectedWasteType[0] : a.selectedWasteType,
                  debrisLabel: a.selectedWasteTypeLabel
                },
                paymentId: t.paymentId,
                intentId: t.pi
              });

            case 5:
              (n = e.sent).data && a.handleContinue(n.data.jobRequestId), e.next = 15;
              break;

            case 9:
              e.prev = 9, e.t0 = e.catch(0), console.log(e.t0), G(!1), ze("declinedPayment"), ce(!0);

            case 15:
              return e.prev = 15, G(!1), e.finish(15);

            case 18:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 9, 15, 18]]);
    }));
    return function (t) {
      return e.apply(this, arguments);
    };
  }(),
      qe = function () {
    var e = je(Be().mark(function e() {
      var t, n;
      return Be().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, G(!0), e.next = 4, qt.addFullCheckout(a.apolloURL, {
                jobData: {
                  addressData: {
                    address: a.addressData.street,
                    address2: a.addressData.street2,
                    address_id: a.addressData.place_id,
                    city: a.addressData.locality,
                    instructions: _,
                    state: a.addressData.state,
                    zip: a.addressData.postal_code,
                    place: m
                  },
                  placeId: m,
                  proId: c,
                  proName: f,
                  phone: null == A ? void 0 : A.replace(/ /g, "").replace(/-/g, "").replace("(", "").replace(")", ""),
                  startDate: a.fromDate,
                  endDate: a.toDate,
                  serviceId: a.service._id,
                  debrisValue: Array.isArray(a.selectedWasteType) ? a.selectedWasteType[0] : a.selectedWasteType,
                  debrisLabel: a.selectedWasteTypeLabel
                },
                customerData: {
                  customerEmail: W,
                  customerName: E,
                  customerSurname: S,
                  customerPhone: null == A ? void 0 : A.replace(/ /g, "").replace(/-/g, "").replace("(", "").replace(")", "")
                },
                methodData: {
                  methodId: re,
                  attachedMethod: null === (t = Q.find(function (e) {
                    return e.id === re;
                  })) || void 0 === t ? void 0 : t.attachedMethod
                }
              });

            case 4:
              (n = e.sent).data && a.handleContinue(n.data.jobRequestId), e.next = 12;
              break;

            case 8:
              e.prev = 8, e.t0 = e.catch(0), G(!1), 422 === e.t0.response.status && 2005 === e.t0.response.data.code ? (ze("declinedCard"), ce(!0)) : (ze("declinedPayment"), ce(!0));

            case 12:
              return e.prev = 12, G(!1), e.finish(12);

            case 15:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 8, 12, 15]]);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }();

  return e.createElement(e.Fragment, null, e.createElement(h, {
    spacing: 4,
    container: !0,
    direction: "row"
  }, i ? e.createElement(F, {
    className: o.backdrop,
    open: !0
  }, e.createElement(N, {
    className: o.white
  })) : e.createElement(e.Fragment, null, e.createElement("div", {
    className: o.headerContainerColor
  }, e.createElement(O, {
    className: o.backButtonColor,
    onClick: function onClick() {
      return ze("goBack");
    }
  }, e.createElement(ge, null)), e.createElement("p", {
    className: o.fontHeaderColor
  }, "Checkout")), e.createElement(dn, {
    modalCode: de,
    changeShowModal: ze,
    showModal: ie,
    stripeApiKey: u,
    selectedCard: re,
    handleCheckoutFinishWithPayment: He,
    setShowModal: ce,
    service: a.service,
    apolloURL: a.apolloURL,
    proId: c,
    fromDate: a.fromDate,
    toDate: a.toDate,
    placeId: m,
    email: W,
    name: E,
    mobilePhone: A,
    lastname: S,
    count: he,
    setCount: Ce,
    removeCard: Ue,
    handleBack: a.handleBack,
    dumpsterPlacement: _,
    customerList: Q,
    cardToRemove: pe,
    handleChange: We,
    getCustomerList: _e,
    customerId: De,
    setPopUpClass: Oe,
    popUpClass: Ae
  }), e.createElement(h, {
    item: !0,
    className: o.detailContainer
  }, e.createElement(T, {
    expanded: "panel1" === g,
    className: o.accordionContainer
  }, e.createElement(D, {
    "aria-controls": "panel1bh-content",
    id: "panel1bh-header",
    className: o.accordionSummary
  }, e.createElement(h, {
    container: !0,
    justifyContent: "space-between"
  }, e.createElement(y, {
    className: "".concat(o.descriptionFont, " ").concat(o.titleCheckoutFont)
  }, "1. Contact"), E && S && Me.test(W) && 14 === (null == A ? void 0 : A.length) && "panel1" !== g ? e.createElement(Ee, {
    className: o.checkedIcon
  }) : e.createElement(xe, null)), E && S && Me.test(W) && 14 === (null == A ? void 0 : A.length) && "panel1" !== g && e.createElement(e.Fragment, null, e.createElement("br", null), e.createElement("div", {
    className: o.contactSummaryContainer
  }, e.createElement("div", {
    className: o.contactSummary
  }, e.createElement("p", {
    className: o.contactText
  }, E, " ", S), e.createElement("p", {
    className: o.contactText
  }, A), e.createElement("p", {
    className: o.contactText
  }, W)), e.createElement("div", null, e.createElement("button", {
    onClick: function onClick() {
      return We("panel1");
    },
    className: o.editButton
  }, "Edit"))))), e.createElement(P, null, e.createElement(an, {
    handleFirstNameChange: function handleFirstNameChange(e) {
      w(e.target.value);
    },
    handleLastnameChange: function handleLastnameChange(e) {
      I(e.target.value);
    },
    handleMobilePhoneChange: function handleMobilePhoneChange(e) {
      var t = "",
          n = e.target.value.replace(/[^0-9]/g, "");
      "1" === n[0] && (n = "");
      var a = n.substr(0, 3),
          r = n.substr(3, 3),
          l = n.substr(6, 4);
      0 === a.length ? t = "" : a.length < 3 ? t = "(" + a : 3 == a.length && r.length < 3 ? t = "(" + a + ") " + r : 3 == a.length && 3 == r.length && (t = "(" + a + ") " + r + "-" + l), M(t), 0 === t.length ? H("Please enter your mobile phone number") : 14 !== t.length ? H("Enter a 10 digit number starting with the area code") : H("");
    },
    handleEmailChange: function handleEmailChange(e) {
      B(e.target.value), Me.test(e.target.value) ? K("") : K("Enter a valid email");
    },
    name: E,
    lastname: S,
    mobilePhone: A,
    email: W,
    error: U,
    dumpsterPlacement: _,
    emailError: $,
    handleContinue: We,
    getCustomerList: _e,
    getCustomer: Re,
    changeShowModal: ze,
    setCustomerList: X,
    setSelectedCard: le
  }))), e.createElement(T, {
    expanded: "panel2" === g,
    className: o.accordionContainer
  }, e.createElement(D, {
    "aria-controls": "panel2bh-content",
    id: "panel2bh-header",
    className: o.accordionSummary
  }, e.createElement(h, {
    container: !0,
    justifyContent: "space-between"
  }, e.createElement(y, {
    className: "".concat(o.descriptionFont, " ").concat(o.titleCheckoutFont)
  }, "2. Delivery instructions"), _ && "panel2" !== g ? e.createElement(Ee, {
    className: o.checkedIcon
  }) : e.createElement(xe, null)), _ && "panel2" !== g && e.createElement(e.Fragment, null, e.createElement("br", null), e.createElement("div", {
    className: o.contactSummaryContainer
  }, e.createElement("div", {
    className: o.contactSummary
  }, e.createElement("p", {
    className: o.contactText
  }, (null == _ ? void 0 : _.length) > 100 ? (null == _ ? void 0 : _.substring(0, 100)) + "..." : _)), e.createElement("div", null, e.createElement("button", {
    onClick: function onClick() {
      return We("panel2");
    },
    className: o.editButton
  }, "Edit"))))), e.createElement(P, null, e.createElement(rn, {
    deliveryDate: a.fromDate,
    handleDumpsterPlacementChange: function handleDumpsterPlacementChange(e) {
      j(e.target.value);
    },
    dumpsterPlacement: _,
    handleContinue: We,
    setIsShowingCards: ne,
    customerList: Q,
    setIsContinuePress: Ie
  }))), e.createElement(T, {
    expanded: "panel3" === g,
    className: o.accordionContainer
  }, e.createElement(D, {
    "aria-controls": "panel3bh-content",
    id: "panel3bh-header",
    className: o.accordionSummary
  }, e.createElement(h, {
    container: !0,
    justifyContent: "space-between"
  }, e.createElement(y, {
    className: "".concat(o.descriptionFont, " ").concat(o.titleCheckoutFont)
  }, "3. Debit or credit card"), E && S && _ && Me.test(W) && 14 === (null == A ? void 0 : A.length) && re && te && "panel3" !== g ? e.createElement(Ee, {
    className: o.checkedIcon
  }) : e.createElement(xe, null)), E && S && _ && Me.test(W) && 14 === (null == A ? void 0 : A.length) && te && e.createElement(e.Fragment, null, e.createElement("br", null), Q.length > 0 && Q.map(function (t, n) {
    return e.createElement("div", {
      key: t.id,
      className: "".concat(o.contactSummaryContainer, " ").concat(o.alignCard)
    }, e.createElement("div", {
      className: o.cardInfo,
      onClick: function onClick() {
        return le(t.id);
      }
    }, e.createElement(s, {
      className: o.checkboxContainer,
      icon: e.createElement(Ne, null),
      checkedIcon: e.createElement(we, {
        className: o.checkedButton
      }),
      defaultChecked: !1,
      checked: re === t.id
    }), e.createElement("img", {
      src: Ve(t.brand),
      className: o.cardIcon,
      alt: "card".concat(n)
    }), " ", e.createElement("div", {
      className: o.contactSummaryCard
    }, e.createElement("p", {
      className: o.contactText
    }, "Card ...", t.last4), e.createElement("p", {
      className: o.contactText
    }, "Expires ", t.expiration))), e.createElement("div", null, e.createElement(ke, {
      className: o.removeCard,
      color: "secondary",
      onClick: function onClick() {
        fe(t.id), ze("removeCard");
      }
    })));
  }), e.createElement("br", null), e.createElement("div", {
    className: o.addCardContainer
  }, e.createElement(b, {
    startIcon: e.createElement(be, null),
    onClick: function onClick() {
      ne(!1), We("panel3");
    },
    className: o.addCard
  }, "Add a new card")))), e.createElement(P, null, e.createElement("div", {
    className: o.paymentFormContainer
  }, "panel3" === g && e.createElement(on, {
    googlePlaceAutocompleteApiKey: a.googlePlaceAutocompleteApiKey,
    pi: d,
    customerName: E,
    customerLastname: S,
    customerEmail: W,
    customerPhone: null == A ? void 0 : A.replace(/ /g, "").replace(/-/g, "").replace("(", "").replace(")", ""),
    apolloURL: a.apolloURL,
    defaultAddress: a.addressData,
    stripeApiKey: u,
    handleContinue: We,
    setIsShowingCards: ne,
    addCustomerList: function addCustomerList(e) {
      if (e) {
        var t = Q;
        t.unshift(e), X(t), le(e.id);
      }
    }
  }))))), e.createElement(h, {
    item: !0,
    className: o.pricingContainer
  }, e.createElement(h, {
    container: !0,
    spacing: 2
  }, e.createElement(h, {
    xs: 12,
    item: !0
  }, e.createElement(h, {
    container: !0,
    alignItems: "center"
  }, e.createElement(ye, {
    className: o.marginRightSmall
  }), e.createElement(y, {
    variant: "subtitle1",
    className: o.descriptionFont
  }, "Secure checkout"))), e.createElement(h, {
    xs: 12,
    item: !0
  }, e.createElement(tn, {
    startDate: a.fromDate,
    endDate: a.toDate,
    placeId: m,
    proId: c,
    additionalPeriodsAmount: a.getAditionalPeriodsAmount(),
    extraPeriodCost: a.service.details[1].extraPeriodCost,
    serviceId: a.service._id,
    apolloURL: a.apolloURL,
    serviceDescription: a.serviceDescription
  })), e.createElement(h, {
    xs: 12,
    item: !0
  }, e.createElement(b, {
    onClick: function onClick() {
      var e;
      return null != Q && null !== (e = Q.find(function (e) {
        return e.id === re;
      })) && void 0 !== e && e.attachedMethod ? ze("security") : qe();
    },
    className: o.accentBookableColor,
    size: "large",
    variant: "contained",
    fullWidth: !0,
    disabled: !E || !S || !Me.test(W) || 14 !== (null == A ? void 0 : A.length) || !_ || !re || !Fe || Y
  }, Y ? e.createElement(N, {
    size: 24,
    color: "inherit"
  }) : e.createElement("b", null, "Place your order"))))))));
}

function un(a) {
  var r,
      l,
      o = en(),
      i = a.bookingId,
      c = a.proId,
      s = a.proName,
      d = a.proPhone,
      m = a.apolloURL,
      u = a.imageStaticEnv,
      p = a.backUrl,
      f = a.isError,
      v = a.bookingRequest,
      g = a.gatsbyKey,
      C = $e(t(null), 2),
      x = C[0],
      E = C[1],
      b = $e(t(null), 2),
      w = b[0],
      k = b[1],
      F = $e(t(!0), 2),
      I = F[0],
      T = F[1],
      D = $e(t(null), 2),
      P = D[0],
      L = D[1],
      A = $e(t(null), 2),
      O = A[0],
      M = A[1],
      z = $e(t(f || !1), 2),
      W = z[0],
      B = z[1];
  n(function () {
    je(Be().mark(function e() {
      var t, n, a, r;
      return Be().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, window.scrollTo(0, 0), T(!0), e.next = 5, Kt.getWasteTreatmentByPro(m, g, c);

            case 5:
              if (t = e.sent, k(t.data), !v || !v.jobRequestInvitations) {
                e.next = 15;
                break;
              }

              E(v), n = new Date(new Date(v.startDate).toISOString().slice(0, -1)), L(n), n = new Date(new Date(v.endDate).toISOString().slice(0, -1)), M(n), e.next = 23;
              break;

            case 15:
              return e.next = 17, R();

            case 17:
              a = e.sent, E(a[0]), r = new Date(new Date(a[0].startDate).toISOString().slice(0, -1)), L(r), r = new Date(new Date(a[0].endDate).toISOString().slice(0, -1)), M(r);

            case 23:
              e.next = 28;
              break;

            case 25:
              e.prev = 25, e.t0 = e.catch(0), console.log(e.t0);

            case 28:
              return e.prev = 28, T(!1), e.finish(28);

            case 31:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 25, 28, 31]]);
    }))();
  }, []);

  var R = function () {
    var e = je(Be().mark(function e() {
      var t;
      return Be().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, e.next = 3, Kt.getBookingById(m, i);

            case 3:
              return t = e.sent, e.abrupt("return", t.data);

            case 7:
              throw e.prev = 7, e.t0 = e.catch(0), B(!0), e.t0;

            case 11:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 7]]);
    }));
    return function () {
      return e.apply(this, arguments);
    };
  }(),
      _ = function _() {
    var e;
    return w && (null === (e = w.disallowedWaste) || void 0 === e ? void 0 : e.length) > 0;
  },
      j = function j() {
    var e,
        t = (null == w || null === (e = w.wasteInstructions) || void 0 === e ? void 0 : e.filter(function (e) {
      return e.id == x.debrisValue;
    })) || [];
    return t.length > 0 ? "Instructions: ".concat(t[0].instructions) : null;
  };

  return e.createElement(e.Fragment, null, I ? e.createElement(N, {
    size: 35,
    className: o.loader
  }) : e.createElement(e.Fragment, null, e.createElement(dn, {
    modalCode: "pageOutOfOrder",
    showModal: W,
    setShowModal: B
  }), x && e.createElement(h, {
    container: !0,
    className: o.orderConfirmationContainer
  }, (null === (r = x.payment) || void 0 === r ? void 0 : r.length) > 0 && (null === (l = x.payment[0].total) || void 0 === l ? void 0 : l.totalRefunds) && e.createElement("div", {
    className: o.fullWidth
  }, e.createElement("span", {
    className: o.failedContainer
  }, "A refund of $", x.payment[0].total.totalRefunds.toFixed(2), " has been applied to this booking.")), e.createElement(h, {
    item: !0,
    className: o.firstOrderColumn
  }, e.createElement(y, {
    className: o.fontHeaderConfirmation
  }, function () {
    var e,
        t = "";

    switch (x.jobRequestInvitations[0].status) {
      case "Delivered":
        t = "Your request was sent.";
        break;

      case "Accepted":
        t = (null === (e = x.payment) || void 0 === e ? void 0 : e.length) > 0 && "refunded" === x.payment[0].status ? "Your dumpster was canceled." : "Your dumpster is confirmed.";
        break;

      case "Declined":
      case "Expired":
        t = "Your booking was declined by ".concat(s);
    }

    return t;
  }()), e.createElement(y, {
    className: o.fontSubTitleConfirmation
  }, function () {
    var e,
        t = "";

    switch (x.jobRequestInvitations[0].status) {
      case "Delivered":
        t = "Please allow the service pro up to 3 business hours to confirm the booking. You wont be charged until your booking is confirmed.";
        break;

      case "Accepted":
        t = (null === (e = x.payment) || void 0 === e ? void 0 : e.length) > 0 && "refunded" === x.payment[0].status ? "Your card was fully refunded." : "".concat(s, " will deliver your dumpster!");
        break;

      case "Declined":
      case "Expired":
        t = "Unfortunately, your selected service provider is not available to deliver your dumpster. We're sorry for the inconvenience. You have not been charged.";
    }

    return t;
  }()), e.createElement("img", {
    src: u + x.service[0].image,
    className: o.imageConfirmation
  }), e.createElement(y, {
    className: o.boldFontConfirmation
  }, x.service[0].description), e.createElement(y, {
    className: "".concat(o.fontSubTitleConfirmation, " ").concat(o.marginPhone)
  }, e.createElement("a", {
    href: p,
    target: "_blank",
    inline: !0,
    className: o.proLink
  }, s)), "Accepted" === x.jobRequestInvitations[0].status && e.createElement("a", {
    inline: !0,
    style: {
      fontSize: "2.3rem"
    },
    className: "".concat(o.boldFontConfirmation, " ").concat(o.proLink),
    align: "right",
    href: "tel://" + d
  }, d), e.createElement(S, {
    className: o.dividerConfirmation,
    variant: "middle"
  }), e.createElement(h, {
    container: !0,
    direction: "column",
    className: o.fontDatesConfirmation
  }, e.createElement(h, {
    item: !0
  }, e.createElement(y, {
    className: o.boldFontConfirmation
  }, "Delivery"), e.createElement(y, {
    className: o.fontSubTitleConfirmation
  }, P.toLocaleDateString("en-EN", {
    weekday: "long"
  }), ", ", P.toLocaleString("en-EN", {
    month: "long"
  }), " ", P.getDate(), ", ", P.getFullYear())), e.createElement(h, {
    item: !0
  }, e.createElement(y, {
    className: o.boldFontConfirmation
  }, "Removal"), e.createElement(y, {
    className: o.fontSubTitleConfirmation
  }, O.toLocaleDateString("en-EN", {
    weekday: "long"
  }), ", ", O.toLocaleString("en-EN", {
    month: "long"
  }), " ", O.getDate(), ", ", O.getFullYear())), e.createElement(h, {
    item: !0
  }, e.createElement(y, {
    className: "".concat(o.boldFontConfirmation)
  }, "Address"), e.createElement(y, {
    className: o.fontSubTitleConfirmation
  }, x.address.address, " ", x.address.address2), x.address.instructions && e.createElement(y, {
    className: o.fontSubTitleConfirmation
  }, "Instructions: ", x.address.instructions))), e.createElement(S, {
    className: o.dividerConfirmation,
    variant: "middle"
  })), e.createElement(h, {
    item: !0,
    className: o.thirdOrderColumn
  }, e.createElement(h, {
    container: !0
  }, e.createElement(y, {
    inline: !0,
    className: o.boldFontConfirmation,
    align: "left"
  }, "Amount")), e.createElement(y, {
    className: o.fontSubTitleConfirmation
  }, "$", x.payment[0].total.gross.toFixed(2)), e.createElement(y, {
    className: o.fontSubTitleConfirmation
  }, x.service[0].details[0].details.replace(". <br>", ",")), e.createElement(y, {
    className: o.fontSubTitleConfirmation
  }, x.service[0].details[1].details.replace(". <br>", ",")), "Accepted" === x.jobRequestInvitations[0].status && e.createElement(h, {
    item: !0
  }, e.createElement(S, {
    className: o.dividerConfirmation,
    variant: "middle"
  }), e.createElement(y, {
    className: "".concat(o.boldFontConfirmation)
  }, "Customer Support"), e.createElement(y, {
    className: o.fontSubTitleConfirmation
  }, "Contact your service provider directly for support."), e.createElement(y, {
    className: "".concat(o.fontSubTitleConfirmation, " ").concat(o.marginPhone)
  }, e.createElement("a", {
    href: p,
    target: "_blank",
    inline: !0,
    className: o.proLink
  }, s)), e.createElement("a", {
    inline: !0,
    style: {
      fontSize: "2.3rem"
    },
    className: "".concat(o.boldFontConfirmation, " ").concat(o.proLink),
    align: "right",
    href: "tel://" + d
  }, d)), e.createElement(S, {
    className: o.dividerConfirmation,
    variant: "middle"
  }), e.createElement(y, {
    className: "".concat(o.boldFontConfirmation)
  }, "Waste Type"), e.createElement(y, {
    className: o.fontSubTitleConfirmation
  }, x.debrisLabel), e.createElement(y, {
    className: o.fontSubTitleConfirmation
  }, j() && j()), _() && e.createElement(e.Fragment, null, e.createElement(S, {
    className: o.dividerConfirmation,
    variant: "middle"
  }), e.createElement(y, {
    className: "".concat(o.boldFontConfirmation)
  }, "Disallowed Waste"), e.createElement(y, {
    className: "".concat(o.fontSubTitleConfirmation)
  }, "The following items are not allowed in the dumpster."), e.createElement("br", null), e.createElement(y, {
    className: o.fontSubTitleConfirmation
  }, _() ? w.disallowedWaste.map(function (t) {
    return e.createElement("span", {
      key: t.id
    }, t.name, e.createElement("br", null));
  }) : void 0), " ")))));
}

function pn(a) {
  var r = $e(e.useState(!1), 2),
      l = r[0],
      o = r[1],
      i = $e(e.useState(null), 2),
      c = i[0],
      s = i[1],
      d = $e(e.useState(null), 2),
      m = d[0],
      u = d[1],
      p = en(),
      f = a.initialData.find(function (e) {
    return "wasteType" === e.key;
  }).value,
      v = a.initialData.find(function (e) {
    return "service" === e.key;
  }).value,
      g = a.initialData.find(function (e) {
    return "fullFormData" === e.key;
  }).value,
      h = a.initialData.find(function (e) {
    return "placeId" === e.key;
  }).value,
      y = $e(t(), 2),
      C = y[0],
      x = y[1],
      E = $e(t(!0), 2),
      b = E[0],
      w = E[1],
      k = $e(t(!0), 2),
      S = k[0],
      F = k[1],
      I = $e(t(null), 2),
      T = I[0],
      D = I[1],
      P = $e(t(!1), 2),
      L = P[0],
      A = P[1],
      O = $e(t(""), 2),
      M = O[0],
      z = O[1];
  n(function () {
    je(Be().mark(function e() {
      var t, n;
      return Be().wrap(function (e) {
        for (;;) {
          switch (e.prev = e.next) {
            case 0:
              return e.prev = 0, w(!0), e.next = 4, Ut.getServiceById(a.apolloURL, a.proId, v.id);

            case 4:
              t = e.sent, x(t.data), localStorage.removeItem("Customer"), delete Mt.defaults.headers.common.hashcode, e.next = 13;
              break;

            case 10:
              e.prev = 10, e.t0 = e.catch(0), 404 === (null === (n = e.t0.response) || void 0 === n ? void 0 : n.status) ? (z("pageOutOfDate"), A(!0)) : (z("pageOutOfOrder"), A(!0));

            case 13:
              return e.prev = 13, w(!1), e.finish(13);

            case 16:
            case "end":
              return e.stop();
          }
        }
      }, e, null, [[0, 10, 13, 16]]);
    }))();
  }, []);
  return b ? e.createElement(N, {
    size: 35,
    className: p.loader
  }) : e.createElement(e.Fragment, null, e.createElement(dn, {
    handleClose: function handleClose() {
      if (A(!1), a.handleBack) {
        var e = null != c && c.selectedWasteType ? null == c ? void 0 : c.selectedWasteType : f;
        a.handleBack([{
          key: "wasteType",
          value: e && (Array.isArray(e) ? e[0] : e)
        }, {
          key: "fullFormData",
          value: null != c && c.googlePlace ? null == c ? void 0 : c.googlePlace : g
        }]);
      }
    },
    modalCode: M,
    showModal: L,
    setShowModal: A
  }), S ? l ? e.createElement(mn, {
    selectedWasteType: null == c ? void 0 : c.selectedWasteType,
    selectedWasteTypeLabel: null == c ? void 0 : c.selectedWasteTypeLabel,
    addressData: null == c ? void 0 : c.addressData,
    service: C,
    fromDate: null == c ? void 0 : c.deliveryDates[0],
    toDate: null == c ? void 0 : c.deliveryDates[1],
    googlePlaceAutocompleteApiKey: a.googlePlaceAutocompleteApiKey,
    apolloURL: a.apolloURL,
    proId: a.proId,
    proName: a.proName,
    handleBack: function handleBack(e) {
      u(e), o(!1);
    },
    placeId: h,
    defaultName: null == m ? void 0 : m.name,
    defaultLastname: null == m ? void 0 : m.lastname,
    defaultMobilePhone: null == m ? void 0 : m.mobilePhone,
    defaultEmail: null == m ? void 0 : m.email,
    defaultDumpsterPlacement: null == m ? void 0 : m.dumpsterPlacement,
    defaultCustomerList: null == m ? void 0 : m.customerList,
    defaultCustomerId: null == m ? void 0 : m.customerId,
    handleContinue: function handleContinue(e) {
      window.history.replaceState(null, "", "/order?j=".concat(e)), D(e), F(!1);
    },
    stripeApiKey: a.stripeApiKey,
    getAditionalPeriodsAmount: null == c ? void 0 : c.getAditionalPeriodsAmount,
    serviceDescription: null == c ? void 0 : c.serviceDescription,
    staticUrl: a.staticUrl
  }) : C && e.createElement(nn, {
    proName: a.proName,
    deliveryDates: null == c ? void 0 : c.deliveryDates,
    selectedWasteType: null != c && c.selectedWasteType ? null == c ? void 0 : c.selectedWasteType : f,
    googlePlace: null != c && c.googlePlace ? null == c ? void 0 : c.googlePlace : g,
    staticUrl: a.staticUrl,
    googlePlaceAutocompleteApiKey: a.googlePlaceAutocompleteApiKey,
    apolloURL: a.apolloURL,
    service: C,
    placeId: h,
    handleCheckoutClick: function handleCheckoutClick(e) {
      e.addressData = Object.fromEntries(JSON.parse(e.googlePlace)), s(e), o(!0);
    },
    connectedAcountId: a.connectedAcountId,
    proId: a.proId,
    handleBack: a.handleBack,
    setModalCode: z,
    setShowModal: A,
    maxDatePicker: a.maxDatePicker ? a.maxDatePicker : 7776e6
  }) : e.createElement(un, {
    proId: a.proId,
    apolloURL: a.apolloURL,
    proName: a.proName,
    proPhone: a.proPhone,
    bookingId: T,
    imageStaticEnv: a.staticUrl,
    backUrl: a.backUrl,
    gatsbyKey: a.gatsbyKey
  }));
}

export { Tt as Ondeff, pn as OnlineBooking, un as OrderConfirmation, Qt as ServiceSeeker, Xt as createSteplessValidationSchema, bt as createValidationSchema };